(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-directory"] && !Shopify.designMode) return;
  try {
    
/* ===================================================================
   FAQ DIRECTORY
   -------------------------------------------------------------------
   Search, category filtering, deep links and copy-link, for every
   [data-fq-root] on the page.

   MATCHING
   Folded, not normalised. Every substitution maps one character to one
   character (dashes to "-", curly quotes to straight, non-breaking
   space to space) so an index into the folded string is also a valid
   index into the original. That is what lets the highlighter mark the
   raw text without re-deriving offsets. Dropping characters -- say,
   stripping the trademark sign -- would break that, and is not needed:
   matching is per token with AND semantics, so "pristine carbon" still
   finds "Pristine(tm) carbon fiber shafts".

   HIGHLIGHTING
   Runs over text nodes only, via a TreeWalker, so the links inside an
   answer survive. Each render restores the original HTML first rather
   than trying to unwrap marks.

   AUTO-OPEN
   Results stay collapsed unless there are few enough of them to be
   worth opening outright -- the threshold comes from the section
   setting. Typing two characters and getting fifteen open answers is
   the endless scroll this section replaced.
   =================================================================== */

(function () {
  'use strict';

  if (window.PgcFaqDirectory) return;
  window.PgcFaqDirectory = true;

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MIN_QUERY = 2;

  function fold(str) {
    return (str || '')
      .toLowerCase()
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/[\u2018\u2019\u02bc]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/[\u00a0\u2007\u202f]/g, ' ');
  }

  function tokenize(str) {
    return fold(str).split(/\s+/).filter(Boolean);
  }

  function textNodesIn(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var out = [];
    var node;
    while ((node = walker.nextNode())) out.push(node);
    return out;
  }

  function highlight(el, tokens) {
    if (!tokens.length) return;

    textNodesIn(el).forEach(function (node) {
      var raw = node.nodeValue;
      if (!raw || !raw.trim()) return;

      var hay = fold(raw);
      var ranges = [];

      tokens.forEach(function (token) {
        var at = hay.indexOf(token);
        while (at !== -1) {
          ranges.push([at, at + token.length]);
          at = hay.indexOf(token, at + token.length);
        }
      });

      if (!ranges.length) return;

      ranges.sort(function (a, b) {
        return a[0] - b[0];
      });

      var merged = [];
      ranges.forEach(function (range) {
        var last = merged[merged.length - 1];
        if (last && range[0] <= last[1]) {
          if (range[1] > last[1]) last[1] = range[1];
        } else {
          merged.push([range[0], range[1]]);
        }
      });

      var frag = document.createDocumentFragment();
      var pos = 0;

      merged.forEach(function (range) {
        if (range[0] > pos) frag.appendChild(document.createTextNode(raw.slice(pos, range[0])));
        var mark = document.createElement('mark');
        mark.className = 'pgc-faq__hit';
        mark.appendChild(document.createTextNode(raw.slice(range[0], range[1])));
        frag.appendChild(mark);
        pos = range[1];
      });

      if (pos < raw.length) frag.appendChild(document.createTextNode(raw.slice(pos)));

      node.parentNode.replaceChild(frag, node);
    });
  }

  function plural(n, one, many) {
    return n === 1 ? '1 ' + one : n + ' ' + many;
  }

  function scrollTo(el) {
    /* The existence check matters: without it the catch below would call
       the same missing method again and throw for real. */
    if (!el || !el.scrollIntoView) return;
    try {
      el.scrollIntoView({
        behavior: reduceMQ.matches ? 'auto' : 'smooth',
        block: 'start'
      });
    } catch (err) {
      el.scrollIntoView();
    }
  }

  /* -----------------------------------------------------------------
     one section
     ----------------------------------------------------------------- */

  function build(root) {
    if (root.fqBuilt) return;
    root.fqBuilt = true;

    var input = root.querySelector('[data-fq-search]');
    var status = root.querySelector('[data-fq-status]');
    var empty = root.querySelector('[data-fq-empty]');
    var expandBtn = root.querySelector('[data-fq-expand]');
    var pills = [].slice.call(root.querySelectorAll('[data-fq-pill]'));
    var groups = [].slice.call(root.querySelectorAll('[data-fq-group]'));

    var autoOpenMax = parseInt(root.getAttribute('data-fq-autoopen'), 10);
    if (isNaN(autoOpenMax)) autoOpenMax = 5;

    var labels = {
      copy: root.getAttribute('data-fq-copy-label') || 'Copy link',
      copied: root.getAttribute('data-fq-copied-label') || 'Link copied',
      expand: root.getAttribute('data-fq-expand-label') || 'Expand all',
      collapse: root.getAttribute('data-fq-collapse-label') || 'Collapse all'
    };

    var items = [].slice.call(root.querySelectorAll('[data-fq-item]')).map(function (el) {
      var qEl = el.querySelector('[data-fq-qtext]');
      var aEl = el.querySelector('[data-fq-atext]');
      var groupEl = el.closest('[data-fq-group]');

      return {
        el: el,
        qEl: qEl,
        aEl: aEl,
        qHTML: qEl ? qEl.innerHTML : '',
        aHTML: aEl ? aEl.innerHTML : '',
        hay: fold(
          (qEl ? qEl.textContent : '') + ' \n ' + (aEl ? aEl.textContent : '')
        ),
        group: groupEl ? groupEl.getAttribute('data-fq-group') : 'all',
        visible: true
      };
    });

    var groupName = {};
    groups.forEach(function (g) {
      var h = g.querySelector('.pgc-faq__cat');
      groupName[g.getAttribute('data-fq-group')] = h ? h.textContent.trim() : '';
    });

    var state = {
      query: '',
      category: 'all',
      searching: false,
      savedOpen: null
    };

    /* ---- rendering ---- */

    function restoreText() {
      items.forEach(function (item) {
        if (item.qEl && item.qEl.innerHTML !== item.qHTML) item.qEl.innerHTML = item.qHTML;
        if (item.aEl && item.aEl.innerHTML !== item.aHTML) item.aEl.innerHTML = item.aHTML;
      });
    }

    function render() {
      var tokens = state.query.length >= MIN_QUERY ? tokenize(state.query) : [];
      var wasSearching = state.searching;
      state.searching = tokens.length > 0;

      /* Remember how the reader had left the list before their first
         keystroke, so clearing the box puts it back. */
      if (state.searching && !wasSearching) {
        state.savedOpen = items.map(function (item) {
          return item.el.open;
        });
      }

      restoreText();

      var perGroup = {};
      var matches = [];

      items.forEach(function (item) {
        var inCategory = state.category === 'all' || item.group === state.category;
        var hit = true;

        for (var i = 0; i < tokens.length; i++) {
          if (item.hay.indexOf(tokens[i]) === -1) {
            hit = false;
            break;
          }
        }

        item.visible = inCategory && hit;
        item.el.hidden = !item.visible;

        /* Counted per category before the category filter, so the pills
           report what switching to them would show. */
        if (hit) {
          perGroup[item.group] = (perGroup[item.group] || 0) + 1;
          if (inCategory) matches.push(item);
        }
      });

      if (state.searching) {
        matches.forEach(function (item) {
          if (item.qEl) highlight(item.qEl, tokens);
          if (item.aEl) highlight(item.aEl, tokens);
        });
      }

      /* Few enough results to be worth reading outright. */
      if (state.searching) {
        var openThem = matches.length > 0 && matches.length <= autoOpenMax;
        items.forEach(function (item) {
          item.el.open = openThem && item.visible;
        });
      } else if (wasSearching && state.savedOpen) {
        items.forEach(function (item, i) {
          item.el.open = !!state.savedOpen[i];
        });
        state.savedOpen = null;
      }

      groups.forEach(function (g) {
        var any = [].slice.call(g.querySelectorAll('[data-fq-item]')).some(function (el) {
          return !el.hidden;
        });
        g.hidden = !any;
      });

      pills.forEach(function (pill) {
        var key = pill.getAttribute('data-fq-pill');
        var num = pill.querySelector('[data-fq-pillnum]');
        var count;

        if (key === 'all') {
          count = Object.keys(perGroup).reduce(function (n, k) {
            return n + perGroup[k];
          }, 0);
        } else {
          count = perGroup[key] || 0;
        }

        if (num) num.textContent = String(count);
        pill.classList.toggle('is-on', key === state.category);
        pill.classList.toggle('is-nil', count === 0);
        pill.setAttribute('aria-current', key === state.category ? 'true' : 'false');
      });

      if (empty) empty.hidden = matches.length > 0 || items.length === 0;

      if (status) {
        var where = state.category === 'all' ? '' : groupName[state.category] || '';
        var text;

        if (state.searching) {
          if (matches.length === 0) {
            text = 'No results for \u201c' + state.query.trim() + '\u201d';
            if (where) text += ' in ' + where;
          } else {
            text = plural(matches.length, 'result', 'results') +
              ' for \u201c' + state.query.trim() + '\u201d';
            if (where) text += ' in ' + where;
          }
        } else if (where) {
          text = plural(matches.length, 'question', 'questions') + ' in ' + where;
        } else {
          text = plural(matches.length, 'question', 'questions');
        }

        status.textContent = text;
      }

      syncExpandLabel();
    }

    /* ---- expand / collapse all ---- */

    function visibleItems() {
      return items.filter(function (item) {
        return item.visible;
      });
    }

    function syncExpandLabel() {
      if (!expandBtn) return;
      var vis = visibleItems();
      var allOpen = vis.length > 0 && vis.every(function (item) {
        return item.el.open;
      });
      expandBtn.textContent = allOpen ? labels.collapse : labels.expand;
      expandBtn.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
      expandBtn.hidden = vis.length === 0;
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        var vis = visibleItems();
        var allOpen = vis.length > 0 && vis.every(function (item) {
          return item.el.open;
        });
        vis.forEach(function (item) {
          item.el.open = !allOpen;
        });
        syncExpandLabel();
      });
    }

    items.forEach(function (item) {
      item.el.addEventListener('toggle', syncExpandLabel);
    });

    /* ---- search ---- */

    var clearBtns = [].slice.call(root.querySelectorAll('[data-fq-clear]'));

    function setQuery(value, focus) {
      state.query = value;
      if (input) input.value = value;
      clearBtns.forEach(function (btn) {
        if (btn.classList.contains('pgc-faq__clear')) btn.hidden = !value;
      });
      render();
      if (focus && input) input.focus();
    }

    if (input) {
      input.addEventListener('input', function () {
        setQuery(input.value, false);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (input.value) {
            event.preventDefault();
            setQuery('', true);
          } else {
            input.blur();
          }
          return;
        }

        if (event.key === 'Enter') {
          event.preventDefault();
          var first = visibleItems()[0];
          if (first) {
            first.el.open = true;
            syncExpandLabel();
            scrollTo(first.el);
            var summary = first.el.querySelector('summary');
            if (summary) summary.focus();
          }
        }
      });
    }

    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQuery('', true);
      });
    });

    /* ---- categories ---- */

    function setCategory(key, scroll) {
      state.category = key;
      render();

      var target = null;
      if (key !== 'all') {
        target = root.querySelector('[data-fq-group="' + key + '"]');
      } else {
        target = root.querySelector('[data-fq-groups]');
      }

      /* Readable in the address bar and reusable as a link, without
         filling the back button with every pill press. */
      if (history.replaceState) {
        var hash = key === 'all' || !target || !target.id ? '' : '#' + target.id;
        try {
          history.replaceState(null, '', location.pathname + location.search + hash);
        } catch (err) {
          /* Sandboxed preview. The filter still works; only the address
             bar misses out. */
        }
      }

      /* Only pull the page back if the reader had already scrolled
         past the top of the list. Switching category from the top of
         the page should not move anything. */
      if (scroll) {
        var listTop = root.querySelector('[data-fq-groups]');
        if (listTop && listTop.getBoundingClientRect().top < 0) scrollTo(listTop);
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        event.preventDefault();
        setCategory(pill.getAttribute('data-fq-pill'), true);
      });
    });

    /* ---- copy link ---- */

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise(function (resolve, reject) {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.top = '-1000px';
        document.body.appendChild(field);
        field.select();
        var ok = false;
        try {
          ok = document.execCommand('copy');
        } catch (err) {
          ok = false;
        }
        document.body.removeChild(field);
        if (ok) resolve();
        else reject(new Error('copy failed'));
      });
    }

    [].slice.call(root.querySelectorAll('[data-fq-copy]')).forEach(function (btn) {
      var textEl = btn.querySelector('[data-fq-copytext]');

      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-fq-target');
        var url = location.origin + location.pathname + '#' + id;

        copyText(url)
          .then(function () {
            if (textEl) textEl.textContent = labels.copied;
            btn.classList.add('is-done');
            clearTimeout(btn.fqTimer);
            btn.fqTimer = setTimeout(function () {
              if (textEl) textEl.textContent = labels.copy;
              btn.classList.remove('is-done');
            }, 2200);
          })
          .catch(function () {
            /* No clipboard permission. Put it in the address bar so it
               can still be copied by hand. */
            try {
              location.hash = id;
            } catch (err) {
              /* nothing left to try */
            }
          });
      });
    });

    /* ---- deep links ---- */

    function openFromHash(scroll) {
      var raw = (location.hash || '').replace(/^#/, '');
      if (!raw) return false;

      var id;
      try {
        id = decodeURIComponent(raw);
      } catch (err) {
        id = raw;
      }

      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return false;

      [].slice.call(root.querySelectorAll('.is-linked')).forEach(function (el) {
        el.classList.remove('is-linked');
      });

      if (target.hasAttribute('data-fq-group')) {
        setCategory(target.getAttribute('data-fq-group'), false);
        if (scroll) scrollTo(target);
        return true;
      }

      if (target.hasAttribute('data-fq-item')) {
        /* A linked question has to be reachable whatever filter was
           left behind, so both filters come off first. */
        state.category = 'all';
        setQuery('', false);
        target.open = true;
        target.classList.add('is-linked');
        syncExpandLabel();
        if (scroll) scrollTo(target);
        return true;
      }

      return false;
    }

    window.addEventListener('hashchange', function () {
      openFromHash(true);
    });

    /* ---- keyboard shortcut ---- */

    if (input && !window.fqSlashBound) {
      window.fqSlashBound = true;
      document.addEventListener('keydown', function (event) {
        if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;

        var el = document.activeElement;
        if (el && (el.isContentEditable ||
          /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return;

        var first = document.querySelector('[data-fq-root] [data-fq-search]');
        if (!first) return;
        event.preventDefault();
        first.focus();
        first.select();
      });
    }

    /* ---- entrance ---- */

    function reveal() {
      if (!root.querySelector('[data-fq-reveal]')) return;

      root.classList.add('fq-ready');

      var targets = [].slice.call(root.querySelectorAll('[data-fq-reveal]'));
      targets.forEach(function (el, i) {
        el.style.setProperty('--fq-i', String(i));
      });

      function showAll() {
        targets.forEach(function (el) {
          el.classList.add('is-in');
        });
      }

      if (reduceMQ.matches || !('IntersectionObserver' in window)) {
        showAll();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      targets.forEach(function (el) {
        io.observe(el);
      });

      /* Failsafe. Nothing on a support page is allowed to stay
         invisible because an observer never fired. */
      setTimeout(showAll, 1600);
    }

    /* ---- how far a linked question sits from the top ----
       It has to clear the theme header and the sticky toolbar. The
       toolbar's height is not knowable from Liquid -- it changes with
       the breakpoint and with how many categories the merchant added --
       so the section setting acts as a floor and the real clearance is
       measured here. Read the configured value before anything is
       written inline, or it reads back its own answer. */

    var configuredOffset = parseFloat(
      getComputedStyle(root).getPropertyValue('--fq-anchor-offset')
    ) || 0;

    function syncAnchorOffset() {
      var toolbar = root.querySelector('.pgc-faq__toolbar');
      var parked = 0;
      var height = 0;

      if (toolbar) {
        var cs = getComputedStyle(toolbar);
        /* A toolbar the merchant un-stuck covers nothing, so it needs
           no clearance and the configured value stands. */
        if (cs.position === 'sticky') {
          parked = parseFloat(cs.top) || 0;
          height = toolbar.getBoundingClientRect().height;
        }
      }

      var needed = Math.round(parked + height + 20);
      root.style.setProperty(
        '--fq-anchor-offset',
        Math.max(configuredOffset, needed) + 'px'
      );
    }

    var offsetTimer;
    window.addEventListener('resize', function () {
      clearTimeout(offsetTimer);
      offsetTimer = setTimeout(syncAnchorOffset, 150);
    });

    root.classList.add('fq-js');
    syncAnchorOffset();
    render();

    if (!openFromHash(true)) {
      /* Nothing linked; leave the list closed and let the reader choose. */
      syncExpandLabel();
    }

    reveal();
  }

  /* -----------------------------------------------------------------
     boot
     ----------------------------------------------------------------- */

  function scan() {
    [].slice.call(document.querySelectorAll('[data-fq-root]')).forEach(function (root) {
      build(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('[data-fq-root]')
      : null;
    if (root) build(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    var item = el && el.closest ? el.closest('[data-fq-item]') : null;
    if (!item && el && el.hasAttribute && el.hasAttribute('data-fq-item')) item = el;
    if (item) {
      item.hidden = false;
      item.open = true;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-hero"] && !Shopify.designMode) return;
  try {
    
/* ==================================================================
   SHARED GUARANTEE MOTION CONTROLLER
   One IntersectionObserver and one rAF loop for every guarantee
   section on the page. All three sections ship a byte-identical copy;
   the guard below means only the first to run takes effect, so no
   section depends on any other being present. Edit it in one file and
   you must paste the same block into the other two.

   Three jobs:
     1. reveal    -- fade and rise, replaying on re-entry
     2. parallax  -- --pgcg-shift, transform only, desktop only
     3. progress  -- --pgcg-progress 0..1, drives the karaoke ramp

   NOTHING SECTION-SPECIFIC GOES IN HERE. Because this file is
   triplicated and only the first copy to run takes effect, a feature
   added here silently does nothing unless EVERY section is re-pasted.
   The "see more reviews" button was put here once and broke exactly
   that way. Section-specific behaviour belongs in that section's own
   guarded block.
   ================================================================== */
(function () {
  if (window.PgcGuaranteeMotion) return;

  var SEL_REVEAL = '[data-pgcg-reveal]';
  var SEL_PARALLAX = '[data-pgcg-parallax]';
  var SEL_PROGRESS = '[data-pgcg-progress]';

  /* Below this the sticky track is too short to measure a pin against,
     so the ramp falls back to viewport timing. That is what happens on
     mobile, where the pin is switched off in CSS. */
  var PIN_MIN = 40;
  var FALL_FROM = 92;
  var FALL_TO = 18;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wideQuery = window.matchMedia('(min-width: 750px)');

  var observer = null;
  var parallax = [];
  var progress = [];
  var queued = false;
  var everFired = false;
  var failsafe = 0;

  function revealAll() {
    var nodes = document.querySelectorAll(SEL_REVEAL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('pgcg-in');
  }

  function onEntries(entries) {
    everFired = true;
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        entry.target.classList.add('pgcg-in');
      } else if (entry.intersectionRatio === 0) {
        /* Reset only when the element is completely out of view.
           Resetting at the same boundary that reveals would flicker. */
        entry.target.classList.remove('pgcg-in');
      }
    }
  }

  /* position: sticky silently does nothing if any ancestor clips or
     scrolls, which would leave a tall empty gap where the pinned band
     should be. Checked once, at startup. */
  function ancestorClips(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var cs = window.getComputedStyle(node);
      var flow = cs.overflow + ' ' + cs.overflowX + ' ' + cs.overflowY;
      if (flow.indexOf('hidden') > -1 || flow.indexOf('clip') > -1 || flow.indexOf('scroll') > -1 || flow.indexOf('auto') > -1) {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function measure() {
    parallax = [];
    var pNodes = document.querySelectorAll(SEL_PARALLAX);
    for (var i = 0; i < pNodes.length; i++) {
      var strength = parseFloat(pNodes[i].getAttribute('data-pgcg-parallax'));
      if (strength) parallax.push({ el: pNodes[i], strength: strength });
    }

    progress = [];
    var gNodes = document.querySelectorAll(SEL_PROGRESS);
    for (var j = 0; j < gNodes.length; j++) {
      var el = gNodes[j];
      var raw = (el.getAttribute('data-pgcg-progress') || '').trim();

      if (raw === 'pin') {
        /* Only mark the pin dead once; re-measuring on resize must not
           un-kill a layout that still clips. */
        if (ancestorClips(el)) el.classList.add('pgcg-pin-off');
        progress.push({ el: el, pin: true, from: FALL_FROM, to: FALL_TO });
        continue;
      }

      /* "88,34" = start when the top edge is 88% down the viewport,
         finish when it reaches 34%. */
      var range = raw.split(',');
      var from = parseFloat(range[0]);
      var to = parseFloat(range[1]);
      if (isNaN(from)) from = FALL_FROM;
      if (isNaN(to)) to = FALL_TO;
      if (from <= to) from = to + 1;
      progress.push({ el: el, pin: false, from: from, to: to });
    }
  }

  function paint() {
    queued = false;
    var calm = reduceQuery.matches;
    var drift = wideQuery.matches && !calm;
    var vh = window.innerHeight || 1;
    var i;

    for (i = 0; i < parallax.length; i++) {
      var item = parallax[i];

      if (!drift) {
        item.el.style.setProperty('--pgcg-shift', '0px');
        continue;
      }

      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -240 || rect.top > vh + 240) continue;

      var centre = rect.top + rect.height / 2;
      var travel = (centre - vh / 2) / vh;
      if (travel > 1) travel = 1;
      if (travel < -1) travel = -1;

      /* transform only -- never top/left/width/height. */
      item.el.style.setProperty('--pgcg-shift', (travel * item.strength).toFixed(2) + 'px');
    }

    for (i = 0; i < progress.length; i++) {
      var band = progress[i];

      if (calm) {
        band.el.style.setProperty('--pgcg-progress', '1');
        continue;
      }

      var box = band.el.getBoundingClientRect();
      var ratio;
      var slack = box.height - vh;

      if (band.pin && slack > PIN_MIN) {
        /* Pinned: how far the track has been scrolled through. The
           band is stuck to the top for exactly this distance. */
        ratio = -box.top / slack;
      } else {
        /* Not pinned -- either the pin was refused, or the layout
           stacked it on a small screen. Time it off the viewport
           instead. Measured, not guessed from a media query, so the
           awkward in-between widths are right too. */
        var start = (vh * band.from) / 100;
        var end = (vh * band.to) / 100;
        ratio = (start - box.top) / (start - end);
      }

      if (ratio > 1) ratio = 1;
      if (ratio < 0) ratio = 0;
      band.el.style.setProperty('--pgcg-progress', ratio.toFixed(4));
    }
  }

  function schedule() {
    if (queued) return;
    /* Flag set BEFORE the request, never from its return value: a
       synchronous callback would otherwise latch the guard shut. */
    queued = true;
    window.requestAnimationFrame(paint);
  }

  function init() {
    var anything =
      document.querySelector(SEL_REVEAL) ||
      document.querySelector(SEL_PARALLAX) ||
      document.querySelector(SEL_PROGRESS);
    if (!anything) return;

    if (reduceQuery.matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      if (!observer) {
        observer = new IntersectionObserver(onEntries, {
          rootMargin: '0px 0px -8% 0px',
          threshold: [0, 0.08]
        });
      }
      var nodes = document.querySelectorAll(SEL_REVEAL);
      for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);

      /* A stalled observer must not leave the page blank. */
      if (!failsafe) {
        failsafe = window.setTimeout(function () {
          if (!everFired) revealAll();
        }, 2500);
      }
    }

    measure();
    schedule();
  }

  window.PgcGuaranteeMotion = { refresh: init };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener(
    'resize',
    function () {
      measure();
      schedule();
    },
    { passive: true }
  );

  /* Sections re-render in the theme editor without a page load. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    measure();
    schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-promise"] && !Shopify.designMode) return;
  try {
    
/* ==================================================================
   SHARED GUARANTEE MOTION CONTROLLER
   One IntersectionObserver and one rAF loop for every guarantee
   section on the page. All three sections ship a byte-identical copy;
   the guard below means only the first to run takes effect, so no
   section depends on any other being present. Edit it in one file and
   you must paste the same block into the other two.

   Three jobs:
     1. reveal    -- fade and rise, replaying on re-entry
     2. parallax  -- --pgcg-shift, transform only, desktop only
     3. progress  -- --pgcg-progress 0..1, drives the karaoke ramp

   NOTHING SECTION-SPECIFIC GOES IN HERE. Because this file is
   triplicated and only the first copy to run takes effect, a feature
   added here silently does nothing unless EVERY section is re-pasted.
   The "see more reviews" button was put here once and broke exactly
   that way. Section-specific behaviour belongs in that section's own
   guarded block.
   ================================================================== */
(function () {
  if (window.PgcGuaranteeMotion) return;

  var SEL_REVEAL = '[data-pgcg-reveal]';
  var SEL_PARALLAX = '[data-pgcg-parallax]';
  var SEL_PROGRESS = '[data-pgcg-progress]';

  /* Below this the sticky track is too short to measure a pin against,
     so the ramp falls back to viewport timing. That is what happens on
     mobile, where the pin is switched off in CSS. */
  var PIN_MIN = 40;
  var FALL_FROM = 92;
  var FALL_TO = 18;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wideQuery = window.matchMedia('(min-width: 750px)');

  var observer = null;
  var parallax = [];
  var progress = [];
  var queued = false;
  var everFired = false;
  var failsafe = 0;

  function revealAll() {
    var nodes = document.querySelectorAll(SEL_REVEAL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('pgcg-in');
  }

  function onEntries(entries) {
    everFired = true;
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        entry.target.classList.add('pgcg-in');
      } else if (entry.intersectionRatio === 0) {
        /* Reset only when the element is completely out of view.
           Resetting at the same boundary that reveals would flicker. */
        entry.target.classList.remove('pgcg-in');
      }
    }
  }

  /* position: sticky silently does nothing if any ancestor clips or
     scrolls, which would leave a tall empty gap where the pinned band
     should be. Checked once, at startup. */
  function ancestorClips(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var cs = window.getComputedStyle(node);
      var flow = cs.overflow + ' ' + cs.overflowX + ' ' + cs.overflowY;
      if (flow.indexOf('hidden') > -1 || flow.indexOf('clip') > -1 || flow.indexOf('scroll') > -1 || flow.indexOf('auto') > -1) {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function measure() {
    parallax = [];
    var pNodes = document.querySelectorAll(SEL_PARALLAX);
    for (var i = 0; i < pNodes.length; i++) {
      var strength = parseFloat(pNodes[i].getAttribute('data-pgcg-parallax'));
      if (strength) parallax.push({ el: pNodes[i], strength: strength });
    }

    progress = [];
    var gNodes = document.querySelectorAll(SEL_PROGRESS);
    for (var j = 0; j < gNodes.length; j++) {
      var el = gNodes[j];
      var raw = (el.getAttribute('data-pgcg-progress') || '').trim();

      if (raw === 'pin') {
        /* Only mark the pin dead once; re-measuring on resize must not
           un-kill a layout that still clips. */
        if (ancestorClips(el)) el.classList.add('pgcg-pin-off');
        progress.push({ el: el, pin: true, from: FALL_FROM, to: FALL_TO });
        continue;
      }

      /* "88,34" = start when the top edge is 88% down the viewport,
         finish when it reaches 34%. */
      var range = raw.split(',');
      var from = parseFloat(range[0]);
      var to = parseFloat(range[1]);
      if (isNaN(from)) from = FALL_FROM;
      if (isNaN(to)) to = FALL_TO;
      if (from <= to) from = to + 1;
      progress.push({ el: el, pin: false, from: from, to: to });
    }
  }

  function paint() {
    queued = false;
    var calm = reduceQuery.matches;
    var drift = wideQuery.matches && !calm;
    var vh = window.innerHeight || 1;
    var i;

    for (i = 0; i < parallax.length; i++) {
      var item = parallax[i];

      if (!drift) {
        item.el.style.setProperty('--pgcg-shift', '0px');
        continue;
      }

      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -240 || rect.top > vh + 240) continue;

      var centre = rect.top + rect.height / 2;
      var travel = (centre - vh / 2) / vh;
      if (travel > 1) travel = 1;
      if (travel < -1) travel = -1;

      /* transform only -- never top/left/width/height. */
      item.el.style.setProperty('--pgcg-shift', (travel * item.strength).toFixed(2) + 'px');
    }

    for (i = 0; i < progress.length; i++) {
      var band = progress[i];

      if (calm) {
        band.el.style.setProperty('--pgcg-progress', '1');
        continue;
      }

      var box = band.el.getBoundingClientRect();
      var ratio;
      var slack = box.height - vh;

      if (band.pin && slack > PIN_MIN) {
        /* Pinned: how far the track has been scrolled through. The
           band is stuck to the top for exactly this distance. */
        ratio = -box.top / slack;
      } else {
        /* Not pinned -- either the pin was refused, or the layout
           stacked it on a small screen. Time it off the viewport
           instead. Measured, not guessed from a media query, so the
           awkward in-between widths are right too. */
        var start = (vh * band.from) / 100;
        var end = (vh * band.to) / 100;
        ratio = (start - box.top) / (start - end);
      }

      if (ratio > 1) ratio = 1;
      if (ratio < 0) ratio = 0;
      band.el.style.setProperty('--pgcg-progress', ratio.toFixed(4));
    }
  }

  function schedule() {
    if (queued) return;
    /* Flag set BEFORE the request, never from its return value: a
       synchronous callback would otherwise latch the guard shut. */
    queued = true;
    window.requestAnimationFrame(paint);
  }

  function init() {
    var anything =
      document.querySelector(SEL_REVEAL) ||
      document.querySelector(SEL_PARALLAX) ||
      document.querySelector(SEL_PROGRESS);
    if (!anything) return;

    if (reduceQuery.matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      if (!observer) {
        observer = new IntersectionObserver(onEntries, {
          rootMargin: '0px 0px -8% 0px',
          threshold: [0, 0.08]
        });
      }
      var nodes = document.querySelectorAll(SEL_REVEAL);
      for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);

      /* A stalled observer must not leave the page blank. */
      if (!failsafe) {
        failsafe = window.setTimeout(function () {
          if (!everFired) revealAll();
        }, 2500);
      }
    }

    measure();
    schedule();
  }

  window.PgcGuaranteeMotion = { refresh: init };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener(
    'resize',
    function () {
      measure();
      schedule();
    },
    { passive: true }
  );

  /* Sections re-render in the theme editor without a page load. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    measure();
    schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-proof"] && !Shopify.designMode) return;
  try {
    
/* ==================================================================
   SHARED GUARANTEE MOTION CONTROLLER
   One IntersectionObserver and one rAF loop for every guarantee
   section on the page. All three sections ship a byte-identical copy;
   the guard below means only the first to run takes effect, so no
   section depends on any other being present. Edit it in one file and
   you must paste the same block into the other two.

   Three jobs:
     1. reveal    -- fade and rise, replaying on re-entry
     2. parallax  -- --pgcg-shift, transform only, desktop only
     3. progress  -- --pgcg-progress 0..1, drives the karaoke ramp

   NOTHING SECTION-SPECIFIC GOES IN HERE. Because this file is
   triplicated and only the first copy to run takes effect, a feature
   added here silently does nothing unless EVERY section is re-pasted.
   The "see more reviews" button was put here once and broke exactly
   that way. Section-specific behaviour belongs in that section's own
   guarded block.
   ================================================================== */
(function () {
  if (window.PgcGuaranteeMotion) return;

  var SEL_REVEAL = '[data-pgcg-reveal]';
  var SEL_PARALLAX = '[data-pgcg-parallax]';
  var SEL_PROGRESS = '[data-pgcg-progress]';

  /* Below this the sticky track is too short to measure a pin against,
     so the ramp falls back to viewport timing. That is what happens on
     mobile, where the pin is switched off in CSS. */
  var PIN_MIN = 40;
  var FALL_FROM = 92;
  var FALL_TO = 18;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wideQuery = window.matchMedia('(min-width: 750px)');

  var observer = null;
  var parallax = [];
  var progress = [];
  var queued = false;
  var everFired = false;
  var failsafe = 0;

  function revealAll() {
    var nodes = document.querySelectorAll(SEL_REVEAL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('pgcg-in');
  }

  function onEntries(entries) {
    everFired = true;
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        entry.target.classList.add('pgcg-in');
      } else if (entry.intersectionRatio === 0) {
        /* Reset only when the element is completely out of view.
           Resetting at the same boundary that reveals would flicker. */
        entry.target.classList.remove('pgcg-in');
      }
    }
  }

  /* position: sticky silently does nothing if any ancestor clips or
     scrolls, which would leave a tall empty gap where the pinned band
     should be. Checked once, at startup. */
  function ancestorClips(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var cs = window.getComputedStyle(node);
      var flow = cs.overflow + ' ' + cs.overflowX + ' ' + cs.overflowY;
      if (flow.indexOf('hidden') > -1 || flow.indexOf('clip') > -1 || flow.indexOf('scroll') > -1 || flow.indexOf('auto') > -1) {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function measure() {
    parallax = [];
    var pNodes = document.querySelectorAll(SEL_PARALLAX);
    for (var i = 0; i < pNodes.length; i++) {
      var strength = parseFloat(pNodes[i].getAttribute('data-pgcg-parallax'));
      if (strength) parallax.push({ el: pNodes[i], strength: strength });
    }

    progress = [];
    var gNodes = document.querySelectorAll(SEL_PROGRESS);
    for (var j = 0; j < gNodes.length; j++) {
      var el = gNodes[j];
      var raw = (el.getAttribute('data-pgcg-progress') || '').trim();

      if (raw === 'pin') {
        /* Only mark the pin dead once; re-measuring on resize must not
           un-kill a layout that still clips. */
        if (ancestorClips(el)) el.classList.add('pgcg-pin-off');
        progress.push({ el: el, pin: true, from: FALL_FROM, to: FALL_TO });
        continue;
      }

      /* "88,34" = start when the top edge is 88% down the viewport,
         finish when it reaches 34%. */
      var range = raw.split(',');
      var from = parseFloat(range[0]);
      var to = parseFloat(range[1]);
      if (isNaN(from)) from = FALL_FROM;
      if (isNaN(to)) to = FALL_TO;
      if (from <= to) from = to + 1;
      progress.push({ el: el, pin: false, from: from, to: to });
    }
  }

  function paint() {
    queued = false;
    var calm = reduceQuery.matches;
    var drift = wideQuery.matches && !calm;
    var vh = window.innerHeight || 1;
    var i;

    for (i = 0; i < parallax.length; i++) {
      var item = parallax[i];

      if (!drift) {
        item.el.style.setProperty('--pgcg-shift', '0px');
        continue;
      }

      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -240 || rect.top > vh + 240) continue;

      var centre = rect.top + rect.height / 2;
      var travel = (centre - vh / 2) / vh;
      if (travel > 1) travel = 1;
      if (travel < -1) travel = -1;

      /* transform only -- never top/left/width/height. */
      item.el.style.setProperty('--pgcg-shift', (travel * item.strength).toFixed(2) + 'px');
    }

    for (i = 0; i < progress.length; i++) {
      var band = progress[i];

      if (calm) {
        band.el.style.setProperty('--pgcg-progress', '1');
        continue;
      }

      var box = band.el.getBoundingClientRect();
      var ratio;
      var slack = box.height - vh;

      if (band.pin && slack > PIN_MIN) {
        /* Pinned: how far the track has been scrolled through. The
           band is stuck to the top for exactly this distance. */
        ratio = -box.top / slack;
      } else {
        /* Not pinned -- either the pin was refused, or the layout
           stacked it on a small screen. Time it off the viewport
           instead. Measured, not guessed from a media query, so the
           awkward in-between widths are right too. */
        var start = (vh * band.from) / 100;
        var end = (vh * band.to) / 100;
        ratio = (start - box.top) / (start - end);
      }

      if (ratio > 1) ratio = 1;
      if (ratio < 0) ratio = 0;
      band.el.style.setProperty('--pgcg-progress', ratio.toFixed(4));
    }
  }

  function schedule() {
    if (queued) return;
    /* Flag set BEFORE the request, never from its return value: a
       synchronous callback would otherwise latch the guard shut. */
    queued = true;
    window.requestAnimationFrame(paint);
  }

  function init() {
    var anything =
      document.querySelector(SEL_REVEAL) ||
      document.querySelector(SEL_PARALLAX) ||
      document.querySelector(SEL_PROGRESS);
    if (!anything) return;

    if (reduceQuery.matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      if (!observer) {
        observer = new IntersectionObserver(onEntries, {
          rootMargin: '0px 0px -8% 0px',
          threshold: [0, 0.08]
        });
      }
      var nodes = document.querySelectorAll(SEL_REVEAL);
      for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);

      /* A stalled observer must not leave the page blank. */
      if (!failsafe) {
        failsafe = window.setTimeout(function () {
          if (!everFired) revealAll();
        }, 2500);
      }
    }

    measure();
    schedule();
  }

  window.PgcGuaranteeMotion = { refresh: init };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener(
    'resize',
    function () {
      measure();
      schedule();
    },
    { passive: true }
  );

  /* Sections re-render in the theme editor without a page load. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    measure();
    schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==================================================================
   SEE MORE REVIEWS
   Deliberately NOT in the shared controller above.

   That controller is byte-identical in all three guarantee sections
   and guarded so only the first copy to run takes effect. Anything
   added to it therefore stays dead until every section is re-pasted --
   which is exactly how this button shipped broken. Living here, it
   works whenever THIS file is current, whatever the other two carry.

   Every card is already in the DOM with the overflow hidden in CSS, so
   a click is instant and costs no network. The button carries the
   hidden attribute and is only un-hidden here, so a page where this
   script never runs shows no button at all rather than a dead one.
   ================================================================== */
(function () {
  if (window.PgcGuaranteeMore) return;
  window.PgcGuaranteeMore = true;

  var ROOT = '[data-gr-more-root]';

  function reveal(event) {
    var btn = event.currentTarget;
    var root = btn.closest ? btn.closest(ROOT) : null;
    if (!root) return;

    var step = parseInt(root.getAttribute('data-gr-step'), 10);
    if (!step || step < 1) step = 8;

    var extras = root.querySelectorAll('.gr__card--extra');
    var take = extras.length < step ? extras.length : step;
    for (var i = 0; i < take; i++) extras[i].classList.remove('gr__card--extra');

    if (!root.querySelectorAll('.gr__card--extra').length) btn.hidden = true;

    /* The wall just got taller, so anything the motion controller
       measured off page geometry is now stale. */
    if (window.PgcGuaranteeMotion && window.PgcGuaranteeMotion.refresh) {
      window.PgcGuaranteeMotion.refresh();
    }
  }

  function wire() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      /* The theme editor re-runs this on every save; a second listener
         would make one click jump two batches. */
      if (root.getAttribute('data-gr-wired') === 'true') continue;

      var btn = root.querySelector('[data-gr-more-btn]');
      if (!btn) continue;
      if (!root.querySelectorAll('.gr__card--extra').length) continue;

      root.setAttribute('data-gr-wired', 'true');
      btn.hidden = false;
      btn.addEventListener('click', reveal);
    }
  }

  document.addEventListener('shopify:section:load', wire);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // The header has two search overlays (the mobile icon beside the menu and
      // the theme's own), so close every one.
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((modal) => modal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgc-all-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ENDPOINT = 'https://judge.me/reviews/all_reviews_js_based';
  var MAX_PAGE = 40; // Judge.me repeats page 40 for anything past it

  var SORTS = {
    'most-recent':    { by: 'created_at', dir: 'desc' },
    'highest-rating': { by: 'rating',     dir: 'desc' },
    'lowest-rating':  { by: 'rating',     dir: 'asc'  },
    'pictures-first': { by: 'pictures_first', dir: null }
  };

  var CHECK = '<svg class="pgcar__check" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 1.6l2.6 1.9 3.2-.2.9 3.1 2.6 1.9-1.3 3 1.3 3-2.6 1.9-.9 3.1-3.2-.2L12 22.4l-2.6-1.9-3.2.2-.9-3.1L2.7 15.7l1.3-3-1.3-3 2.6-1.9.9-3.1 3.2.2z" opacity=".22"/>' +
    '<path d="M10.6 15.6l-3-3 1.3-1.3 1.7 1.7 4.2-4.2 1.3 1.3z"/></svg>';

  function text(node) {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  // Judge.me wraps each paragraph of a review in its own <p>. Flattening
  // that to textContent runs the paragraphs together, so keep the breaks:
  // the card styles the quote with white-space: pre-line.
  function paragraphs(node) {
    if (!node) return '';
    var ps = node.querySelectorAll('p');
    if (!ps.length) return text(node);
    var out = [];
    Array.prototype.forEach.call(ps, function (p) {
      var t = text(p);
      if (t) out.push(t);
    });
    return out.join('\n\n');
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function starSvg(n) {
    var out = '';
    for (var i = 0; i < n; i++) {
      out += '<svg class="pgcar__star" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
             '<path d="M12 2.1l3.02 6.53 7.15.83-5.3 4.83 1.44 7.03L12 17.86 5.69 21.32l1.44-7.03-5.3-4.83 7.15-.83z"/></svg>';
    }
    return out;
  }

  function starBlock(score, small) {
    var pct = Math.max(0, Math.min(100, (parseFloat(score) || 0) * 20));
    var wrap = el('span', 'pgcar__stars' + (small ? ' pgcar__stars--sm' : ''));
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', String(score));
    var off = el('span', 'pgcar__stars-row pgcar__stars-row--off');
    var on = el('span', 'pgcar__stars-row pgcar__stars-row--on');
    var inner = el('span', 'pgcar__stars-inner');
    on.style.width = pct + '%';
    off.innerHTML = starSvg(5);
    inner.innerHTML = starSvg(5);
    on.appendChild(inner);
    wrap.appendChild(off);
    wrap.appendChild(on);
    return wrap;
  }

  function formatDate(raw) {
    if (!raw) return '';
    // Judge.me sends "2026-10-25 22:07:02 UTC"
    var iso = raw.replace(' UTC', 'Z').replace(' ', 'T');
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en', {
        day: 'numeric', month: 'long', year: 'numeric'
      });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  /* Judge.me serves review photos through a proxy that honours the
     width in the query string, so the card image is requested at the
     column's real size rather than the 1024 their own markup asks for.
     The thumbnails below the text carry width=160 already. */
  function picSrc(src, w) {
    return src.replace(/([?&])width=\d+/, '$1width=' + w);
  }

  function buildCard(rev, cfg) {
    var card = el('div', 'pgcar__card');
    card.setAttribute('role', 'listitem');
    var id = rev.getAttribute('data-review-id');
    if (id) card.setAttribute('data-review-id', id);

    var body = paragraphs(rev.querySelector('.jdgm-rev__body'));
    if (!body) return null;

    var author = text(rev.querySelector('.jdgm-rev__author'));
    var alt = cfg.photoAlt + (author ? ' ' + author : '');
    var pics = cfg.showPhotos ? rev.querySelectorAll('.jdgm-rev__pic-img') : [];

    /* ---- the card photo ---- */
    if (pics.length) {
      var first = pics[0].getAttribute('data-src') || pics[0].getAttribute('src');
      if (first) {
        var hero = el('button', 'pgcar__img-btn');
        hero.type = 'button';
        hero.setAttribute('data-pgcar-full', picSrc(first, 1600));
        hero.setAttribute('aria-label', cfg.zoomLabel);
        var heroImg = el('img', 'pgcar__card-img');
        heroImg.src = picSrc(first, 520);
        heroImg.srcset = picSrc(first, 320) + ' 320w, '
                       + picSrc(first, 520) + ' 520w, '
                       + picSrc(first, 700) + ' 700w';
        heroImg.sizes = '(min-width: 1200px) 24vw, (min-width: 990px) 30vw, (min-width: 750px) 45vw, 47vw';
        heroImg.loading = 'lazy';
        heroImg.decoding = 'async';
        heroImg.width = 4;
        heroImg.height = 5;
        heroImg.alt = alt;
        hero.appendChild(heroImg);
        card.appendChild(hero);
      }
    }

    var box = el('div', 'pgcar__card-body');

    /* ---- who ---- */
    var name = el('p', 'pgcar__name');
    name.textContent = author;
    var place = text(rev.querySelector('.jdgm-rev__location')).replace(/^\(|\)$/g, '').trim();
    if (cfg.showLocation && place) {
      var ps = el('span', 'pgcar__place');
      ps.textContent = '\u00a0\u00b7\u00a0' + place;
      name.appendChild(ps);
    }
    box.appendChild(name);

    /* ---- badge ---- */
    var verified = rev.getAttribute('data-verified-buyer') === 'true';
    var badge = cfg.badgeMode === 'all'
      ? cfg.verifiedLabel
      : (verified ? cfg.verifiedLabel : cfg.collectedLabel);
    if (badge) {
      var b = el('p', 'pgcar__verified');
      b.innerHTML = CHECK;
      var bt = document.createElement('span');
      bt.textContent = badge;
      b.appendChild(bt);
      box.appendChild(b);
    }

    /* ---- score and date ---- */
    var ratingNode = rev.querySelector('.jdgm-rev__rating');
    var score = ratingNode ? ratingNode.getAttribute('data-score') : '';
    box.appendChild(starBlock(score, true));

    var stamp = rev.querySelector('.jdgm-rev__timestamp');
    var when = stamp ? formatDate(stamp.getAttribute('data-content')) : '';
    if (cfg.showDate && when) {
      var dateEl = el('span', 'pgcar__date');
      dateEl.textContent = when;
      box.appendChild(dateEl);
    }

    /* ---- the review ---- */
    var title = text(rev.querySelector('.jdgm-rev__title'));
    if (cfg.showTitle && title) {
      var t = el('p', 'pgcar__card-title');
      t.textContent = title;
      box.appendChild(t);
    }

    var q = el('blockquote', 'pgcar__quote');
    q.textContent = body;
    box.appendChild(q);

    /* ---- any further photos ---- */
    if (pics.length > 1) {
      var shots = el('div', 'pgcar__shots');
      for (var i = 1; i < pics.length && i < 4; i++) {
        var src = pics[i].getAttribute('data-src') || pics[i].getAttribute('src');
        if (!src) continue;
        var btn = el('button', 'pgcar__shot');
        btn.type = 'button';
        btn.setAttribute('data-pgcar-full', picSrc(src, 1600));
        btn.setAttribute('aria-label', cfg.zoomLabel);
        var img = el('img', 'pgcar__shot-img');
        img.src = picSrc(src, 160);
        img.srcset = picSrc(src, 160) + ' 160w, ' + picSrc(src, 320) + ' 320w';
        img.sizes = '72px';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = alt;
        btn.appendChild(img);
        shots.appendChild(btn);
      }
      if (shots.childNodes.length) box.appendChild(shots);
    }

    /* ---- what it was for ---- */
    if (cfg.showProduct) {
      var link = rev.querySelector('.jdgm-rev__prod-link');
      var prodName = text(link);
      if (prodName) {
        var href = link.getAttribute('href') || '';
        var p = el(href ? 'a' : 'p', 'pgcar__product');
        p.textContent = prodName;
        if (href) p.setAttribute('href', href);
        box.appendChild(p);
      }
    }

    card.appendChild(box);
    return card;
  }

  /* ------------------------------------------------------------------
     Judge.me's own review form

     Ported from sections/scan-me-review-card.liquid, which is the only
     place on this store where opening their modal from our own button
     works properly. Three things have to travel together or it breaks:

       1. the bundle list below, in this order
       2. showModalPage(1) for a store review
       3. alignSlider / keepAligned

     Every asset URL is derived from loader.js's own src, so an app
     update to a new build number needs no change here.
  ------------------------------------------------------------------ */

  var WIDGET_CLASS = 'jdgm-review-widget-modal';
  var jmReady = null;

  function assetBase() {
    var sc = document.querySelector('script[src*="judgeme"][src*="loader.js"]');
    if (!sc || !sc.src) return null;
    return sc.src.replace(/loader\.js.*$/, '');
  }

  function loadScript(url) {
    return new Promise(function (resolve) {
      if (document.querySelector('script[data-pgcar-src="' + url + '"]')) return resolve(true);
      var sc = document.createElement('script');
      sc.src = url;
      sc.async = false;
      sc.setAttribute('data-pgcar-src', url);
      sc.onload = function () { resolve(true); };
      sc.onerror = function () { resolve(false); };
      document.head.appendChild(sc);
    });
  }

  function loadCss(url) {
    if (document.querySelector('link[data-pgcar-href="' + url + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = url;
    l.setAttribute('data-pgcar-href', url);
    document.head.appendChild(l);
  }

  function waitFor(test, ms) {
    return new Promise(function (resolve) {
      if (test()) return resolve(true);
      var done = 0;
      var t = setInterval(function () {
        done += 100;
        if (test()) { clearInterval(t); resolve(true); }
        else if (done >= ms) { clearInterval(t); resolve(false); }
      }, 100);
    });
  }

  /* Judge.me's own path builder, so the CSS follows them when the app
     updates. It lives on loader.js, which is always on the page; the
     extension directory is the fallback if it ever is not. */
  function cdnPath(base, name) {
    try {
      if (window.jdgm && typeof window.jdgm.widgetPath === 'function') {
        return window.jdgm.widgetPath(name);
      }
    } catch (e) {}
    return base + name;
  }

  function ensureJudgeme() {
    if (jmReady) return jmReady;

    jmReady = (function () {
      var base = assetBase();
      if (!base) return Promise.resolve(false);

      /* The modal's layout lives in form.css. Without it the dialog
         renders as a full-width block with its panels stacked, which
         reads as the form being cut off. media.css is the photo
         upload. Both are served from judge.me's own CDN, not from the
         Shopify extension directory, which is why they are built with
         widgetPath rather than by appending to base. */
      loadCss(cdnPath(base, 'form.css'));
      loadCss(cdnPath(base, 'media.css'));

      /* This page builds its own cards and carries no Judge.me widget,
         so their core is usually not here yet. The short wait is for
         the case where something else on the page has pulled it in. */
      return waitFor(function () {
        return !!(window.jdgm && window.jdgm._WriteReviewModal);
      }, 1500)
        .then(function (have) {
          if (have) return true;
          /* One file on the current build (830). It carries jQuery,
             the widget core and the review modal together. */
          return loadScript(base + 'shopify_v2.js').then(function () {
            return waitFor(function () {
              return !!(window.jdgm && window.jdgm._WriteReviewModal);
            }, 6000);
          });
        })
        .then(function (have) {
          if (have) return true;
          /* Older builds split the same code across these six, with
             the stylesheets in the extension directory. Kept so a
             rollback on their side does not take the button with it. */
          loadCss(base + 'widget_v3_form.css');
          loadCss(base + 'widget_v3_media.css');
          return loadScript(base + 'widget_common.js')
            .then(function () { return loadScript(base + 'widget_others.js'); })
            .then(function () { return loadScript(base + 'widget_main.js'); })
            .then(function () { return loadScript(base + 'widget_media.js'); })
            .then(function () { return loadScript(base + 'widget_write_review_modal.js'); })
            .then(function () { return loadScript(base + 'widget_form.js'); })
            .then(function () {
              return waitFor(function () {
                return !!(window.jdgm && window.jdgm._WriteReviewModal);
              }, 6000);
            });
        })
        .catch(function () { return false; });
    })();

    return jmReady;
  }

  /* ---- keep Judge.me's slider aligned ----------------------------
     The modal is two nested horizontal tracks: an outer one holding
     three panels (intro / slider / thank-you), and inside the middle
     panel a second track holding the form steps. Each is positioned
     with transform: translateX(-100% x index).

     Opened from a page like this rather than from a product widget,
     the OUTER track stays at translateX(0) once the customer moves
     past the first step, so the panel holding the form sits a full
     width to the right and is clipped by the modal's content box.

     This re-derives both indexes from whichever page is marked
     current, so it is right on every step rather than only the one we
     know about, and it writes only when the value actually differs so
     it can never fight their own transition.                        */

  function alignSlider(mod) {
    if (!mod) return;
    var track  = mod.querySelector('.jdgm-write-review-modal__sections');
    var slider = mod.querySelector('.jdgm-write-review-modal__slider-container');
    var cur    = mod.querySelector('.jdgm-write-review-modal__page.current-page');
    if (!track || !cur) return;

    var panels = Array.prototype.slice.call(track.children);
    var panelIndex = -1;
    panels.forEach(function (p, i) { if (p.contains(cur)) panelIndex = i; });
    if (panelIndex < 0) return;

    var want = 'translateX(' + (-100 * panelIndex) + '%)';
    if (track.style.transform !== want) track.style.transform = want;

    if (slider && slider.contains(cur)) {
      var pages = Array.prototype.slice.call(
        slider.querySelectorAll('.jdgm-write-review-modal__page')
      ).filter(function (p) { return p.offsetWidth > 0 || p.offsetHeight > 0; });
      var i = pages.indexOf(cur);
      if (i >= 0) {
        var wantInner = 'translateX(' + (-100 * i) + '%)';
        if (slider.style.transform !== wantInner) slider.style.transform = wantInner;
      }
    }
  }

  function keepAligned() {
    var mod = document.querySelector('.jdgm-write-review-modal');
    if (!mod) return;
    alignSlider(mod);
    if (!window.MutationObserver) return;

    var pending = null;
    var run = function () { pending = null; alignSlider(mod); };
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(run, 60);
    });
    obs.observe(mod, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'data-page']
    });
    window.addEventListener('resize', run, { passive: true });

    var poll = setInterval(function () {
      if (!document.body.contains(mod)) {
        obs.disconnect();
        window.removeEventListener('resize', run);
        clearInterval(poll);
      }
    }, 2000);
  }

  function wireWriteButton(root) {
    var btn = root.querySelector('[data-pgcar-write]');
    if (!btn) return;
    var note = root.querySelector('[data-pgcar-writenote]');
    var fallback = btn.getAttribute('data-pgcar-write-fallback') || '';
    var busy = false;

    function say(msg) {
      if (!note) return;
      note.textContent = msg || '';
      note.hidden = !msg;
    }

    function giveUp() {
      busy = false;
      btn.disabled = false;
      if (fallback) { window.location.href = fallback; return; }
      say(btn.getAttribute('data-pgcar-write-error') || '');
    }

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      say(btn.getAttribute('data-pgcar-write-opening') || '');

      ensureJudgeme().then(function (ok) {
        if (!ok) return giveUp();

        var modal;
        try {
          modal = new window.jdgm._WriteReviewModal(window.jdgm.$);
        } catch (e) {
          return giveUp();
        }

        /* A store review is set up as pre-verified so the payload
           carries id = 0. That makes Judge.me start on step 2 and skip
           its own opening screen, which is where the track
           misalignment begins. Forcing step 1 gives the same opening
           screen their hosted page shows and starts both tracks at
           zero. */
        modal.setup(WIDGET_CLASS, 0, { isLeavingShopReview: true, isPreVerified: true })
          .then(function (good) {
            busy = false;
            btn.disabled = false;
            say('');
            if (!good) return giveUp();
            modal.showModalPage(1);
            keepAligned();
          })
          .catch(giveUp);
      });
    });
  }

  function init(root) {
    if (root.dataset.pgcarReady === '1') return;
    root.dataset.pgcarReady = '1';

    var cfg = {
      shop: root.dataset.shop,
      perPage: parseInt(root.dataset.perPage, 10) || 25,
      badgeMode: root.dataset.badgeMode || 'all',
      showPhotos: root.dataset.showPhotos === '1',
      showProduct: root.dataset.showProduct === '1',
      showDate: root.dataset.showDate === '1',
      showLocation: root.dataset.showLocation === '1',
      showTitle: root.dataset.showTitle === '1',
      verifiedLabel: root.dataset.verifiedLabel || '',
      collectedLabel: root.dataset.collectedLabel || '',
      photoAlt: root.dataset.photoAlt || '',
      zoomLabel: root.dataset.zoomLabel || '',
      moreLabel: root.dataset.moreLabel || 'Load more',
      loadingLabel: root.dataset.loadingLabel || '',
      endLabel: root.dataset.endLabel || '',
      errorLabel: root.dataset.errorLabel || '',
      emptyLabel: root.dataset.emptyLabel || ''
    };

    var list = root.querySelector('[data-pgcar-list]');
    var status = root.querySelector('[data-pgcar-status]');
    var controls = root.querySelector('[data-pgcar-controls]');
    var moreWrap = root.querySelector('[data-pgcar-more-wrap]');
    var moreBtn = root.querySelector('[data-pgcar-more]');
    var filterNote = root.querySelector('[data-pgcar-filternote]');
    var filterText = root.querySelector('[data-pgcar-filtertext]');
    var searchInput = root.querySelector('[data-pgcar-search]');
    var sortSelect = root.querySelector('[data-pgcar-sort]');
    if (!list || !moreBtn) return;

    var state = {
      type: root.dataset.firstTab || 'product-reviews',
      page: 1,
      sort: root.dataset.defaultSort || 'most-recent',
      rating: null,
      search: '',
      synced: false,
      busy: false,
      done: false,
      seen: Object.create(null)
    };

    wireWriteButton(root);

    if (controls) controls.hidden = false;
    Array.prototype.forEach.call(root.querySelectorAll('.pgcar__hist-row'), function (b) {
      b.disabled = false;
    });

    function url(page) {
      var u = new URL(ENDPOINT);
      u.searchParams.set('url', cfg.shop);
      u.searchParams.set('shop_domain', cfg.shop);
      u.searchParams.set('platform', 'shopify');
      u.searchParams.set('page', String(page));
      u.searchParams.set('per_page', String(cfg.perPage));
      u.searchParams.set('review_type', state.type);
      var sort = SORTS[state.sort] || SORTS['most-recent'];
      u.searchParams.set('sort_by', sort.by);
      if (sort.dir) u.searchParams.set('sort_dir', sort.dir);
      if (state.rating) u.searchParams.set('filter_rating', String(state.rating));
      if (state.search) u.searchParams.set('search', state.search);
      return u.toString();
    }

    function get(page) {
      return fetch(url(page), { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    /* ---- the columns ----

       Each card is appended to whichever column is shortest at the
       moment it goes in, so a card already on screen never moves when
       the next page loads. CSS multi-column cannot do that: it reflows
       the whole wall on every load-more.

       The card photo reserves its box with aspect-ratio, so the heights
       measured here are already correct before the images decode. */
    var cols = [];
    var lastColCount = 0;

    function colCount() {
      var wide = parseInt(root.dataset.cols, 10) || 4;
      var w = window.innerWidth;
      if (w <= 989) return Math.min(2, wide);
      if (w <= 1199) return Math.min(3, wide);
      return wide;
    }

    function buildColumns(n) {
      cols = [];
      for (var i = 0; i < n; i++) {
        var c = document.createElement('div');
        c.className = 'pgcar__col';
        c.setAttribute('role', 'presentation');
        list.appendChild(c);
        cols.push(c);
      }
      lastColCount = n;
    }

    function shortestCol() {
      var best = cols[0];
      for (var i = 1; i < cols.length; i++) {
        if (cols[i].offsetHeight < best.offsetHeight) best = cols[i];
      }
      return best;
    }

    function place(cards) {
      if (!cols.length) buildColumns(colCount());
      cards.forEach(function (c) { shortestCol().appendChild(c); });
    }

    /* Clearing the list detaches the cards; the array still holds them,
       so this moves them rather than rebuilding them. */
    function repack() {
      var cards = [];
      Array.prototype.forEach.call(
        list.querySelectorAll('.pgcar__card'),
        function (c) { cards.push(c); }
      );
      list.innerHTML = '';
      buildColumns(colCount());
      place(cards);
    }

    /* The cards Liquid rendered are direct children of the list. */
    repack();

    var colTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(colTimer);
      colTimer = setTimeout(function () {
        if (colCount() !== lastColCount) repack();
      }, 150);
    }, { passive: true });

    function cardsFrom(html) {
      var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
      var out = [];
      Array.prototype.forEach.call(doc.querySelectorAll('.jdgm-rev'), function (rev) {
        var id = rev.getAttribute('data-review-id');
        if (id && state.seen[id]) return;
        var card = buildCard(rev, cfg);
        if (!card) return;
        if (id) state.seen[id] = true;
        out.push(card);
      });
      return out;
    }

    function paint(html, replace) {
      if (replace) {
        list.innerHTML = '';
        cols = [];
        state.seen = Object.create(null);
      }
      var cards = cardsFrom(html);
      place(cards);
      observeCards();
      return cards.length;
    }

    // ---- entrance ----

    var io = null;
    var staggerMs = parseInt(root.dataset.motionStagger, 10) || 0;

    function revealAll() {
      Array.prototype.forEach.call(list.querySelectorAll('.pgcar__card'), function (c) {
        c.style.transitionDelay = '0ms';
        c.classList.add('pgcar__card--in');
      });
    }

    function observeCards() {
      if (!io) return;
      var n = 0;
      Array.prototype.forEach.call(
        list.querySelectorAll('.pgcar__card:not(.pgcar__card--in)'),
        function (c) {
          if (c.dataset.pgcarObs === '1') return;
          c.dataset.pgcarObs = '1';
          c.dataset.pgcarI = String(n++);
          io.observe(c);
        }
      );
    }

    function startMotion() {
      if (root.dataset.motion !== '1') return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      root.classList.add('pgcar--motion');
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = parseInt(en.target.dataset.pgcarI || '0', 10);
          en.target.style.transitionDelay = (Math.min(i, 7) * staggerMs) + 'ms';
          en.target.classList.add('pgcar__card--in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

      observeCards();

      // A background tab or an embedded preview pane can leave the observer
      // silent for as long as it is not displayed. Rather than hold a wall of
      // reviews at opacity 0 in that case, show everything.
      setTimeout(function () {
        if (!list.querySelector('.pgcar__card--in')) revealAll();
      }, 1800);
    }

    // ---- the viewer ----

    var lb = root.querySelector('[data-pgcar-lightbox]');
    var lbImg = lb ? lb.querySelector('[data-pgcar-lb-img]') : null;
    var lbClose = lb ? lb.querySelector('[data-pgcar-lb-close]') : null;
    var lastFocus = null;

    function openViewer(src, alt) {
      if (!lb || !lbImg) return;
      lastFocus = document.activeElement;
      lbImg.setAttribute('src', src);
      lbImg.setAttribute('alt', alt || '');
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }

    function closeViewer() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      lbImg.removeAttribute('src');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    if (lb) {
      // Out of the section and onto <body>, so no transformed ancestor can
      // turn its position: fixed into position: absolute.
      document.body.appendChild(lb);
      lb.addEventListener('click', closeViewer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') closeViewer();
      });

      // Delegated, so it covers the cards the server rendered and the ones
      // built from the API without rewiring anything.
      root.addEventListener('click', function (e) {
        var t = e.target;
        var btn = null;
        while (t && t !== root) {
          if (t.hasAttribute && t.hasAttribute('data-pgcar-full')) { btn = t; break; }
          t = t.parentNode;
        }
        if (!btn) return;
        e.preventDefault();
        var img = btn.querySelector('img');
        openViewer(btn.getAttribute('data-pgcar-full'), img ? img.alt : '');
      });
    }

    function counts(json) {
      [['product-reviews', json.number_of_product_reviews],
       ['shop-reviews', json.number_of_shop_reviews]].forEach(function (pair) {
        if (typeof pair[1] !== 'number') return;
        var node = root.querySelector('[data-pgcar-count="' + pair[0] + '"]');
        if (node) node.textContent = '(' + pair[1].toLocaleString() + ')';
      });
    }

    function setBusy(on) {
      state.busy = on;
      moreBtn.disabled = on;
      if (on) status.textContent = cfg.loadingLabel;
    }

    function finish() {
      if (!list.children.length) {
        status.textContent = cfg.emptyLabel;
      } else if (state.done) {
        status.textContent = cfg.endLabel;
      } else {
        status.textContent = '';
      }
      moreWrap.hidden = state.done || !list.children.length;
    }

    function reload() {
      if (state.busy) return;
      setBusy(true);
      state.page = 1;
      state.done = false;
      get(1).then(function (json) {
        counts(json);
        var added = paint(json.html || '', true);
        state.synced = true;
        if (!json.html || added < 1 || cfg.perPage > added) state.done = true;
        setBusy(false);
        finish();
      }).catch(function () {
        setBusy(false);
        status.textContent = cfg.errorLabel;
      });
    }

    function loadMore() {
      if (state.busy || state.done) return;
      setBusy(true);

      if (!state.synced) {
        // The server list came from the metafield cache, which can lag the
        // API. Take pages 1 and 2 from the API and replace it, so nothing
        // can appear twice at the seam.
        Promise.all([get(1), get(2)]).then(function (res) {
          counts(res[0]);
          paint((res[0].html || '') + (res[1].html || ''), true);
          state.page = 2;
          state.synced = true;
          if (!res[1].html) state.done = true;
          setBusy(false);
          finish();
        }).catch(function () {
          setBusy(false);
          status.textContent = cfg.errorLabel;
        });
        return;
      }

      var next = state.page + 1;
      if (next > MAX_PAGE) {
        state.done = true;
        setBusy(false);
        finish();
        return;
      }

      get(next).then(function (json) {
        var added = paint(json.html || '', false);
        state.page = next;
        if (!json.html || added === 0) state.done = true;
        setBusy(false);
        finish();
      }).catch(function () {
        setBusy(false);
        status.textContent = cfg.errorLabel;
      });
    }

    function showFilterNote() {
      if (!filterNote) return;
      var bits = [];
      if (state.rating) bits.push(state.rating + '★');
      if (state.search) bits.push('“' + state.search + '”');
      if (!bits.length) {
        filterNote.hidden = true;
        return;
      }
      if (filterText) filterText.textContent = bits.join(' · ');
      filterNote.hidden = false;
    }

    moreBtn.addEventListener('click', loadMore);
    moreWrap.hidden = false;

    Array.prototype.forEach.call(root.querySelectorAll('[data-pgcar-tab]'), function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-pgcar-tab');
        if (type === state.type) return;
        state.type = type;
        Array.prototype.forEach.call(root.querySelectorAll('[data-pgcar-tab]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        reload();
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-pgcar-rating]'), function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(btn.getAttribute('data-pgcar-rating'), 10);
        state.rating = state.rating === val ? null : val;
        Array.prototype.forEach.call(root.querySelectorAll('[data-pgcar-rating]'), function (b) {
          b.setAttribute('aria-pressed',
            state.rating !== null && b === btn ? 'true' : 'false');
        });
        showFilterNote();
        reload();
      });
    });

    var clearBtn = root.querySelector('[data-pgcar-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.rating = null;
        state.search = '';
        if (searchInput) searchInput.value = '';
        Array.prototype.forEach.call(root.querySelectorAll('[data-pgcar-rating]'), function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        showFilterNote();
        reload();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        reload();
      });
    }

    if (searchInput) {
      var timer = null;
      var run = function () {
        var v = searchInput.value.trim();
        if (v === state.search) return;
        state.search = v;
        showFilterNote();
        reload();
      };
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(run, 400);
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(timer);
          run();
        }
      });
    }

    startMotion();

    // No server-rendered reviews means the metafield was not readable.
    // Fall back to the API for the first page too.
    if (!list.children.length) reload();
  }

  function boot() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-pgcar-root]'), init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgc-chalk-difference"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_SELECTOR = '.pcd[data-pcd-animate="true"]';

  function reveal(root) {
    if (root.dataset.pcdReady === '1') return;
    root.dataset.pcdReady = '1';

    var items = root.querySelectorAll('[data-pcd-reveal]');
    if (!items.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* The hidden state lives behind this class, so a page whose script
       never runs shows everything rather than nothing. */
    root.classList.add('pcd--js');

    if (reduce || typeof IntersectionObserver === 'undefined') {
      for (var i = 0; i < items.length; i++) items[i].classList.add('pcd-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.pcdDelay || '0', 10);
        window.setTimeout(function () { el.classList.add('pcd-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    for (var j = 0; j < items.length; j++) {
      items[j].dataset.pcdDelay = String(j * 90);
      io.observe(items[j]);
    }

    /* Failsafe: anything still hidden after 2.5s is shown regardless. */
    window.setTimeout(function () {
      for (var k = 0; k < items.length; k++) items[k].classList.add('pcd-in');
    }, 2500);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) reveal(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgc-listicle-buybar"] && !Shopify.designMode) return;
  try {
    
/* The buy bar's own behaviour. Self-contained -- it shares nothing
   with pgc-listicle.js, so neither file can break the other.

   Three jobs:
     1. reveal the bar once the reader is past the opening,
     2. get out of the way over the closing call to action, which
        already carries the same button,
     3. keep the body's bottom padding equal to the bar's real height
        while it is showing.

   Scroll work is coalesced into one animation frame however many
   events arrive, and the listener is passive. */
(function () {
  'use strict';

  if (window.PgcListicleBuyBar) {
    return;
  }

  /* THE WINDOW LISTENERS ARE WIRED EXACTLY ONCE. The theme editor
     re-renders a section by replacing its markup, which throws away
     the old bar element but not anything bound to `window`. Re-running
     the whole setup on shopify:section:load would stack another scroll
     handler on every edit. `refresh()` re-finds the element instead;
     only `bar` and the observers are rebuilt. */
  var bar = null;
  var closingVisible = false;
  var revealAfter = 600;
  var shown = null;
  var queued = false;
  var sizeWatcher = null;
  var closingWatcher = null;

  function publishHeight() {
    if (!bar) {
      return;
    }
    document.documentElement.style.setProperty(
      '--pgcl-buybar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px'
    );
  }

  function sync() {
    queued = false;

    if (!bar) {
      document.body.classList.remove('pgcl-has-buybar');
      return;
    }

    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var want = y > revealAfter && !closingVisible;

    if (want === shown) {
      return;
    }
    shown = want;

    /* Measured on the way in: the bar may have been off screen when
       its thumbnail landed or the breakpoint changed. */
    if (want) {
      publishHeight();
    }
    bar.classList.toggle('is-in', want);
    document.body.classList.toggle('pgcl-has-buybar', want);
  }

  function onScroll() {
    if (queued) {
      return;
    }
    queued = true;
    window.requestAnimationFrame(sync);
  }

  function refresh() {
    if (sizeWatcher) { sizeWatcher.disconnect(); sizeWatcher = null; }
    if (closingWatcher) { closingWatcher.disconnect(); closingWatcher = null; }

    bar = document.querySelector('[data-pgcl-buybar]');
    shown = null;
    closingVisible = false;

    if (!bar) {
      document.body.classList.remove('pgcl-has-buybar');
      return;
    }

    var configured = parseInt(bar.getAttribute('data-pgcl-reveal'), 10);
    revealAfter = isNaN(configured) ? 600 : configured;

    /* The closing band, if the article has one. Nothing to configure:
       the bar looks for it, and simply never hides early if it is not
       there. */
    var closing = bar.getAttribute('data-pgcl-hide-over-cta') === '1'
      ? document.querySelector('.pgcl-cta')
      : null;

    if (closing && window.IntersectionObserver) {
      closingWatcher = new window.IntersectionObserver(function (entries) {
        closingVisible = entries[entries.length - 1].isIntersecting;
        sync();
      }, { threshold: 0 });
      closingWatcher.observe(closing);
    }

    /* Height is measured, never assumed: it moves with the breakpoint,
       with the thumbnail arriving and with a longer price string. */
    if (window.ResizeObserver) {
      sizeWatcher = new window.ResizeObserver(publishHeight);
      sizeWatcher.observe(bar);
    }

    publishHeight();
    sync();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { publishHeight(); onScroll(); });
  window.addEventListener('load', function () { publishHeight(); sync(); });
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  window.PgcListicleBuyBar = { refresh: refresh, sync: sync, measure: publishHeight };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pristine-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('pristine-potshot-motion')) return;

    function clamp01(n) {
      return n < 0 ? 0 : n > 1 ? 1 : n;
    }

    function clamp(n, lo, hi) {
      return n < lo ? lo : n > hi ? hi : n;
    }

    function num(value, fallback) {
      var n = parseFloat(value);
      return isNaN(n) ? fallback : n;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function easeOutQuint(t) {
      return 1 - Math.pow(1 - t, 5);
    }

    function smoothstep(t) {
      return t * t * (3 - 2 * t);
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class PristineIwtMotion extends HTMLElement {
      connectedCallback() {
        if (this.setUp) return;
        this.setUp = true;

        this.track = this.querySelector('[data-pj-track]');
        this.view = this.querySelector('[data-pj-view]');
        this.content = this.querySelector('.pristine-potshot__content');
        this.anchorEl = this.querySelector('[data-pj-anchor]');
        this.roller = this.querySelector('[data-pj-roller]');
        this.inner = this.querySelector('[data-pj-inner]');
        this.sheen = this.querySelector('[data-pj-sheen]');
        this.cueball = this.querySelector('[data-pj-cueball]');
        this.spot = this.querySelector('[data-pj-spot]');
        this.striker = this.querySelector('[data-pj-strike]');
        this.passer = this.querySelector('[data-pj-pass]');
        this.impact = this.querySelector('[data-pj-impact]');
        this.pocket = this.querySelector('[data-pj-pocket]');
        this.pocketMouth = this.querySelector('[data-pj-pocket-mouth]');
        this.textItem = this.querySelector('[data-pj-text]');

        this.readSettings();

        this.rollActive = this.dataset.roll === '1' && !!this.roller && !!this.inner;
        this.strikeActive = !!this.striker;
        this.passActive = !!this.passer;
        this.textActive = this.dataset.text === '1' && this.prepareText();

        if (prefersReducedMotion()) {
          // A static rod across the section is a graphic, not motion.
          if (this.passActive) {
            this.passer.style.opacity = String(this.passOpacity);
            this.passer.style.transform = 'rotate(' + this.passAngle + 'deg)';
          }
          return;
        }

        if (!this.rollActive && !this.strikeActive && !this.passActive && !this.textActive) {
          return;
        }

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.measure();
        this.update();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        // A late web font changes the text column's height, which moves
        // the media column's centre when they are centre-aligned.
        if (document.fonts && document.fonts.ready) {
          var self = this;
          document.fonts.ready.then(function () {
            self.settle();
          });
        }

        /* WATCH THE CONTENT'S HEIGHT, and re-decide.

           Whether this section can pin comes down to whether its content
           fits one screen, and that was settled once on load. Measured
           before layout has finished the content reads taller than it is,
           the pin is refused, and nothing ever asks again -- so the whole
           timeline falls back to the unpinned mapping with no sign of why.
           That is what made the animation feel like it only began once the
           section reached the middle of the screen. */
        if (window.ResizeObserver && this.content) {
          var ro = this;
          this.ro = new ResizeObserver(function () {
            var h = ro.content.offsetHeight;
            if (ro.lastContentH !== undefined && Math.abs(h - ro.lastContentH) < 6) return;
            ro.lastContentH = h;
            ro.onResize();
          });
          this.ro.observe(this.content);
        }

        /* SETTLE PASSES. fonts.ready resolves instantly when the fonts are
           already cached -- the common case -- which lands the decision
           right back in the same too-early moment. So it is simply re-taken
           at a few fixed points: after layout, after load, and once more
           late enough for an app that injects itself into the page. Three
           measures over the first second, nothing per frame. */
        this.settle();
        var me = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            me.settle();
          });
        });
        if (document.readyState === 'complete') {
          setTimeout(function () {
            me.settle();
          }, 400);
        } else {
          window.addEventListener(
            'load',
            function () {
              me.settle();
              setTimeout(function () {
                me.settle();
              }, 400);
            },
            { once: true }
          );
        }
      }

      // Re-measure and repaint from wherever the page currently is.
      settle() {
        this.measure();
        this.lastSig = undefined;
        this.update();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.resizeTimer);
        if (this.ro) this.ro.disconnect();
      }

      readSettings() {
        var d = this.dataset;

        this.anchor = clamp(num(d.anchor, 50), 20, 80);

        /* Four breakpoints now, enforced strictly increasing so a bad
           settings combination cannot make the phases overlap:

             0 .. CONTACT   ball parked at the corner, shaft driving in
             CONTACT        the strike
             .. ARRIVE      ball rolls and grows into place
             .. LEAVE       settled, readable
             .. 1           flung out to the exit corner              */
        this.tContact = clamp(num(d.contact, 10) / 100, 0.04, 0.44);
        this.tArrive = clamp(num(d.arrive, 38) / 100, this.tContact + 0.1, 0.82);
        /* The fallback only. When the passing shaft is set to trigger the
           exit, tLeave is DERIVED during measurement from where that
           shaft's tip crosses the image -- see measureShaft. */
        this.tLeaveBase = clamp(num(d.leave, 70) / 100, this.tArrive + 0.06, 0.97);
        this.tLeave = this.tLeaveBase;

        this.ballSize = Math.max(16, num(d.ball, 96));
        this.ballInset = Math.max(0, num(d.ballInset, 72));
        this.bounceAt = clamp(num(d.bounceAt, 45) / 100, 0.1, 0.85);
        this.bounceDrop = clamp(num(d.bounceDrop, 30) / 100, 0, 1);
        this.pocketSize = Math.max(40, num(d.pocketSize, 160));
        this.pocketInset = Math.max(0, num(d.pocketInset, 60));
        this.flashMax = clamp(num(d.flash, 0.45), 0, 1);
        this.shaftAccel = clamp(num(d.shaftAccel, 2.4), 1, 5);
        this.spinMult = clamp(num(d.spin, 1), 0, 4);
        // The settled corner radius. The morph interpolates between this
        // and half the box, which is the value that draws a circle.
        this.frameR = Math.max(0, num(d.radius, 16));

        this.corner = d.corner === 'tl' ? 'tl' : 'tr';
        this.exitCorner = ['tl', 'tr', 'bl', 'br'].indexOf(d.exitCorner) > -1 ? d.exitCorner : 'br';

        this.pinWanted = d.pin === '1';
        this.pinMobile = d.pinMobile === '1';
        this.shaftScale = clamp(num(d.shaftScale, 100), 40, 300) / 100;
        this.holdZoom = clamp(num(d.holdZoom, 3), 0, 20) / 100;
        this.passHit = d.passHit === '1';
        this.passHitOffset = num(d.passHitOffset, 0);
        this.pinned = false;

        // The striker.
        this.shaftNudge = num(d.shaftLead, 0);
        this.shaftAngle = num(d.shaftAngle, 0);
        this.shaftOpacity = clamp(num(d.shaftOpacity, 0.95), 0, 1);

        /* The passer borrows the striker's look outright -- same angle,
           same opacity, same everything the CSS already shares. Only its
           placement and window are its own. */
        this.passAngle = this.shaftAngle;
        this.passOpacity = this.shaftOpacity;
        this.passAim = d.passAnchor === 'fixed' ? 'fixed' : 'text';
        this.passGap = num(d.passGap, 24);
        this.passYPct = clamp(num(d.passY, 68), 0, 100);
        this.passStart = clamp(num(d.passStart, 28) / 100, 0, 0.9);
        this.passEnd = clamp(num(d.passEnd, 96) / 100, this.passStart + 0.08, 1);

        this.strikeY = 0;
        this.passY = 0;
      }

      /* ----------------------------------------------------------------
         GEOMETRY

         Everything the roll needs is derived here, once, from the real
         layout box -- transforms stripped for one frame so we read the
         settled size rather than whatever the roll last left behind.
      ---------------------------------------------------------------- */
      /* Pin or don't, decided before anything is measured -- the decision
         changes the layout, so every rect read afterwards depends on it.

         Two reasons to refuse. The view is exactly one screen tall, so
         content taller than that would be cropped top and bottom with no
         way to reach it; falling back to normal flow shows all the copy,
         which matters more than the effect. And pinning on a phone hijacks
         a short screen for several swipes, so it is opt-in there. */
      decidePin() {
        if (!this.pinWanted || !this.track || !this.content) return;

        /* TRY THE PIN ON BEFORE MEASURING IT.

           The pinned state is what reclaims the section padding, so
           measuring the content while unpinned reports a height that
           includes space pinning would have taken back -- and refuses
           layouts that would in fact have fitted. Applying it first and
           reverting on a genuine overflow costs one forced layout on load
           and nothing per frame. */
        this.track.classList.add("pristine-potshot__track--pinned");
        var ch = this.content.offsetHeight;
        var fits = ch <= window.innerHeight - 8;
        if (!fits) this.track.classList.remove("pristine-potshot__track--pinned");
        var allowed = this.pinMobile || window.innerWidth >= 750;
        var pin = fits && allowed;

        /* A REFUSED PIN IS OTHERWISE COMPLETELY SILENT.

           Without the pin this section plays its whole sequence over about
           two screens instead of twenty, and there is nothing on the page
           to say why -- it simply feels rushed, and no amount of raising
           the scroll setting changes it, because that setting only applies
           while pinned. Worth one console line. */
        if (!pin && allowed && !this.warnedPin && window.console && console.info) {
          this.warnedPin = true;
          console.info(
            '[Pristine Image with Text] Scroll pinning skipped: the content is ' +
              ch +
              'px tall against a ' +
              window.innerHeight +
              'px window, so it will not fit a single screen. The section plays' +
              ' over about two screens instead of twenty, and "Extra scroll' +
              ' distance" has no effect. Shorten it, or give the window ' +
              (ch + 8 - window.innerHeight) +
              'px more height.'
          );
        }

        if (pin === this.pinned) return;
        this.pinned = pin;
        this.track.classList.toggle('pristine-potshot__track--pinned', pin);
      }

      measure() {
        this.decidePin();

        if (!this.rollActive) {
          this.measureShaft();
          return;
        }

        this.roller.classList.add('pristine-potshot__roller--measuring');

        var rect = this.roller.getBoundingClientRect();
        var w = rect.width || 1;
        var h = rect.height || 1;
        var vw = window.innerWidth;

        this.roller.classList.remove('pristine-potshot__roller--measuring');

        this.w = w;
        this.h = h;

        /* SQUASH FACTORS.

           A uniform scale keeps a 3:2 box a 3:2 box, so it can never be
           a circle. Squashing the LONG axis until the box is square is
           what makes border-radius able to draw a circle at all:

               qx = h/w   (landscape)      qy = w/h   (portrait)

           On its own that would also squash the photograph. So the media
           inside gets the exact inverse on the same axis. Child
           transforms compose INSIDE the parent's, so the two scales
           cancel for the image while leaving the frame square:

               frame = T . R . Scale(S*qx, S*qy)
               image = frame . Scale(1/qx, 1/qy) = T . R . Scale(S, S)

           The frame is a square the image overflows, and overflow:hidden
           crops the excess -- so the result is a perfect circular crop
           of an undistorted, uniformly shrunk photograph. */
        if (w >= h) {
          this.qx = h / w;
          this.qy = 1;
        } else {
          this.qx = 1;
          this.qy = w / h;
        }

        /* THE SAME BALL AS THE JOINT SECTION.

           These two sections sit on the same page and show the same
           object, so a cue ball that is one size in one and another size in
           the other reads as a mistake however well each is judged on its
           own. 96px is the joint section's diameter, and everything about
           the cue here is derived from it, so the pair match down to the
           thickness of the shaft.

           Proportioning it to the artwork instead was the obvious idea and
           the wrong one: it made a handsome ball in isolation and a
           mismatched one in context. If you change the joint section's Ball
           diameter, change this to match.

           The panel value still applies as a floor, so it can be made
           larger, never smaller than the ball it is meant to match. */
        var JOINT_BALL = 96;
        var minDim = Math.min(w, h);
        var wanted = Math.max(this.ballSize, JOINT_BALL);
        this.ballScale = clamp(wanted / minDim, 0.02, 1);
        this.ballD = minDim * this.ballScale;

        this.sizeShaft();

        /* THE PATH.

           Measured against the SECTION box, not the viewport, so the ball
           enters from the section's own top-left corner rather than from
           wherever the window edge happens to be. That matters because
           the section is page-width: a viewport-relative start would put
           the ball a different distance out on every screen size.

           Distances are to the BALL's edge, not the frame's, since it is
           small at both ends of the roll. */
        /* Measured against the VIEW, not the track.

           Once pinned, the track is several screens tall while the view
           is exactly one screen. Corner offsets taken from the track
           would send the ball two extra screens out of frame. The view is
           the box the visitor actually sees, so it is the box the corners
           belong to. */
        var box = (this.view || this).getBoundingClientRect();
        var cx = rect.left - box.left + w / 2;
        var cy = rect.top - box.top + h / 2;
        var pad = this.ballD / 2 + 40;

        // The image's left edge in view coordinates -- the line the
        // passing shaft's tip has to clear to knock the ball loose.
        this.imgLeft = rect.left - box.left;

        // Offsets that put the ball fully outside each edge of the view.
        var offRight = box.width - cx + pad;
        var offLeft = -(cx + pad);
        var offTop = -(cy + pad);
        var offBottom = box.height - cy + pad;

        /* PARKED POSITION -- inside the corner, not beyond it.

           The ball has to be visible sitting there waiting to be hit, so
           the entrance offset is measured to a spot INSET from the corner
           rather than to a point off-screen. Kept in view coordinates as
           well, because the shaft has to aim at it and the impact bloom
           has to be placed on it. */
        var r = this.ballD / 2;
        this.parkX = this.corner === 'tl' ? this.ballInset + r : box.width - this.ballInset - r;
        this.parkY = this.ballInset + r;

        this.inX = this.parkX - cx;
        this.inY = this.parkY - cy;

        /* THE CUSHION.

           Struck, the ball crosses to the OPPOSITE wall, rebounds, and
           only then heads for its column. Two segments, so the wall is a
           real waypoint rather than a curve in a single path -- which
           matters because the rebound has to reverse the spin, and a
           single path cannot do that. */
        var wallX = this.corner === 'tl' ? box.width - r - 8 : r + 8;
        var wallY = this.parkY + (cy - this.parkY) * this.bounceDrop;
        this.bX = wallX - cx;
        this.bY = wallY - cy;

        /* THE POCKET.

           With one on the table the exit aims INTO its mouth instead of
           past the corner, so the ball is potted rather than merely
           leaving. Without one, the old off-screen corner targets. */
        var ex = this.exitCorner;

        if (this.pocket) {
          /* THE POCKET HAS TO BE WIDER THAN THE BALL.

             The two jaw tips sit about 0.46 of the pocket apart on each
             axis, so the opening between them is 0.65 of its width. At 130
             the opening was 85px against a 96px ball -- the ball was wider
             than the hole it was being asked to enter, so it could not pass
             between the jaws and rode the cushion instead. No amount of
             re-aiming fixes a gap the ball does not fit through.

             A real corner pocket mouth is about twice the ball. Floored at
             2.6 times the ball diameter, the opening comes out at 1.7 balls
             wide -- enough to pass cleanly with a third of a ball to spare
             on each side. */
          var ps = Math.max(this.pocketSize, this.ballD * 2.6);

          /* THE WHOLE POCKET HAS TO BE ON SCREEN.

             The inset is measured to the pocket's CENTRE, so anything less
             than its own radius hangs the rest of it over the edge -- at an
             inset of 10 against a 130px pocket, most of the hole was
             outside the section and the ball dropped into something you
             could barely see. Held to at least the radius, the pocket
             finishes exactly at the edge at worst. */
          var inset = Math.max(this.pocketInset, ps / 2);

          var px =
            ex === 'bc'
              ? box.width / 2
              : ex === 'tl' || ex === 'bl'
                ? inset
                : box.width - inset;
          var py = ex === 'tl' || ex === 'tr' ? inset : box.height - inset;
          this.pocketX = px;
          this.pocketY = py;


          this.pocket.style.width = ps + 'px';
          this.pocket.style.height = ps + 'px';
          this.pocket.style.left = (px - ps / 2).toFixed(1) + 'px';
          this.pocket.style.top = (py - ps / 2).toFixed(1) + 'px';

          /* THE MOUTH GOES FURTHER OUT THAN THE RAILS.

             Pushed a third of its own width toward the corner along both
             axes, so roughly a third of the opening falls outside the
             section and the edge cuts it. That is what a corner pocket
             looks like from above, and it is also what lets the ball
             disappear without any fading: it rolls into the corner and the
             section clips it. */
          var outward = ps * 0.34;
          var mx = px + (ex === 'tl' || ex === 'bl' ? -outward : outward);
          var my = py + (ex === 'tl' || ex === 'tr' ? -outward : outward);
          this.mouthX = mx;
          this.mouthY = my;

          /* THE HOLE IS THE SIZE OF THE OPENING, not of the box.

             The box is sized so a ball fits between the jaws, which makes
             it a good deal larger than the hole wants to look. Drawing the
             mouth at the full box turned the corner into a big dark disc.

             The opening between the jaw tips is 0.65 of the box, so the
             mouth is drawn a shade over that -- big enough to swallow the
             ball, small enough to read as a pocket rather than a crater. */
          var ms = ps * 0.72;

          if (this.pocketMouth) {
            this.pocketMouth.style.width = ms.toFixed(1) + 'px';
            this.pocketMouth.style.height = ms.toFixed(1) + 'px';
            this.pocketMouth.style.left = (mx - ms / 2).toFixed(1) + 'px';
            this.pocketMouth.style.top = (my - ms / 2).toFixed(1) + 'px';
          }

          /* THE BALL ROLLS TO THE JAWS, NOT TO THE HOLE.

             Aiming at the mouth was wrong, and visibly so: the mouth sits
             out past the corner, the cushions run between, and a straight
             line to it crosses the bottom rail. On a 613px section the
             mouth centre lands 13px BELOW the rail's top edge, so the ball
             rode over the cushion on its way in -- which is the one thing
             that never happens on a table.

             The rails' anchor is the right target. It sits in the gap
             between the two jaw tips, 31px clear of the rail edge, on the
             cloth -- so the ball can reach it without touching a cushion,
             and it arrives through the opening the way a potted ball
             actually does. */
          this.outX = px - cx;
          this.outY = py - cy;

          /* AND THEN IT DROPS DOWN THE POCKET'S OWN LINE.

             Not along its approach: a ball that reaches the jaws stops
             being steered by where it came from and falls into the hole,
             which from above means straight down the corner diagonal.
             Taking the direction from the corner rather than from the
             incoming path is what separates dropping in from skidding
             past.

             Far enough to be completely out of sight: to the mouth centre,
             then a further ball's width, so nothing is left showing at the
             edge. A sliver reads as a rendering fault rather than as a ball
             in a hole. */
          var dgx = ex === 'tl' || ex === 'bl' ? -1 : 1;
          var dgy = ex === 'tl' || ex === 'tr' ? -1 : 1;
          var diag = Math.SQRT1_2;
          /* Far enough to be gone, solved rather than guessed: the distance
             from the jaw gap to the section corner, plus a ball. A fixed
             multiple of the pocket left an eight-pixel crescent showing at
             the corner, which reads as a rendering fault rather than as a
             ball in a hole -- and it shifts with the pocket size, so a
             constant was never going to hold. */
          var toCorner = Math.hypot(
            ex === 'tl' || ex === 'bl' ? px : box.width - px,
            ex === 'tl' || ex === 'tr' ? py : box.height - py
          );
          var dropDist = toCorner + this.ballD;

          this.dropX = dgx * diag * dropDist;
          this.dropY = dgy * diag * dropDist;
        } else {
          this.outX = ex === 'bc' ? 0 : ex === 'tl' || ex === 'bl' ? offLeft : offRight;
          this.outY = ex === 'tl' || ex === 'tr' ? offTop : offBottom;
        }

        /* ROLLING ROTATION.

           A ball rolling without slipping turns once per circumference
           travelled, so the revolution count is path length / (pi * d) --
           not an arbitrary spin value. Now that the path is diagonal the
           length is the hypotenuse, not one axis.

           Rounding to a WHOLE number of turns is what makes the frame
           land square without a separate corrective tween: at the end of
           the roll the rotation is an exact multiple of 360 degrees,
           which is visually identical to zero. */
        var circumference = Math.PI * this.ballD;
        var turns = (dist) => Math.max(1, Math.round((dist / circumference) * this.spinMult));

        var d1 = Math.hypot(this.bX - this.inX, this.bY - this.inY);
        var d2 = Math.hypot(this.bX, this.bY);
        var revs1 = turns(d1);
        var revs2 = turns(d2);
        this.revsOut = turns(Math.hypot(this.outX, this.outY));

        /* The two travelling distances, kept for the timeline. Scroll is
           handed out in proportion to these, which is what keeps the ball
           moving at one steady rate rather than crawling through one phase
           and bolting through another. */
        this.pathIn = d1 + d2;
        this.pathOut = Math.hypot(this.outX, this.outY);

        /* ROTATION KEYFRAMES, worked backwards from the landing.

           The frame must sit upright once settled, so the end of segment
           two is 0. Segment two travels toward home, so its direction
           sets how much rotation has to be standing at the cushion; and
           segment one travels the other way, so it starts further back
           still. Both keyframes come out as exact multiples of 360, which
           is why the parked ball and the settled frame are both square
           without anything having to correct them.

           The sign flip between the two segments IS the rebound: a real
           ball reverses its spin when it comes off a cushion. */
        var s1 = Math.sign(this.bX - this.inX) || 1;
        var s2 = Math.sign(-this.bX) || -1;

        this.rot1 = -s2 * revs2 * 360;
        this.rot0 = this.rot1 - s1 * revs1 * 360;

        // Place and size the impact bloom once. Only opacity animates.
        if (this.impact) {
          var flash = this.ballD * 4;
          this.impact.style.width = flash + 'px';
          this.impact.style.height = flash + 'px';
          this.impact.style.left = (this.parkX - flash / 2).toFixed(1) + 'px';
          this.impact.style.top = (this.parkY - flash / 2).toFixed(1) + 'px';
        }

        this.measureShaft();
      }

      /* HALF-EXTENT, not half-thickness.

         A tilted rod is far taller than it is thick: a 1300px shaft at
         only 3 degrees sweeps about 68px of vertical space. Clearing the
         text by half the THICKNESS would still put the high end of the
         rod straight through the last line of copy, so any clearance test
         has to use the full vertical reach of the rotated rod.

         This is also why both shafts only ever translate horizontally:
         with a constant Y, one measurement holds at every scroll
         position. A vertical component would need re-checking per frame. */
      reachOf(el, angleDeg) {
        return (
          (el.offsetWidth * Math.abs(Math.sin((angleDeg * Math.PI) / 180)) + el.offsetHeight) / 2
        );
      }

      measureShaft() {
        // The view, not the track: both shaft layers are inset to the
        // view, so their coordinates belong in the same box.
        var stage = (this.view || this).getBoundingClientRect();

        if (this.strikeActive) {
          /* STRIKE GEOMETRY.

             The rod is centred in the view and its tip is its left end,
             so at translateX = 0 the tip sits at (viewWidth - length)/2 --
             usually a long way off-screen left, since the rod is wider
             than the section. Every keyframe is therefore expressed as
             "where do I want the TIP, minus where the tip already is". */
          var sLen = this.striker.offsetWidth;
          this.strike = this.rollActive && this.parkX !== undefined;

          if (this.strike) {
            /* MIRRORED when the ball is parked on the left.

               The artwork's tip is its left end. Coming from the left the
               rod travels rightward, so its LEADING edge has to be the
               tip -- otherwise the cue arrives butt-first. scaleX(-1)
               flips it, which also swaps which end of the box the tip
               sits at, so the arithmetic below flips with it. */
            this.mirror = this.corner === 'tl';

            var leftEnd = stage.width / 2 - sLen / 2;
            var rightEnd = stage.width / 2 + sLen / 2;

            /* IT LEAVES THE WAY IT ARRIVED.

               sxEnd used to be the far side of the section, so the striker
               drove through the ball and carried on clean across -- which
               is a rod passing through, not a shot. A cue goes in, makes
               contact and comes back out along its own line; only the lower
               shaft is meant to cross.

               So the end point is now just past where it started, on the
               same side. 160px beyond is enough to be fully clear at any
               rod angle. */
            if (this.mirror) {
              // Tip is the right end; meet the ball's left edge.
              this.sxContact = this.parkX - this.ballD / 2 - this.shaftNudge - rightEnd;
              this.sxStart = -rightEnd - 240;
              this.sxEnd = this.sxStart - 160;
            } else {
              // Tip is the left end; meet the ball's right edge.
              this.sxContact = this.parkX + this.ballD / 2 + this.shaftNudge - leftEnd;
              this.sxStart = stage.width + 240 - leftEnd;
              this.sxEnd = this.sxStart + 160;
            }

            this.strikeY = this.parkY;
          } else {
            // Nothing to hit -- park it out of the way rather than
            // leaving a rod stranded mid-section.
            this.sxStart = this.sxContact = this.sxEnd = stage.width + sLen;
            this.strikeY = stage.height / 2;
          }
        }

        if (this.passActive) {
          /* PASS GEOMETRY. Symmetric: fully clear of the right edge at
             one end, fully clear of the left at the other. */
          var pLen = this.passer.offsetWidth;
          this.passIn = stage.width / 2 + pLen / 2 + 60;
          this.passOut = this.passIn;

          if (this.passAim === 'text' && this.textItem) {
            var text = this.textItem.getBoundingClientRect();
            this.passY =
              text.bottom - stage.top + this.reachOf(this.passer, this.passAngle) + this.passGap;
          } else {
            this.passY = (stage.height * this.passYPct) / 100;
          }

          /* THE SECOND STRIKE.

             The exit is no longer a number someone picked -- it is solved
             for. Find the scroll progress at which this shaft's tip
             crosses the image's left edge, and make that the instant the
             ball is knocked loose. So the rod visibly drives through and
             the ball leaves because it was hit, rather than the two
             merely happening to coincide.

             Running the tip equation backwards is all it takes:
               tip(tx) = tipAtZero + tx        (tip is the rod's left end)
               tx(p)   = passIn - p * (passIn + passOut)
             solve tip = target for p, then map p back onto u. */
          if (this.passHit && this.imgLeft !== undefined) {
            var tipAtZero = stage.width / 2 - pLen / 2;
            var txAtHit = this.imgLeft + this.passHitOffset - tipAtZero;
            // Fraction of its TRAVEL completed at the hit -- geometry only.
            var fAtHit = clamp01((this.passIn - txAtHit) / (this.passIn + this.passOut));
            /* Fraction of its WINDOW completed at the hit. These differ
               because the rod accelerates: travel = pow(progress, accel),
               so the progress that produces a given travel is the accel-th
               root of it.

               This is what lets the rod enter early -- keeping the hold
               alive -- while its tip still does not reach the image until
               late in the timeline, near where the pin releases. Slow
               approach, sudden contact: the same curve that makes the
               stroke look real is the one that fixes the timing. */
            var pAtHit = Math.pow(fAtHit, 1 / this.shaftAccel);
            var uAtHit = this.passStart + pAtHit * (this.passEnd - this.passStart);
            this.uAtHit = uAtHit;
            this.tLeave = clamp(uAtHit, this.tArrive + 0.06, 0.97);
          } else {
            this.tLeave = this.tLeaveBase;
          }
        } else {
          this.tLeave = this.tLeaveBase;
        }

        this.balanceTimeline();
      }

      /* THE THREE PHASES, IN SCREENS OF SCROLL.

         Measured on a nine-screen pass, the shape was wrong end up:

           entrance  4.1 screens
           hold      0.8
           roll-out  4.0

         Four screens of the ball merely arriving, and then under a screen
         of it settled before it was knocked away again -- which is why it
         never seemed to rest in the middle, and why the pot went by too
         quickly to follow.

         Both are re-solved here as fractions of a screen rather than of the
         pass, so they hold at any pin length and any zoom. The roll-out is
         claimed first because it carries the pot, then the hold, and the
         entrance gets what is left -- which is still the better part of
         three screens. Nothing here can push the ending off the top: the
         run-on already fixes u = 1 at half the section still showing. */
      balanceTimeline() {
        if (!this.pinned || !this.track) return;

        var vh = window.innerHeight;
        var lead = clamp(vh - (this.view ? this.view.offsetHeight : vh) * (this.anchor / 100), 0, vh);
        var total = lead + (this.track.offsetHeight - vh) + vh * 0.5;
        if (total <= 0) return;

        var screenU = clamp01(vh / total);

        // The way out: enough to see the ball slow, drop and disappear.
        var exitU = Math.min(0.5, screenU * 4.5);
        this.tLeave = Math.min(this.tLeave, 1 - exitU);

        /* SCROLL SHARED OUT BY DISTANCE.

           Every previous attempt at this gave one phase a fixed share and
           let another absorb whatever was left, and the leftover phase was
           always the one that felt wrong -- first the roll in at 870px per
           screen, then at 218 once the pass got longer. Either way the ball
           was travelling at a different rate in each phase, which is what
           reads as badly paced however much total scroll it is given.

           So the two moving phases now split the moving time in proportion
           to how far each actually travels. That makes the scroll-to-motion
           ratio the SAME in both -- one steady rate for the whole section,
           which is what the joint section does and why it feels responsive.

           The exit is weighted a little heavier because it carries the pot,
           and that is worth dwelling on. */
        /* The park is the cue driving in with the ball still still. It is
           the only phase with nothing of the ball in it, so it is kept
           short -- long enough to see the rod arrive, not long enough to
           wait through. */
        var parkU = 0.06;
        var holdU = 0.14;

        var inW = Math.max(1, this.pathIn || 1);
        var outW = Math.max(1, this.pathOut || 1) * 1.35;
        var share = inW / (inW + outW);

        var moveU = 1 - parkU - holdU;
        this.tContact = parkU;
        this.tArrive = parkU + moveU * share;
        this.tLeave = this.tArrive + holdU;

        /* KEEP THE SECOND STRIKE HONEST.

           The exit used to be set by solving where the passing rod's tip
           crosses the image -- so the ball left because it was hit. Setting
           it here would break that, unless the rod is moved to suit: so the
           whole pass window slides by however far the two disagree, and the
           tip arrives exactly as the ball goes. Same physical link, from the
           other direction. */
        if (this.passActive && this.uAtHit !== undefined) {
          var shift = this.tLeave - this.uAtHit;
          this.passStart = clamp(this.passStart + shift, 0, 0.9);
          this.passEnd = clamp(this.passEnd + shift, this.passStart + 0.08, 1);
        }

        // The entrance keeps whatever is left, never less than a screen.
        this.tContact = Math.min(this.tContact, Math.max(0.04, this.tArrive - screenU));
      }


      /* HOW BIG THE CUE IS.

         Solved here rather than in the stylesheet because both inputs are
         only known at runtime: the ball is sized from the artwork, and a
         photographed shaft brings its own aspect ratio.

         THICKNESS comes from the ball -- 52.5% of its diameter at the
         butt, which is a real cue against a real cue ball -- times the
         slider. The slider exists because a photograph is not a
         measurement: crop, perspective and transparent margins all change
         how thick the shaft LOOKS inside its own file, and nothing in the
         geometry can know that. It is the one number here that is a
         matter of judgement rather than arithmetic.

         LENGTH follows the photo. The strike geometry aims the box\u2019s end
         at the ball, so the picture has to reach that end; taking the
         length from the image\u2019s own aspect ratio is what makes the two
         agree. Without a photo it falls back to the drawn rod\u2019s 26 ball
         diameters.

         This used to be two lines that set the length from the ball
         regardless, which quietly undid the aspect ratio worked out in
         Liquid and stretched every uploaded shaft to nearly 50:1 -- thin,
         and nothing like the photo. */
      sizeShaft() {
        var host = this.closest('[class*=pristine-potshot--]') || this;
        var thick = this.ballD * 0.525 * (this.shaftScale || 1);

        var img = this.striker && this.striker.querySelector('img');
        if (!img) img = this.passer && this.passer.querySelector('img');

        var len;
        if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
          len = thick * (img.naturalWidth / img.naturalHeight);
          // A near-square upload would otherwise be a stub rather than a rod.
          len = Math.max(len, thick * 8);
        } else {
          len = this.ballD * 25.7;

          /* The photo has not decoded yet, so its ratio is not knowable.
             Measure again when it is -- once, and only if it was actually
             pending, which is the difference between a correction and a
             loop. */
          if (img && !this.shaftPending) {
            this.shaftPending = true;
            var me = this;
            img.addEventListener(
              'load',
              function () {
                me.settle();
              },
              { once: true }
            );
          }
        }

        // A cushion is about four tenths of a ball deep from above.
        host.style.setProperty('--pk-rail', (this.ballD * 0.42).toFixed(1) + 'px');
        host.style.setProperty('--sh-thick', thick.toFixed(1) + 'px');
        host.style.setProperty('--sh-len', len.toFixed(0) + 'px');
      }
      /* ----------------------------------------------------------------
         THE ROLL
      ---------------------------------------------------------------- */
      updateRoll(u) {
        var x;
        var y;
        var ball;
        var rot;
        // Slow zoom carried through the hold and the exit. See below.
        var zoom = 1;

        if (u <= this.tContact) {
          /* PARKED. Sitting in the corner waiting to be struck.

             Rotation is held at a whole multiple of 360 rather than at
             literal zero, which is visually identical but means the roll
             below can simply unwind toward zero without a discontinuity
             at the moment of contact. A ball at rest does not spin, and
             this is what keeps it honest. */
          x = this.inX;
          y = this.inY;
          rot = this.rot0;
          ball = 1;
        } else if (u <= this.tArrive) {
          var t = clamp01((u - this.tContact) / (this.tArrive - this.tContact));

          if (t <= this.bounceAt) {
            /* SEGMENT ONE -- struck, running to the far cushion.

               Still a CUE BALL throughout: ball stays pinned at 1, so the
               photograph does not begin to appear until after the rebound.
               A mild ease-out means it is still travelling when it reaches
               the wall; a full ease-out would glide to a halt there, and
               a ball that stops at a cushion has not bounced off it. */
            var a1 = clamp01(t / this.bounceAt);
            var e1 = 1 - Math.pow(1 - a1, 1.6);

            x = this.inX + (this.bX - this.inX) * e1;
            y = this.inY + (this.bY - this.inY) * e1;
            rot = this.rot0 + (this.rot1 - this.rot0) * e1;
            ball = 1;
          } else {
            /* SEGMENT TWO -- off the cushion, into its column, becoming
               the photograph.

               Quint leaves the wall fast, and the jump in speed between
               the two segments is what reads as the rebound.

               The two axes use DIFFERENT curves, which bends the path into
               an arc rather than a straight diagonal. Rotation gets a
               faster curve again than the position, because matching them
               would make rotation exactly proportional to distance -- only
               correct at a constant radius, and this ball is growing, so
               its spin has to slow relative to its travel. */
            var a2 = clamp01((t - this.bounceAt) / (1 - this.bounceAt));

            x = this.bX * (1 - easeOutQuint(a2));
            y = this.bY * (1 - easeOutCubic(a2));
            rot = this.rot1 * (1 - easeOutQuint(a2));
            ball = 1 - easeOutCubic(a2);
          }
        } else if (u < this.tLeave) {
          /* SETTLED, but not frozen.

             This is the longest phase, and on a pin this length it would
             otherwise be nearly two screens of scrolling during which the
             scroll wheel controls nothing at all -- which does not read
             as a deliberate hold, it reads as the page having stopped
             responding. A slow scroll-linked zoom keeps the wheel
             connected to something without pulling attention off the
             copy. */
          x = 0;
          y = 0;
          rot = 0;
          ball = 0;
          zoom = 1 + this.holdZoom * clamp01((u - this.tArrive) / (this.tLeave - this.tArrive));
        } else {
          /* LEAVING. Accelerates away, then DECELERATES into the pocket.

             It used to accelerate the whole way, so it was travelling at
             its fastest at the exact moment the pocket covered it -- which
             reads as vanishing, not as being potted. A ball rolling into a
             pocket is slowing down by the time it gets there, and easing
             out over the second half is what makes the arrival legible
             rather than an abrupt disappearance. */
          var k = clamp01((u - this.tLeave) / (1 - this.tLeave));
          var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;

          x = this.outX * e;
          y = this.outY * e;

          /* Same derivation, now from the outward leg: the ball travels
             from 0 toward outX, so the sign of outX sets the spin.

             That makes the two exit modes differ for a physical reason
             rather than a coded one. 'through' keeps heading the same way
             it came, so the spin carries on and the whole pass is one
             continuous roll. 'retrace' turns around, so the ball must
             UNWIND -- a real ball reverses its spin when it reverses
             direction -- which makes rotation non-monotonic across the
             pass. That is correct, not a compromise. */
          // The `|| 1` matters for a bottom-centre exit, where the ball
          // leaves almost straight down and sign() can land on 0 -- which
          // would stop it rotating at all while it was still moving.
          rot = (Math.sign(this.outX) || 1) * this.revsOut * 360 * e;

          // Shrinks faster than it flies, so it is a ball well before it
          // reaches the edge.
          ball = smoothstep(clamp01(k * 1.35));

          // Carried over from the hold so there is no size jump at the
          // instant it is knocked away.
          zoom = 1 + this.holdZoom;

          /* DROPPING IN, and now doing its own disappearing.

             The pocket used to be painted over the top, so its darkness
             swallowed the ball and a 15% shrink was enough. Now that the
             ball rides ABOVE the pocket, nothing hides it -- so it has to
             fall out of sight itself: shrinking into the hole over the last
             third and fading through the final tenth. Both are late and
             quick, so it is a ball right up to the point it drops, rather
             than something that dwindles on the way there. */
          if (this.pocket) {
            /* DROPPING IN, at full opacity.

               No fade at all any more. The ball is solid the whole way, the
               same as the joint section's -- it simply carries on into the
               corner and the section's own edge clips it. Fading was always
               a workaround for a hole that could not hide anything, and a
               half-transparent cue ball is the one thing a real one never
               is.

               The remaining shrink is perspective rather than
               disappearance: a ball dropping away from you gets a little
               smaller, and 12% across the drop is about right. */
            var drop = clamp01((k - 0.66) / 0.34);
            var sink = drop * drop;
            x += (this.dropX || 0) * sink;
            y += (this.dropY || 0) * sink;

            /* A little more shrink than before. The ball is now genuinely
               descending into the hole rather than sliding across it, and
               falling away from the viewer is most of what makes a drop
               read as a drop. Still nowhere near enough to vanish on its
               own -- the mouth and the section edge do that. */
            zoom *= 1 - 0.26 * sink;
          }
        }

        /* Roundness resolves faster than size: by the time the frame is
           at full scale it has been rectangular for a while, so the last
           part of the arrival is pure growth. That also keeps the
           border-radius repaints -- the one non-composited property here
           -- happening while the element is small and cheap to raster. */
        var shape = clamp01(ball / 0.5);

        var qxE = 1 + (this.qx - 1) * shape;
        var qyE = 1 + (this.qy - 1) * shape;
        var sE = (1 + (this.ballScale - 1) * ball) * zoom;

        this.roller.style.transform =
          'translate3d(' +
          x.toFixed(1) +
          'px,' +
          y.toFixed(1) +
          'px,0) rotate(' +
          rot.toFixed(2) +
          'deg) scale(' +
          (sE * qxE).toFixed(5) +
          ',' +
          (sE * qyE).toFixed(5) +
          ')';

        // The inverse squash. Only the squash -- never the shrink.
        this.inner.style.transform =
          'scale(' + (1 / qxE).toFixed(5) + ',' + (1 / qyE).toFixed(5) + ')';


        /* Elliptical border-radius, written as "rx / ry". At full ball
           these are exactly half the box on each axis -- i.e. 50%/50% --
           which the squash then renders as a true circle. Quantised to
           48 steps because radius is a repaint, unlike transform. */
        var rq = Math.round(shape * 48) / 48;
        if (this.lastShape !== rq) {
          this.lastShape = rq;
          var rx = this.frameR + (this.w / 2 - this.frameR) * rq;
          var ry = this.frameR + (this.h / 2 - this.frameR) * rq;
          this.roller.style.setProperty('--pj-rx', rx.toFixed(1) + 'px');
          this.roller.style.setProperty('--pj-ry', ry.toFixed(1) + 'px');
        }

        if (this.sheen) {
          // Counter-rotation keeps the highlight fixed to the world while
          // the ball spins under it.
          this.sheen.style.transform = 'rotate(' + (-rot).toFixed(2) + 'deg)';
          this.sheen.style.opacity = (0.3 + 0.7 * ball).toFixed(3);
        }

        /* Cue ball over photograph. Keyed on `ball` -- how ball-shaped the
           frame currently is -- rather than on the phase, so the same line
           covers the entrance and the exit without caring which is which:
           solid cue ball above 0.85, gone by 0.35, crossfading between.
           Quantised because opacity writes are cheap but not free. */
        if (this.cueball) {
          var cue = Math.round(clamp01((ball - 0.35) / 0.5) * 64) / 64;
          if (this.lastCue !== cue) {
            this.lastCue = cue;
            this.cueball.style.opacity = cue.toFixed(4);
          }
          if (this.spot) this.placeSpot(rot, cue);
        }

        /* Entering from the far corner means the ball now crosses the
           text column on its way in. The media column sits before the
           text column in the DOM, so by default the copy would paint over
           the ball and chop it into pieces. Lift it while it is moving,
           and drop it back the moment it settles -- a permanently raised
           column would sit above the text for no reason once parked. */
        if (this.anchorEl) {
          var lift = ball > 0.012;
          if (lift !== this.lifted) {
            this.lifted = lift;
            this.anchorEl.style.zIndex = lift ? '4' : '';
          }
        }
      }

      /* ----------------------------------------------------------------
         THE SHAFT

         Constant velocity, right to left, across the whole pass. Linear
         on purpose: an eased pass-through reads as an object arriving
         somewhere, and this one is only ever travelling.
      ---------------------------------------------------------------- */
      place(el, x, y, angle, opacity, mirror) {
        el.style.transform =
          'translate3d(' +
          x.toFixed(1) +
          'px,' +
          y.toFixed(1) +
          'px,0) rotate(' +
          angle +
          'deg)' +
          (mirror ? ' scaleX(-1)' : '');
        el.style.opacity = opacity.toFixed(3);
      }

      /* THE STRIKER. Two phases, hinged on contact. */
      updateStrike(u) {
        var x;
        var o;

        if (u <= this.tContact) {
          /* THE STROKE. Accelerating into contact, because a break shot
             does: a linear approach reads as a slow push rather than a
             strike. The exponent holds the rod back for most of the phase
             and then snaps it through. */
          var a = clamp01(u / this.tContact);
          var ea = Math.pow(a, this.shaftAccel);
          x = this.sxStart + (this.sxContact - this.sxStart) * ea;
          o = clamp01(a / 0.12);
        } else {
          /* FOLLOW-THROUGH, THEN WITHDRAWAL.

             A stroke does not stop dead at contact and it does not carry
             on through either: the tip drives about a ball's width past,
             then the whole rod comes back out the way it came. The push is
             the first sixth of this phase and the retreat is the rest,
             decelerating, and finished by the time the ball settles --
             which is what keeps the rod off the copy during the one phase
             where the copy is meant to be read.

             The direction of the push is taken from the approach rather
             than hard-coded, so it still drives INTO the ball when the
             rod is mirrored and coming from the other side. */
          var b = clamp01((u - this.tContact) / (this.tArrive - this.tContact));
          var push = clamp01(b / 0.16);
          var backT = clamp01((b - 0.16) / 0.84);
          var eb = 1 - Math.pow(1 - backT, 2);
          var dir = this.sxContact >= this.sxStart ? 1 : -1;

          x =
            this.sxContact +
            dir * this.ballD * 0.9 * push -
            (this.sxContact - this.sxEnd) * eb;
          o = clamp01((1 - backT) / 0.3);
        }

        // Y is constant -- measured once, never animated, which is what
        // makes the clearance provable rather than merely likely.
        this.place(this.striker, x, this.strikeY, this.shaftAngle, o * this.shaftOpacity, this.mirror);
      }

      /* THE PASSER. Constant velocity across its own window, deliberately
         linear: an eased pass-through reads as an object arriving
         somewhere, and this one is only ever travelling. */
      updatePass(u) {
        var p = clamp01((u - this.passStart) / (this.passEnd - this.passStart));
        // Accelerating, exactly like the striker's stroke -- and the
        // reason the hit lands late in the timeline. See measureShaft.
        var f = Math.pow(p, this.shaftAccel);
        var x = this.passIn - f * (this.passIn + this.passOut);
        var o = Math.min(clamp01(p / 0.07), clamp01((1 - p) / 0.09));

        this.place(this.passer, x, this.passY, this.passAngle, o * this.passOpacity, false);
      }

      /* The pocket only exists while the ball is on its way to it. Faded
         in over the first slice of the exit, so it is not sitting in the
         corner over the copy for the whole hold. */
      updatePocket(u) {
        var span = Math.max(0.02, (1 - this.tLeave) * 0.3);
        var o = Math.round(clamp01((u - this.tLeave) / span) * 64) / 64;
        if (this.lastPocket === o) return;
        this.lastPocket = o;
        this.pocket.style.opacity = o.toFixed(4);

        /* The lip fades in with the mouth. It has to be present BEFORE the
           ball reaches the corner -- it is the front edge of the hole, and
           a front edge that appears only once the ball arrives would pop
           into view at the worst possible moment. */
        if (this.pocketMouth) this.pocketMouth.style.opacity = o.toFixed(4);
      }

      /* The impact beat. A cubed falloff over a narrow band around the
         contact point, so it is a strike rather than a glow -- and being
         a pure function of u, it reverses cleanly when scrolling back. */
      updateImpact(u) {
        var d = Math.abs(u - this.tContact);
        var punch = Math.pow(clamp01(1 - d / 0.055), 3);
        var q = Math.round(punch * 64) / 64;
        if (this.lastPunch === q) return;
        this.lastPunch = q;
        this.impact.style.opacity = (q * this.flashMax).toFixed(4);
      }

      /* ----------------------------------------------------------------
         TEXT COLUMN

         Driven by the text column's OWN rect, not by u. The two columns
         do not necessarily enter together, and tying the copy to the
         image's timeline would leave visible text at zero opacity.
         Latches once shown: un-revealing text as the reader scrolls back
         toward it reads as a bug, not an effect.
      ---------------------------------------------------------------- */
      prepareText() {
        if (!this.textItem) return false;
        this.revealEls = Array.prototype.slice.call(this.textItem.querySelectorAll('.pj-r'));
        if (!this.revealEls.length) return false;
        this.textItem.classList.add('pristine-potshot__text-item--motion');
        return true;
      }

      updateText() {
        var vh = window.innerHeight;
        var top = this.textItem.getBoundingClientRect().top;
        var tp = this.textDone ? 1 : clamp01((vh * 0.92 - top) / (vh * 0.42));
        if (tp >= 0.999) this.textDone = true;

        if (this.lastTp !== undefined && Math.abs(tp - this.lastTp) < 0.002) return;
        this.lastTp = tp;

        var n = this.revealEls.length;
        var lead = Math.min(0.07, 0.45 / n);

        for (var i = 0; i < n; i++) {
          var e = easeOutQuint(clamp01((tp - i * lead) / 0.5));
          var el = this.revealEls[i];
          el.style.opacity = e.toFixed(3);
          el.style.transform = 'translate3d(0,' + ((1 - e) * 22).toFixed(1) + 'px,0)';
        }
      }


      /* THE SPOT ON A ROLLING SPHERE.

         Same solve as the joint section: the point sits on a latitude
         circle of a sphere turning about a tilted axis, so its depth --
         and therefore how long it spends hidden behind the ball -- falls
         out of the geometry rather than being a number chosen to look
         right.

         Expressed in percentages of the spot rather than pixels, which
         the joint section could use because its ball is a true square.
         This one is a squashed rectangle rendered as a circle, so pixel
         offsets would come out elliptical; a percentage of the spot
         resolves against width for x and height for y, and those are
         equal once the squash has done its work.

         Two things differ from the joint. The counter-rotation cancels
         the roller\u2019s own rotate() so the offset is not spun twice. And
         the fade is multiplied by how much of a BALL this still is -- it
         becomes the photograph, and a black dot has no business sitting
         on the picture. */
      placeSpot(rotDeg, ballness) {
        var th = (rotDeg * Math.PI) / 180;

        // Latitude, as fractions of the ball\u2019s radius.
        var h = 0.36;
        var r = 0.74;
        var tilt = 0.52;

        var sinT = Math.sin(tilt);
        var cosT = Math.cos(tilt);
        var st = Math.sin(th);

        var px = r * Math.cos(th);
        var py = h * cosT - r * st * sinT;
        var pz = h * sinT + r * st * cosT;

        /* radius fraction -> fraction of the diameter -> multiples of the
           spot, which is 17% of the diameter. */
        var k = 0.5 / 0.17;

        // Fading across the rim rather than switching off at it.
        var facing = clamp01((pz + 0.16) / 0.3);
        // Foreshortening: a spot near the edge is seen at an angle.
        var fore = 0.72 + 0.28 * Math.abs(pz);

        var o = facing * 0.92 * clamp01(ballness);
        var oq = Math.round(o * 64) / 64;

        this.spot.style.transform =
          'rotate(' +
          (-rotDeg).toFixed(1) +
          'deg) translate(' +
          (px * k * 100).toFixed(1) +
          '%,' +
          (py * k * 100).toFixed(1) +
          '%) scale(' +
          fore.toFixed(3) +
          ')';

        if (this.lastSpotO === oq) return;
        this.lastSpotO = oq;
        this.spot.style.opacity = oq.toFixed(3);
      }
      /* ----------------------------------------------------------------
         SHARED SCROLL READ
      ---------------------------------------------------------------- */
      readScroll() {
        var vh = window.innerHeight;

        /* PINNED: progress comes from the TRACK, not from the content.

           This is the part that is easy to get wrong. Once the view is
           stuck, the image stops moving on screen -- so measuring the
           image's position would read a constant and the animation would
           freeze for the whole pin. The track keeps scrolling underneath,
           so it is the only thing left that still knows how far through
           we are.

           Its top starts at 0 when the pin engages and ends at -(height -
           one screen) when it releases, which maps straight onto 0..1
           with no window or anchor involved. That is why "Pass length"
           and "Anchor position" only apply when pinning is off. */
        if (this.pinned && this.track) {
          var t = this.track.getBoundingClientRect();
          var span = t.height - vh;

          /* LEAD-IN.

             Without it, progress could only start once the pin engaged --
             and the pin engages only after the section's top has climbed
             a full screen height. That is a whole screen of scrolling
             with the section in view and absolutely nothing happening,
             which is what made the strike feel like it was waiting for
             the section to reach the middle before it would fire.

             Counting part of that approach means the timeline begins
             while the section is still sliding up, so the strike can land
             on the way in rather than after everything has settled. */
          /* LEAD-OUT, the mirror of the above.

             Once the track's bottom passes, sticky releases and the
             section scrolls away normally. Counting that tail means the
             ball is still rolling out while the section is travelling --
             so the exit has the section moving with it, the same way the
             lead-in has the section moving during the entrance, instead
             of the whole roll-out happening against a locked screen. */
          /* WHERE u = 0 LANDS, derived rather than set.

             The head start used to be a flat percentage of the screen, and
             at 100% that put u = 0 with the section's top exactly on the
             bottom edge -- the timeline opening before there was anything
             to see. Solved from the geometry instead, it starts at the
             moment "Start point" percent of the section is showing: 50%
             means the animation begins when the section is half on screen,
             whatever the section's height or the zoom level. */
          var stageH = this.view ? this.view.offsetHeight : vh;
          var lead = clamp(vh - (stageH * this.anchor) / 100, 0, vh);
          /* THE RUN-ON, HALVED AND DERIVED.

             This is why the pot was never visible. The run-on counts the
             scrolling after the pin releases, and at 100% it mapped the
             whole of it -- so u = 1 landed at the exact moment the section
             finished leaving the screen. The ball dropped into the pocket
             as the section slid up under the header: the animation was
             running perfectly, just entirely out of sight.

             Half a screen instead. u = 1 now falls with the section still
             half on screen, which puts the drop squarely in view with room
             to spare. It is derived rather than set, because it is a
             property of where the section is, not a matter of taste. */
          var out = vh * 0.5;
          var total = lead + span + out;
          var pinU = total > 0 ? clamp01((lead - t.top) / total) : 0;
          return { sig: 1 - 2 * pinU, u: pinU };
        }

        /* UNPINNED FALLBACK -- the section's own travel, same start point.

           This was keyed on the IMAGE's centre against a fixed window, and
           it was the reason the animation seemed to wait for the middle of
           the section. On a 613px section it put u = 0 with the image's
           centre still 72px BELOW the fold, and worse, u = 1 with the
           section still 39% on screen: the whole thing was over while a
           third of the section was still in view.

           Anchored to the section instead, from "Start point" percent of it
           showing through to its bottom edge clearing the top of the
           screen. u = 0 is where you asked for it, and u = 1 cannot happen
           before the section has actually gone. */
        var rect = this.getBoundingClientRect();
        var travel = Math.max(1, rect.height + vh);
        var passed = vh - rect.top;
        var begin = (Math.min(rect.height, vh) * this.anchor) / 100;
        var freeU = clamp01((passed - begin) / Math.max(1, travel - begin));

        return { sig: 1 - 2 * freeU, u: freeU };
      }

      update() {
        var m = this.readScroll();

        if (this.lastSig !== undefined && Math.abs(m.sig - this.lastSig) < 0.0012) return;
        this.lastSig = m.sig;

        if (this.rollActive) this.updateRoll(m.u);
        if (this.strikeActive) this.updateStrike(m.u);
        if (this.passActive) this.updatePass(m.u);
        if (this.impact) this.updateImpact(m.u);
        if (this.pocket) this.updatePocket(m.u);
        if (this.textActive) this.updateText();
      }

      onScroll() {
        if (this.frame) return;
        var self = this;
        this.frame = requestAnimationFrame(function () {
          self.frame = null;
          self.update();
        });
      }

      onResize() {
        var self = this;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
          self.measure();
          self.lastSig = undefined;
          self.lastShape = undefined;
          self.update();
        }, 150);
      }
    }

    customElements.define('pristine-potshot-motion', PristineIwtMotion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pristine-joint"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('pristine-joint-break')) return;

    /* ----------------------------------------------------------------
       Deterministic character tables. Lengths 8 / 9 / 11 -- coprime with
       the 2, 3, 4 and 6 column counts, so the per-card combination keeps
       rotating across the grid instead of repeating in visible stripes.
       No Math.random anywhere: identical on every load and in the editor.
    ---------------------------------------------------------------- */
    var TILT = [-1, 0.55, -0.3, 0.85, -0.7, 0.35, -0.5, 0.65];
    var BOW = [1, -0.72, 0.86, -1, 0.6, -0.88, 0.74, -0.58, 0.92];
    var LIFT = [1, 0.62, 0.88, 0.5, 0.95, 0.7, 0.56, 0.82, 0.66];
    var ROT_X = [1, -0.76, 0.5, -1, 0.8, -0.46, 0.66, -0.86, 0.56];
    var ROT_Y = [-0.82, 1, -0.56, 0.72, -1, 0.6, -0.7, 0.86, -0.5];
    var SPAN = [1, 0.84, 1.14, 0.9, 1.06, 0.78, 1.1, 0.88, 0.96, 1.02, 0.82];
    var EASE_X = [0, 2, 1, 3, 0, 1, 2, 3, 1, 0, 2];
    var EASE_Y = [2, 0, 3, 1, 2, 3, 0, 1, 3, 2, 1];
    var OUT_FAR = [1, 0.74, 0.92, 0.66, 1, 0.8, 0.7, 0.96, 0.86];
    var OUT_Z = [1, -0.8, 0.6, -1, 0.85, -0.55, 0.7, -0.9, 0.5];
    var OUT_SPIN = [-1, 0.8, -0.6, 1, -0.85, 0.55, -0.7, 0.9, -0.5];
    var OUT_FALLBACK = [
      [0, -1],
      [0.92, -0.39],
      [-0.92, -0.39],
      [0.71, 0.71],
      [-0.71, 0.71],
      [1, 0],
      [-1, 0],
      [0, 1]
    ];

    /* Four settles. Giving a card ONE curve for its X axis and a
       DIFFERENT one for its Y is what bends its path: the axes arrive out
       of step, so it sweeps rather than sliding down the straight line
       between the rack and its slot. */
    var EASES = [
      function (t) {
        return 1 - Math.pow(1 - t, 3);
      },
      function (t) {
        return 1 - Math.pow(1 - t, 5);
      },
      function (t) {
        var c = 1.18;
        var v = t - 1;
        return 1 + (c + 1) * v * v * v + c * v * v;
      },
      function (t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
    ];

    function clamp01(n) {
      return n < 0 ? 0 : n > 1 ? 1 : n;
    }

    function clamp(n, lo, hi) {
      return n < lo ? lo : n > hi ? hi : n;
    }

    function num(v, f) {
      var n = parseFloat(v);
      return isNaN(n) ? f : n;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }


    function smoothstep(t) {
      return t * t * (3 - 2 * t);
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* TRIANGULAR RACK for any number of balls, apex first, in units of
       one ball diameter and centred on its own middle. Generated rather
       than tabled, so adding a seventh column racks correctly instead of
       falling off the end of a list. */
    function rackLayout(n) {
      var pos = [];
      var row = 0;
      while (pos.length < n) {
        var count = row + 1;
        for (var i = 0; i < count && pos.length < n; i++) {
          pos.push({ x: i - (count - 1) / 2, y: row * 0.866 });
        }
        row++;
      }
      var my = 0;
      for (var j = 0; j < pos.length; j++) my += pos[j].y;
      my /= pos.length || 1;
      for (var k = 0; k < pos.length; k++) pos[k].y -= my;
      return pos;
    }

    /* CUSHION REFLECTION as a triangle wave. Feed it an unbounded
       coordinate and it folds back and forth inside [lo, hi] -- which is
       exactly what a ball bouncing between two rails does, computed in
       closed form from scroll position rather than simulated step by
       step. That is what keeps it reversible. */
    function fold(v, lo, hi) {
      var span = hi - lo;
      if (span <= 0) return lo;
      var t = (v - lo) % (2 * span);
      if (t < 0) t += 2 * span;
      return lo + (t <= span ? t : 2 * span - t);
    }

    /* Wrap every word in a mask + mover pair. Only TEXT NODES are
       touched, so a merchant's <em> or <strong> in the rich-text heading
       survives. All text nodes are collected BEFORE any replacement,
       because replacing nodes while a TreeWalker is live invalidates the
       walk. Whitespace stays as plain text nodes -- wrapping it would
       collapse the spaces between words. */
    function splitWords(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var texts = [];
      var node;
      while ((node = walker.nextNode())) texts.push(node);

      var movers = [];

      texts.forEach(function (text) {
        if (!text.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();

        text.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (!part.trim()) {
            frag.appendChild(document.createTextNode(part));
            return;
          }
          var mask = document.createElement('span');
          mask.className = 'pj-w';
          var mover = document.createElement('span');
          mover.className = 'pj-w__i';
          mover.textContent = part;
          mask.appendChild(mover);
          frag.appendChild(mask);
          movers.push(mover);
        });

        text.parentNode.replaceChild(frag, text);
      });

      return movers;
    }

    class PristineJointBreak extends HTMLElement {
      connectedCallback() {
        if (this.setUp) return;
        this.setUp = true;

        this.track = this.querySelector('[data-pj-track]');
        this.view = this.querySelector('[data-pj-view]');
        this.fit = this.querySelector('[data-pj-fit]');
        this.content = this.querySelector('.pristine-joint__content');
        this.list = this.querySelector('.pristine-joint__list');
        this.shells = Array.prototype.slice.call(this.querySelectorAll('[data-pj-shell]'));
        this.inners = this.shells.map(function (s) {
          return s.querySelector('[data-pj-inner]');
        });
        this.balls = this.shells.map(function (s) {
          return s.querySelector('[data-pj-ball]');
        });
        this.items = this.shells.map(function (s) {
          return s.closest('.pristine-joint__item') || s.parentElement;
        });

        this.cue = this.querySelector('[data-pj-cue]');
        this.spot = this.querySelector('[data-pj-spot]');
        this.shaft = this.querySelector('[data-pj-shaft]');
        this.impact = this.querySelector('[data-pj-impact]');
        this.glow = this.querySelector('[data-pj-glow]');
        this.header = this.querySelector('[data-pj-header]');

        this.readSettings();

        this.cardsActive = this.dataset.cards === '1' && !!this.list && this.shells.length > 0;
        this.cueActive = this.dataset.cue === '1' && !!this.cue;
        this.shaftActive = this.dataset.shaft === '1' && !!this.shaft;
        this.glowActive = !!this.glow && this.glowBase > 0;

        if (prefersReducedMotion()) {
          // The settled grid, no motion. The balls stay hidden by CSS.
          if (this.glowActive) this.glow.style.opacity = (this.glowBase * 0.6).toFixed(3);
          return;
        }

        this.textActive = this.dataset.text === '1' && this.prepareText();

        if (
          !this.cardsActive &&
          !this.cueActive &&
          !this.shaftActive &&
          !this.textActive &&
          !this.glowActive
        ) {
          return;
        }

        if (this.cardsActive) this.prepareCards();

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.measure();
        this.update();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        /* WATCH THE CONTENT'S HEIGHT, not just the window's.

           Whether the section can pin depends on whether its content fits
           one screen, and that was decided exactly once on load. Anything
           that changes the height afterwards without firing a resize --
           a late web font, a review widget or any other app injecting
           itself, the theme editor, an ancestor settling -- left the
           decision stale, and a stale "no" costs the whole pinned
           sequence with nothing to indicate why.

           The observer fires when pinning itself changes the height, so
           small differences are ignored to stop it chasing its own tail. */
        if (window.ResizeObserver && this.content) {
          var host = this;
          this.ro = new ResizeObserver(function () {
            var h = host.content.offsetHeight;
            if (host.lastContentH !== undefined && Math.abs(h - host.lastContentH) < 6) return;
            host.lastContentH = h;
            host.onResize();
          });
          this.ro.observe(this.content);
        }

        // Image ratios are fixed by inline padding so images never reflow
        // the grid, but a late web font still changes a card title's
        // height, which moves every card's home position.
        if (document.fonts && document.fonts.ready) {
          var self = this;
          document.fonts.ready.then(function () {
            self.settle();
          });
        }

        /* SETTLE PASSES.

           The pin decision is the one thing here that cannot afford to be
           made early, because a stale "no" costs the entire pinned
           sequence -- and a section measured before layout has settled
           reads taller than it really is. This one measured 1189px on load
           against 1057px once settled, which is the difference between
           refusing the pin and granting it at a comfortable 0.67.

           Neither hook already here is enough on its own. fonts.ready
           resolves instantly when the fonts were already cached, which is
           the common case and lands it right back in the same too-early
           moment. And the ResizeObserver deliberately ignores small
           changes so it does not chase the height that pinning itself
           changes -- which also means it cannot be relied on to notice
           this one.

           So the decision is simply re-run at a few deterministic points
           instead of waiting to be told: after layout, after load, and
           once more late enough for an app that injects itself into the
           page. It is three measures over the first second and nothing
           per frame. */
        this.settle();
        var me = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            me.settle();
          });
        });
        if (document.readyState === 'complete') {
          setTimeout(function () {
            me.settle();
          }, 400);
        } else {
          window.addEventListener(
            'load',
            function () {
              me.settle();
              setTimeout(function () {
                me.settle();
              }, 400);
            },
            { once: true }
          );
        }
      }

      /* Re-measure and repaint from wherever the page currently is. Cheap
         enough to call a handful of times on load; never called per
         frame. */
      settle() {
        if (!this.setUp) return;
        this.measure();
        this.lastSig = undefined;
        this.update();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.resizeTimer);
        if (this.ro) this.ro.disconnect();
        if (this.textIO) this.textIO.disconnect();
      }

      readSettings() {
        var d = this.dataset;

        this.windowPct = num(d.window, 90);
        this.anchor = clamp(num(d.anchor, 50), 20, 80);

        this.pinWanted = d.pin === '1';
        this.pinMobile = d.pinMobile === '1';
        this.leadIn = clamp(num(d.lead, 60), 0, 100);
        this.leadOut = clamp(num(d.leadout, 80), 0, 100);
        this.pinned = false;

        /* Breakpoints, forced strictly increasing so no settings
           combination can make the phases overlap. */
        this.tContactBase = clamp(num(d.contact, 10) / 100, 0.02, 0.3);
        this.tContact = this.tContactBase;
        this.tBreakBase = clamp(num(d.break, 22) / 100, this.tContact + 0.04, 0.45);
        this.tBreak = this.tBreakBase;
        this.scatterSpan = clamp(num(d.scatterSpan, 12) / 100, 0.03, 0.35);
        // Same duration whether pinned or not, so the scatter reads the
        // same either way.
        this.tDealtBase = clamp(this.tBreakBase + this.scatterSpan, this.tBreakBase + 0.04, 0.8);
        this.tDealt = this.tDealtBase;
        this.tLeaveBase = clamp(num(d.leave, 80) / 100, this.tDealt + 0.05, 0.97);
        this.tLeave = this.tLeaveBase;

        this.frameR = Math.max(0, num(d.radius, 14));
        this.ballSize = Math.max(20, num(d.ball, 96));
        this.rackGap = clamp(num(d.rackGap, 104) / 100, 0.9, 1.6);
        this.rackX = clamp(num(d.rackX, 50), 0, 100);
        this.rackOffset = Math.max(0, num(d.rackOffset, 200));
        this.perspective = Math.max(200, num(d.perspective, 1300));
        this.spinMult = clamp(num(d.spin, 1), 0, 4);

        this.stagger = num(d.stagger, 90);
        this.smoothing = num(d.smoothing, 180);
        this.variance = clamp(num(d.variance, 1), 0, 1);
        this.tilt = num(d.tilt, 5);
        this.depth = num(d.depth, 150);
        this.arc = num(d.arc, 36);
        this.tumble = num(d.tumble, 7);
        this.liftShadow = d.liftShadow === '1';
        this.flightBlur = num(d.flightBlur, 0);
        this.outSpin = num(d.exitSpin, 40);
        this.outDepth = num(d.exitDepth, 225);
        this.outDrop = clamp(num(d.exitDrop, 55) / 100, 0, 1.5);
        this.outStagger = num(d.exitStagger, 70);

        /* The cue ball is the SAME diameter as the object balls, taken
           from their setting rather than having one of its own.

           On a real table both are 2.25 inches, so a separate control was
           only ever an opportunity for them to disagree -- and a saved
           value from an earlier version kept them disagreeing no matter
           what default I set. Deriving it means they cannot drift. */
        this.cueSize = this.ballSize;
        this.cueXPct = clamp(num(d.cueX, 50), 0, 100);
        this.cueYPx = Math.max(0, num(d.cueY, 96));
        this.cueAccel = clamp(num(d.cueAccel, 2.4), 1, 5);
        /* Capped against the section own size rather than left to the raw
           setting. 1200px inside a box 1265 wide is a full lap of the table
           during a phase that has just been shortened, so the ball reads as
           hurrying rather than coasting to a stop. Three quarters of a lap
           is a roll into a cushion and a drift back, which is what the end
           of a break actually looks like. Applied in measure(), where the
           box size is known. */
        this.driftSet = Math.max(0, num(d.drift, 2400));
        this.driftSpan = this.driftSet;
        this.driftAngle = num(d.driftAngle, 26);
        this.cueBounces = Math.max(0, Math.round(num(d.cueBounces, 2)));

        this.shaftOpacity = clamp(num(d.shaftOpacity, 0.95), 0, 1);
        this.shaftNudge = num(d.shaftNudge, 0);
        this.flashMax = clamp(num(d.flash, 0.5), 0, 1);
        this.splitWords = d.split === '1';
        this.glowBase = num(d.glow, 0.45);
      }

      /* ----------------------------------------------------------------
         PIN
      ---------------------------------------------------------------- */

      /* Decided before anything is measured, because it changes the
         layout every later rect read depends on.

         Two reasons to refuse. The view is exactly one screen tall, so
         content taller than that would be cropped top and bottom with no
         way to reach it -- showing all the copy matters more than the
         effect. And pinning a phone hijacks a short screen for several
         swipes, so it is opt-in there. */
      decidePin() {
        if (!this.pinWanted || !this.track || !this.content) return;

        if (!(this.pinMobile || window.innerWidth >= 750)) {
          this.pinned = false;
          this.track.classList.remove('pristine-joint__track--pinned');
          return;
        }

        /* TRY IT ON, THEN MEASURE.

           The pinned state is what removes the section padding and
           tightens the header, so measuring the content BEFORE applying
           it reports a height that includes space the pin would have
           reclaimed -- and refuses layouts that would in fact have fitted
           with room to spare. Applying it first and reverting on a genuine
           overflow costs one forced layout on load and on resize, and
           nothing at all per frame. */
        this.track.classList.add('pristine-joint__track--pinned');

        /* SCALE TO FIT rather than refuse.

           Measured with the scale off, so the reading is the layout's own
           height and not last frame's scaled one. Then shrink by exactly
           the shortfall. A 3-column grid with wide images needs about 0.93
           -- imperceptible; with tall images nearer 0.71, which is
           noticeably smaller text but vastly better than losing the pin
           and with it every screen of scroll the sequence lives on.

           THE FLOOR USED TO BE 0.62, and on a 720px-tall screen this
           section needs 0.599 -- so it was refused by two percent, and
           lost every screen of scroll the sequence lives on. Given the
           choice between a slightly small section and one that plays its
           whole break in a screen and a half, the small one wins: the
           animation is the reason this section exists.

           0.58 is where it stops being a section anyone can read at all.
           If you would rather have it bigger, the scale is just available
           height over content height -- shortening the cards raises it
           directly, and the console logs both numbers. */
        if (this.fit) this.fit.style.transform = 'none';
        this.track.classList.remove('pristine-joint__track--compact');

        var avail = window.innerHeight - 8;
        var h = this.fit ? this.fit.offsetHeight : this.content.offsetHeight;

        /* SLIDE IT, DO NOT SHRINK IT.

           Scaling to fit was the wrong instrument. Six cards with images
           plus a header cannot be squeezed into one 720px screen at the
           type size the rest of the page uses -- I measured it, and even
           counter-scaling the fonts to compensate diverges: it plateaus
           around 12px against the page's 14-16px while the images collapse
           to nothing. So the section came out visibly smaller than its
           neighbours, which is a worse fault than the one scaling solved.

           Panning has none of that. The type stays exactly the size it is
           everywhere else on the page, the images keep their ratio, and
           the grid SLIDES up by the overflow during the reading hold --
           row one, then row two, both at full size. There is a hold of two
           screens of scroll to spend on it, so it is a gentle drift rather
           than a jump.

           Scale is now a last resort for genuinely enormous content, not
           the mechanism. */
        var scale = 1;
        var pan = h - avail;

        /* Compact only if the slide would be a long haul. Under about six
           tenths of a screen the section keeps its layout exactly as
           designed; past that, shortening the boxes beats sliding for
           ages. */
        if (pan > avail * 0.6) {
          this.track.classList.add('pristine-joint__track--compact');
          var hC = this.fit ? this.fit.offsetHeight : this.content.offsetHeight;
          if (hC < h) {
            h = hC;
            pan = h - avail;
          } else {
            this.track.classList.remove('pristine-joint__track--compact');
          }
        }

        /* Only past two screens of content does sliding stop being
           reasonable, and only then does anything shrink -- just enough to
           bring the slide back to about one screen. */
        if (pan > avail * 0.95) {
          scale = clamp((avail * 1.95) / h, 0.58, 1);
          pan = h * scale - avail;
        }

        this.pinned = scale >= 0.58;
        this.fitScale = this.pinned ? scale : 1;

        var rendered = h * this.fitScale;
        /* The ONLY centring mechanism. The view top-aligns its content, so
           a section with room to spare is centred here instead -- in the
           same transform that does the sliding, which is what stops the
           two from fighting. Taller than the view, there is nothing to
           centre: it starts at the top and slides. */
        this.baseY = this.pinned && rendered < avail ? (window.innerHeight - rendered) / 2 : 0;
        this.panMax = this.pinned ? Math.max(0, rendered - avail) : 0;
        /* Where the slide settles for the roll-out. Half way back shares
           the screen between the two rows almost evenly -- a shade over
           half of each -- which is the most of the grid that can be on
           screen at once with the header holding its own 286px. */
        this.panExit = this.panMax * 0.55;
        this.panNow = 0;
        this.writeFit();

        if (!this.pinned) {
          this.track.classList.remove('pristine-joint__track--pinned');

          /* The compact layout STAYS even when the pin is refused, and
             deliberately so. Unpinned, the section is taller than the
             screen and scrolls past under its own steam -- so 167px less
             of it is 167px more of it you can take in at once, which is
             the whole problem on a short screen. It earned its place by
             fitting better; it keeps it for the same reason. */

          /* Say so. A skipped pin is completely silent otherwise: the
             section still works, it just plays the whole sequence over
             about one screen of scroll instead of a dozen, and there is
             nothing on the page to suggest why it feels rushed. Logged
             once, not per frame. */
          if (!this.warnedPin && window.console && console.info) {
            this.warnedPin = true;
            console.info(
              '[Pristine Joint] Scroll pinning skipped: the section is ' +
                h +
                'px tall against a ' +
                window.innerHeight +
                'px screen, so fitting it would need a ' +
                scale.toFixed(2) +
                'x scale — small enough that the copy would be hard to read.' +
                ' Without the pin the break plays out over about one screen of scroll' +
                ' instead of a dozen. Shorten the section: "Image ratio" to Wide 16:9,' +
                ' or "Columns on desktop" to 6.'
            );
          }
        }
      }

      /* ----------------------------------------------------------------
         GEOMETRY
      ---------------------------------------------------------------- */

      prepareCards() {
        var self = this;
        var n = this.shells.length;

        this.list.style.setProperty('--pj-smoothing', this.smoothing + 'ms');
        this.list.classList.add('pristine-joint__list--scrub');

        this.plan = this.shells.map(function (shell, i) {
          return {
            spanMult: 1 + (SPAN[i % SPAN.length] - 1) * self.variance,
            outMult: 1 + (SPAN[(i + 5) % SPAN.length] - 1) * self.variance,
            easeX: EASES[EASE_X[i % EASE_X.length]],
            easeY: EASES[EASE_Y[i % EASE_Y.length]],
            bow: BOW[i % BOW.length],
            lift: LIFT[i % LIFT.length],
            rotX: ROT_X[i % ROT_X.length],
            rotY: ROT_Y[i % ROT_Y.length],
            tilt: TILT[i % TILT.length],
            outFar: OUT_FAR[i % OUT_FAR.length],
            outZ: OUT_Z[i % OUT_Z.length],
            outSpin: OUT_SPIN[i % OUT_SPIN.length],
            fallback: OUT_FALLBACK[i % OUT_FALLBACK.length]
          };
        });

        this.airborne = new Array(n);
        this.lastAir = new Array(n);
        this.lastOpacity = new Array(n);
        this.lastBall = new Array(n);
        this.lastBallOpacity = new Array(n);
        this.gone = new Array(n);

        /* Per-card offset into a phase, so they move one shortly after
           another. Dividing the shared span by the largest duration
           multiplier guarantees even the slowest still finishes exactly
           as the phase ends. */
        var maxMult = function (key) {
          var m = 1;
          for (var i = 0; i < self.plan.length; i++) {
            if (self.plan[i][key] > m) m = self.plan[i][key];
          }
          return m;
        };

        this.dealLead = n > 1 ? Math.min(this.stagger / 1000, 0.6 / (n - 1)) : 0;
        this.dealSpan = (1 - this.dealLead * (n - 1)) / maxMult('spanMult');
        this.outLead = n > 1 ? Math.min(this.outStagger / 1000, 0.5 / (n - 1)) : 0;
        this.outSpan = (1 - this.outLead * (n - 1)) / maxMult('outMult');
      }

      measure() {
        this.decidePin();

        /* TIE THE ROLL-OUT TO THE SECTION'S DEPARTURE.

           This is the one that kept emptying the section early. The pin
           releases at a point set purely by geometry -- lead-in plus
           pinned span over the whole mapped distance -- and that is also
           the moment the next section starts to appear. A roll-out
           starting at a hand-set 64% spent 85% of itself while the
           section was still pinned and filling the screen: the balls
           rolled off the edge, got clipped, and the section just sat
           there empty. No opacity curve can fix that, because nothing
           was wrong with the fading -- they had simply already left.

           Derived instead, the roll-out always ends as the section does,
           whatever the pin length. The 0.16 is how much of it happens
           while still pinned, so it is visibly under way before the
           section starts to travel. */
        if (this.pinned && this.track) {
          var vhP = window.innerHeight;
          var spanP = this.track.offsetHeight - vhP;
          var leadP = (vhP * this.leadIn) / 100;
          var outP = (vhP * this.leadOut) / 100;
          var totalP = leadP + spanP + outP;

          var engageU = totalP > 0 ? leadP / totalP : 0;
          this.releaseU = totalP > 0 ? (leadP + spanP) / totalP : 1;

          /* THE OPENING IS DERIVED FROM WHERE THE PIN LOCKS.

             Percentages were the trap here. 10% of the pass sounds
             modest, but the pass is eighteen screens -- so contact sat
             1.8 screens in, and since the pin locks at 5.6% the section
             was sitting there fully visible and motionless for the best
             part of a screen with nothing struck yet.

             Pinned, the useful landmarks are geometric, not fractional:
             the section locks at engageU and leaves at releaseU. Hanging
             the strike just before the lock and the break just after it
             means the cue arrives as the section settles, whatever the
             pin length or zoom level -- 0.72 screens at 100% and at 90%
             alike, because both are the same fraction of their own
             screen. */
          this.tContact = clamp(engageU * 0.72, 0.012, 0.25);
          this.tBreak = clamp(engageU + 0.035, this.tContact + 0.015, 0.4);
          this.tDealt = clamp(this.tBreak + this.scatterSpan, this.tBreak + 0.04, 0.62);
          /* The roll-out starts a screen and a bit before the section is
             released rather than exactly one screen, which takes that
             difference straight out of the standby -- the phase where
             nothing happens but the cue ball drifting. Expressed in screens
             so it holds at any pin length or zoom. */
          var screenP = totalP > 0 ? vhP / totalP : 0.2;
          this.tLeave = clamp(this.releaseU - screenP * 1.4, this.tDealt + 0.05, 0.95);
          this.passPx = totalP;
        } else {
          this.tContact = this.tContactBase;
          this.tBreak = this.tBreakBase;
          this.tDealt = this.tDealtBase;
          this.tLeave = this.tLeaveBase;

          // The free scrub's mapped distance, matching readScroll exactly.
          var vhF = window.innerHeight;
          var rectF = this.getBoundingClientRect();
          var travelF = Math.max(1, rectF.height + vhF);
          var beginF = travelF * (1 - this.windowPct / 100) * (this.anchor / 100);
          this.passPx = Math.max(1, travelF - beginF);
        }

        /* A READING HOLD, IN SCROLL DISTANCE.

           The stretch between the grid landing and the roll-out beginning
           is the only part of this where the cards sit still long enough
           to be read -- and expressed as a fraction of the pass it is at
           the mercy of how long the pass happens to be. A hold of 18%
           across five screens is a screen of comfortable reading; the same
           18% across a screen and a half is 270px, gone in one flick of
           the wheel, and the cards have turned back into balls before the
           second row was ever taken in.

           So it is required in pixels: one screen of scrolling with the
           grid settled, wherever that is affordable. The exit cannot give
           ground -- it has to end exactly as the section leaves -- so the
           time comes out of the assembly instead, which simply lands
           sooner. */
        var screenU = clamp01(window.innerHeight / this.passPx);

        /* A FLOOR AND A CEILING, both in screens.

           The floor is the reading time: a screen of settled grid, so the
           cards can actually be taken in. That was already here.

           The ceiling is new, and it is the fix for a standby that ran to
           2.1 screens -- over 1500px of scrolling whose only content was
           the cue ball drifting off the cushions. It was the longest phase
           of the whole sequence and the least worth watching. Capped at
           1.3 screens, the scroll it gives back goes to the scatter, where
           there is something to look at. */
        var holdMin = Math.min(0.3, screenU);
        var holdMax = Math.min(0.42, screenU * 1.3);

        if (this.tLeave - this.tDealt < holdMin) {
          this.tDealt = Math.max(this.tBreak + 0.04, this.tLeave - holdMin);
        } else if (this.tLeave - this.tDealt > holdMax) {
          this.tDealt = Math.max(this.tBreak + 0.04, this.tLeave - holdMax);
        }

        /* Measure in the wrapper's OWN space, with the fit scale switched
           off for the duration.

           getBoundingClientRect reports scaled pixels. Every offset here
           is applied to elements INSIDE the scaled wrapper, so measuring
           scaled and then applying inside would compound the factor twice
           and put the rack, the cue ball and the cushions all in the wrong
           places. Reading with the scale off keeps one consistent space. */
        if (this.fit) this.fit.style.transform = 'none';

        var box = (this.fit || this.view || this).getBoundingClientRect();
        this.viewW = box.width;
        this.viewH = box.height;

        /* HOLD THE DRIFT TO ABOUT THREE QUARTERS OF A LAP.

           Here, and not up with the other timing, because it needs the box
           width -- which is measured on the line above. Computed any earlier
           it reads an unset viewW, and the whole drift comes out NaN.

           1200px inside a box 1265 wide is a full lap of the table during a
           phase that has just been shortened, so the ball reads as hurrying
           rather than coasting to a stop. Three quarters is a roll into a
           cushion and a drift back, which is what the end of a break
           actually looks like. */
        var lap = Math.max(200, this.viewW / (this.fitScale || 1) - this.ballSize);
        this.driftSpan = Math.min(this.driftSet, lap * 0.75);

        if (this.cardsActive) this.measureCards(box);
        if (this.cueActive) this.measureCue(box);
        // Third, because it needs the cards' positions AND the cue ball's
        // rebound path to work out who gets hit and when.
        this.measureChain();
        if (this.shaftActive) this.measureShaft(box);

        // Rebuilt from state rather than restored from a string, so the
        // slide survives a re-measure instead of being reset to whatever
        // was written last frame.
        this.writeFit();
      }

      /* Distance from a point to the edge of the VISIBLE area along a
         direction, in wrapper units. The visible area is bigger than the
         wrapper, because the wrapper gets scaled down and centred inside
         it -- so this is the boundary things are actually clipped at. */
      clearAlong(cx, cy, ox, oy) {
        /* Solved at the RESTING slide, because that is where the roll-out
           happens -- the sweep is over and eased part-way back before any
           ball starts to leave. */
        var v = this.visBox(this.panExit);

        var tx = ox > 0.001 ? (v.l + v.w - cx) / ox : ox < -0.001 ? (v.l - cx) / ox : 1e9;
        var ty = oy > 0.001 ? (v.t + v.h - cy) / oy : oy < -0.001 ? (v.t - cy) / oy : 1e9;
        return Math.min(tx, ty) + this.ballSize;
      }

      /* THE BREAK-OUT CHAIN.

         On the way out the cue ball works through the cards one at a
         time, and each one only turns back into a ball when the cue ball
         actually reaches it. So rather than a timed stagger, the order and
         the timing both come from a path: a polyline from wherever the cue
         ball happens to be when the roll-out starts, through each card in
         turn, and finally off the screen.

         Two things fall out of it for free. Each card's push direction is
         the direction the cue ball was travelling when it arrived, so
         cards get knocked the way they were hit rather than radially
         outward. And the cue ball changes course at every contact, which
         is what makes it look like it is hitting things.

         Precomputed here, so it is a pure function of scroll position and
         runs backwards as cleanly as everything else. */
      measureChain() {
        if (!this.cardsActive || !this.geo || !this.geo.length) return;

        if (!this.cueActive) {
          for (var q = 0; q < this.geo.length; q++) this.geo[q].hitAt = 0;
          this.chain = null;
          return;
        }

        // Where the cue ball is when the roll-out begins -- same maths
        // updateCue uses for the rebound, evaluated at that instant.
        var b0 = clamp01((this.tLeave - this.tBreak) / (1 - this.tBreak));
        var d0 = this.driftSpan * (1 - Math.pow(1 - b0, 1.8));
        // Settled by the time the roll-out starts, so these are the
        // cushions the ball will actually be bouncing off.
        var v0 = this.visBox(this.panExit);
        var start = {
          x: fold(this.cueHitX + this.driftX * d0, v0.l + this.cueR, v0.l + v0.w - this.cueR),
          y: fold(this.cueHitY + this.driftY * d0, v0.t + this.cueR, v0.t + v0.h - this.cueR)
        };

        /* ONE contact, then the pack breaks up on its own.

           The cue ball strikes the first card and rebounds; it does not
           have to visit each one in turn. That is also what a real break
           does -- the cue ball touches one ball and the energy travels
           through the pack, so everything moves at once rather than
           waiting to be individually hit. */
        var first = this.geo[0];
        var vx = first.cx - start.x;
        var vy = first.cy - start.y;
        var vl = Math.hypot(vx, vy) || 1;
        var inx = vx / vl;
        var iny = vy / vl;

        /* Stop at the CARD's edge -- not at ball-radius from its centre.

           This was the pass-through. At the moment of contact the target
           is still a full-size CARD, not a 96px ball, so backing off by a
           ball radius put the cue ball 75px INSIDE the card's face. There
           was nothing there to rebound from: it was already buried in it,
           and what you saw was the two overlapping.

           Solved properly now -- intersect the approach with the card's
           rectangle and stop one cue-ball radius short of where it enters.
           The two surfaces meet, so the bounce has something to happen
           against. */
        var hit = this.rayRect(start, inx, iny, first);
        var stop = Math.max(1, hit.t - this.cueR);
        var touch = { x: start.x + inx * stop, y: start.y + iny * stop };

        /* Every card is pushed away from THAT contact point. Radiating
           from where the hit landed is what makes the pack look shoved
           rather than exploded: the near ones go almost straight on, the
           far corner ones fan off to the sides. */
        for (var i = 0; i < this.geo.length; i++) {
          var g = this.geo[i];
          var px = g.cx - touch.x;
          var py = g.cy - touch.y;
          var pl = Math.hypot(px, py);
          if (pl < 1) {
            px = inx;
            py = iny;
            pl = 1;
          }
          g.ox = px / pl;
          g.oy = py / pl;
          g.clear = this.clearAlong(g.cx, g.cy, g.ox, g.oy);
        }

        /* Rebound off the FACE it struck, not straight back along its own
           approach. Hitting a card's left side throws the ball back
           leftward; hitting its top throws it back upward. Reversing only
           the component perpendicular to that face is what separates a
           bounce from a reversal -- and only one of the two components
           flips, so it carries on past the card instead of retracing. */
        var rbx = hit.axis === 'x' ? -inx : inx;
        var rby = hit.axis === 'x' ? iny : -iny;
        var ang = (this.driftAngle * Math.PI) / 180;
        var dir = {
          x: rbx * Math.cos(ang) - rby * Math.sin(ang),
          y: rbx * Math.sin(ang) + rby * Math.cos(ang)
        };

        /* MAKE SURE IT REACHES A SIDE RAIL.

           The section is half again as wide as it is tall, so a steep
           rebound hits the top rail, then the bottom, then leaves --
           never a side. And a ball bouncing straight up and down reads as
           a lift, not a bounce.

           So the horizontal component gets a floor: enough of the travel
           has to be across for the path to actually arrive at a left or
           right cushion. It is a floor and not an override -- if the
           rebound angle already sends it across, it is left alone. Which
           way it goes is decided by whichever side has more room, so it
           never tips itself into the near wall. */
        var across = 0.82;
        if (Math.abs(dir.x) < across) {
          var toward =
            Math.abs(dir.x) > 0.08
              ? dir.x > 0
                ? 1
                : -1
              : touch.x < this.viewW / 2
                ? 1
                : -1;
          dir.x = toward * across;
          dir.y = (dir.y > 0 ? 1 : -1) * Math.sqrt(1 - across * across);
        }

        this.chain = [start, touch].concat(this.bouncePath(touch, dir, this.cueBounces));

        /* Segment weights, not equal thirds. The strike wants to be early
           so the pack has most of the roll-out to clear in; everything
           after it shares what is left. */
        var contactShare = 0.16;
        var after = this.chain.length - 2;
        this.chainAt = [0, contactShare];
        for (var s = 1; s <= after; s++) {
          this.chainAt.push(contactShare + (1 - contactShare) * (s / after));
        }

        /* A whisper of stagger so the pack ripples outward from the
           contact instead of every card twitching on the same frame. */
        for (var j = 0; j < this.geo.length; j++) {
          this.geo[j].hitAt = Math.min(0.6, contactShare + j * 0.022);
          this.geo[j].outRoll = this.rollFor(this.geo[j].clear, this.geo[j].ox);
        }

        /* HOW FAR THE CUE BALL HAS ROLLED AT EACH TURN.

           Cumulative along the path, and SIGNED per leg -- so the spin
           reverses when the ball reverses. Without the sign it kept
           turning the same way after a bounce, which is a ball sliding
           sideways with a spin on it, not a ball rolling. */
        this.chainSpin = [0];
        for (var k = 1; k < this.chain.length; k++) {
          var lx = this.chain[k].x - this.chain[k - 1].x;
          var ly = this.chain[k].y - this.chain[k - 1].y;
          var llen = Math.hypot(lx, ly);
          var sgn = Math.abs(lx) > 1 ? (lx > 0 ? 1 : -1) : ly > 0 ? 1 : -1;
          this.chainSpin.push(
            this.chainSpin[k - 1] + sgn * (llen / (Math.PI * this.cueSize)) * 360
          );
        }

        // Frozen at the handover so the roll continues from where the
        // drift left it rather than jumping.
        this.spinAtLeave =
          this.cueRevs * 360 + (d0 / (Math.PI * this.cueSize)) * 360;
      }

      /* Turns for a given distance, and which way. Whole revolutions, so
         a ball's numeral lands upright rather than mid-tumble -- the same
         rule the approach roll uses. */
      rollFor(dist, ox) {
        var revs = Math.max(1, Math.round(dist / (Math.PI * this.ballSize)));
        return (ox >= 0 ? 1 : -1) * revs * 360;
      }

      /* The fit wrapper's transform, composed from the three things that
         decide it: where it sits at rest, how far it has slid, and the
         last-resort scale. Written in one place so no caller has to
         remember the order -- the slide is in rendered pixels, so it has
         to come before the scale. */
      /* THE WHOLE SECTION SLIDES AS ONE.

         The header used to be counter-translated so it stayed put while the
         grid moved under it, which needed a z-index above the cards and an
         opaque backdrop to cover the relative motion. None of that is
         wanted: the copy rides along with the cards, the way it would if
         you were simply scrolling the page, so all three came out. */
      writeFit() {
        if (!this.fit) return;
        var sc = this.fitScale || 1;
        var y = (this.baseY || 0) - (this.panNow || 0);
        var t = '';
        if (Math.abs(y) > 0.01) t = 'translateY(' + y.toFixed(1) + 'px)';
        if (sc !== 1) t += (t ? ' ' : '') + 'scale(' + sc.toFixed(4) + ')';
        this.fit.style.transform = t;
      }

      /* HOW FAR THE GRID HAS SLID at a given point in the pass.

         Four beats, all inside the reading hold:

           still at 0        row one settled and readable
           slide to full     the sweep down to row two
           still at full     row two settled and readable
           ease back to rest where the roll-out happens

         That last beat matters. Parked at the full slide, row one is 86%
         hidden behind the header -- so three of the six would have started
         their roll-out from behind the heading and flown out of nowhere.
         Coming back to about half leaves both rows a bit over half visible,
         which puts every ball on screen when the pack breaks up.

         Smoothstepped throughout, so it eases into and out of each beat
         instead of starting and stopping abruptly. */
      panAt(u) {
        if (!this.panMax) return 0;
        var hold = this.tLeave - this.tDealt;
        if (hold <= 0.001) return u >= this.tLeave ? this.panExit : 0;

        var a = this.tDealt + hold * 0.12;
        var b = this.tDealt + hold * 0.55;
        var c = this.tDealt + hold * 0.78;

        if (u <= a) return 0;
        if (u <= b) return this.panMax * smoothstep(clamp01((u - a) / (b - a)));
        if (u <= c) return this.panMax;
        return (
          this.panMax +
          (this.panExit - this.panMax) *
            smoothstep(clamp01((u - c) / Math.max(0.001, this.tLeave - c)))
        );
      }

      /* THE VISIBLE WINDOW, in the wrapper's own coordinates.

         With the origin at the top, the wrapper's top edge sits at baseY
         minus the slide, so the screen is looking at wrapper rows
         (pan - baseY) / scale upward for one screen's worth. Horizontally
         it is centred, so the window is wider than the wrapper by exactly
         the scale shortfall.

         Everything that needs to know where the edge of the screen is --
         how far a ball must travel to leave, where the cushions are --
         asks this, rather than assuming the wrapper and the view are the
         same box. They only are when nothing is scaled and nothing has
         slid. */
      visBox(pan) {
        var sc = this.fitScale || 1;
        var w = this.viewW / sc;
        var hh = this.viewH / sc;
        return {
          l: this.viewW / 2 - w / 2,
          t: ((pan || 0) - (this.baseY || 0)) / sc,
          w: w,
          h: hh
        };
      }

      /* Where a ray entering a card's box crosses into it, and through
         which face. Slab method: per axis, the nearer of the two edge
         crossings; the entry is the LATER of those two, and the axis that
         produced it is the face that was struck. */
      rayRect(from, dx, dy, g) {
        var hw = g.w / 2;
        var hh = g.h / 2;
        var tx = -Infinity;
        var ty = -Infinity;

        if (Math.abs(dx) > 1e-6) {
          tx = Math.min((g.cx - hw - from.x) / dx, (g.cx + hw - from.x) / dx);
        }
        if (Math.abs(dy) > 1e-6) {
          ty = Math.min((g.cy - hh - from.y) / dy, (g.cy + hh - from.y) / dy);
        }

        return tx > ty ? { t: tx, axis: 'x' } : { t: ty, axis: 'y' };
      }

      /* Ray-trace a bouncing path inside the VISIBLE box, reflecting off
         whichever wall it actually reaches. Every turn therefore happens
         exactly on a cushion -- inset by the ball's radius, so it is the
         ball's edge that touches the rail and not its centre. The last leg
         carries straight on out of frame. */
      bouncePath(from, dir, hops) {
        var v = this.visBox(this.panExit);
        var visW = v.w;
        var visH = v.h;
        var L = v.l + this.cueR;
        var T = v.t + this.cueR;
        var R = L + visW - this.cueR * 2;
        var B = T + visH - this.cueR * 2;

        var pts = [];
        var p = { x: from.x, y: from.y };
        var d = { x: dir.x, y: dir.y };

        for (var i = 0; i < hops; i++) {
          var tx = d.x > 1e-6 ? (R - p.x) / d.x : d.x < -1e-6 ? (L - p.x) / d.x : Infinity;
          var ty = d.y > 1e-6 ? (B - p.y) / d.y : d.y < -1e-6 ? (T - p.y) / d.y : Infinity;
          var t = Math.min(tx, ty);
          if (!isFinite(t) || t <= 0.5) break;

          p = { x: p.x + d.x * t, y: p.y + d.y * t };
          pts.push({ x: p.x, y: p.y });

          /* CORNERS COUNT AS ONE BOUNCE.

             When both rails are reached within a couple of ball widths of
             each other the ball is in a pocket corner, and reflecting off
             them one at a time puts two turns a few pixels apart -- which
             reads as a jitter, not two bounces. Reflecting both at once is
             what a corner actually does to a ball: it comes back out the
             way it went in. */
          if (Math.abs(tx - ty) < this.cueSize * 2) {
            d.x = -d.x;
            d.y = -d.y;
          } else if (tx < ty) {
            d.x = -d.x;
          } else {
            d.y = -d.y;
          }
        }

        var out = visW + visH;
        pts.push({ x: p.x + d.x * out, y: p.y + d.y * out });
        return pts;
      }

      measureCards(box) {
        this.list.classList.add('pristine-joint__list--measuring');

        /* WHERE THE RACK SITS.

           Anchored just below the TOP of the grid, not at its centre.
           That difference is the whole ballgame: the grid's centre is
           673px down the section on desktop and about 1400px down with a
           single column on mobile, so a rack placed there is below the
           fold. Everything that happens to it -- the ball waiting, the
           cue driving in, the break -- would play out where nobody can
           see it, and the first thing a visitor would actually catch is a
           half-scattered triangle.

           Measured off the grid's top edge instead, the rack lands just
           under the header, in the same screenful as the cue ball and the
           shaft, whatever the column count does to the grid's height. */
        var listRect = this.list.getBoundingClientRect();
        var rackCx = listRect.left - box.left + (listRect.width * this.rackX) / 100;
        var rackCy = listRect.top - box.top + this.rackOffset;

        var rack = rackLayout(this.shells.length);
        var spacing = this.ballSize * this.rackGap;
        var circumference = Math.PI * this.ballSize;
        var self = this;

        this.geo = this.shells.map(function (shell, i) {
          var r = shell.getBoundingClientRect();
          var w = r.width || 1;
          var h = r.height || 1;
          var cx = r.left - box.left + w / 2;
          var cy = r.top - box.top + h / 2;

          /* SQUASH FACTORS.

             A uniform scale keeps a 3:2 box a 3:2 box, so it can never be
             a circle. Squashing the LONG axis until the box is square is
             what lets border-radius draw a circle at all. On its own that
             would squash the card's contents too, so the inner element
             gets the exact inverse on the same axis. Child transforms
             compose INSIDE the parent's, so the two cancel for the
             contents while leaving the frame square:

               shell = T . R . Scale(S*qx, S*qy)
               inner = shell . Scale(1/qx, 1/qy) = T . R . Scale(S, S) */
          var qx = w >= h ? h / w : 1;
          var qy = w >= h ? 1 : w / h;
          var minDim = Math.min(w, h);

          var rx = rackCx + rack[i].x * spacing;
          var ry = rackCy + rack[i].y * spacing;
          var dx = rx - cx;
          var dy = ry - cy;

          /* HOW FAR EACH BALL HAS TO TRAVEL TO ACTUALLY LEAVE.

             Derived from where this ball sits and which way it is headed,
             not from a fixed number of pixels. A single distance setting
             cannot be right for six balls at different places: whatever
             value clears the outermost leaves the centre ones still
             inside the section, which is why they had to be faded out
             mid-flight -- and fading in place is what made the section
             look empty while it was still on screen.

             Solved per ball, every one of them is clipped at the edge
             instead, and the fade is only a safety net for the last
             sliver. It also cannot go stale: it re-derives from the
             section's own size on every measure. */
          var ox = dx !== 0 || dy !== 0 ? -dx : 0;
          var oy = dx !== 0 || dy !== 0 ? -dy : 0;
          var olen = Math.hypot(ox, oy);
          if (olen < 1) {
            ox = self.plan[i].fallback[0];
            oy = self.plan[i].fallback[1];
            olen = 1;
          }
          ox /= olen;
          oy /= olen;

          // Bias the direction downward so they arc toward the bottom
          // rather than only fanning out sideways.
          oy += self.outDrop;
          var blen = Math.hypot(ox, oy) || 1;
          ox /= blen;
          oy /= blen;

          /* Solve to the VISIBLE edge, not the wrapper's own edge.

             The wrapper is measured unscaled and then rendered smaller and
             centred, so its box is not where anything gets clipped -- the
             view is, and the view is bigger. Expressed in wrapper units
             there is a good 80px of visible space past each wrapper edge,
             and solving to the wrapper meant every ball finished its
             travel and began fading that far short of the boundary. They
             were dissolving in open space, which is the "balls vanish
             before I have scrolled away" all over again. */
          var clear = self.clearAlong(cx, cy, ox, oy);

          return {
            w: w,
            h: h,
            cx: cx,
            cy: cy,
            qx: qx,
            qy: qy,
            scale: clamp(self.ballSize / minDim, 0.02, 1),
            dx: dx,
            dy: dy,
            ox: ox,
            oy: oy,
            clear: clear,
            /* Turns to cover that distance. Whole revolutions of this
               ball's own circumference -- measureChain re-derives it once
               the contact has decided which way each one goes. */
            outRoll:
              (ox >= 0 ? 1 : -1) *
              Math.max(1, Math.round(clear / (Math.PI * self.ballSize))) *
              360,
            // Overwritten by measureChain when there is a cue ball to do
            // the hitting. Radially outward is the fallback.
            hitAt: 0,
            revs: Math.max(
              1,
              Math.round((Math.hypot(dx, dy) / circumference) * self.spinMult)
            )
          };
        });

        // The apex is where the white ball has to arrive.
        this.apexX = rackCx + rack[0].x * spacing;
        this.apexY = rackCy + rack[0].y * spacing;

        // Kept in page coordinates too, because the unpinned scrub keys
        // off where the RACK is on screen rather than where the grid's
        // centre is -- otherwise the timeline is centred on empty space
        // well below the action.
        this.rackPageY = listRect.top + this.rackOffset;

        this.list.classList.remove('pristine-joint__list--measuring');
      }

      measureCue(box) {
        var r = this.cueSize / 2;
        this.cueR = r;

        // Size and resting position come from CSS. These are the same
        // numbers, needed here only to work the path out from.
        this.cueParkX = (box.width * this.cueXPct) / 100;
        this.cueParkY = this.cueYPx;

        // Target: touching the apex ball, not on top of it.
        var ax = this.apexX !== undefined ? this.apexX : box.width / 2;
        var ay = this.apexY !== undefined ? this.apexY : box.height / 2;
        var vx = ax - this.cueParkX;
        var vy = ay - this.cueParkY;
        var len = Math.hypot(vx, vy) || 1;

        this.cueUx = vx / len;
        this.cueUy = vy / len;

        var stop = this.ballSize / 2 + r;
        this.cueHitX = ax - this.cueUx * stop;
        this.cueHitY = ay - this.cueUy * stop;

        var run = Math.hypot(this.cueHitX - this.cueParkX, this.cueHitY - this.cueParkY);
        this.cueRevs = Math.max(1, Math.round(run / (Math.PI * this.cueSize)));

        /* REBOUND off the pack, not onward through it.

           This was rotating the INCOMING direction by a few degrees, which
           is barely a change of course -- so the cue ball carried on the
           way it was already going and sailed straight through six solid
           balls. That is the glitch: nothing was interacting, the ball just
           kept travelling.

           Reflecting the approach vector first is what makes it a
           collision. Struck into a full rack the cue ball comes back out,
           and the deflection angle then decides which way it squirts off
           rather than whether it stops at all. */
        var a = (this.driftAngle * Math.PI) / 180;
        var bx = -this.cueUx;
        var by = -this.cueUy;
        this.driftX = bx * Math.cos(a) - by * Math.sin(a);
        this.driftY = bx * Math.sin(a) + by * Math.cos(a);

        if (this.impact) {
          var flash = this.ballSize * 4;
          this.impact.style.width = flash + 'px';
          this.impact.style.height = flash + 'px';
          this.impact.style.left = (ax - flash / 2).toFixed(1) + 'px';
          this.impact.style.top = (ay - flash / 2).toFixed(1) + 'px';
        }
      }

      measureShaft(box) {
        /* The rod is positioned ON the parked cue ball and travels along
           its own axis, so its angle can be DERIVED from the shot rather
           than set by hand: it always points exactly where the ball is
           about to go. Move the cue ball and the cue follows.

           With the element centred on the ball, the tip sits at
           parked + (d + len/2) * u, so every keyframe below is just a
           distance along u. */
        var len = this.shaft.offsetWidth || num(this.dataset.shaftLen, 900);
        this.shaftLen = len;

        var ux = this.cueUx !== undefined ? this.cueUx : 0;
        var uy = this.cueUy !== undefined ? this.cueUy : 1;

        this.shaft.style.left = (this.cueParkX || box.width / 2).toFixed(1) + 'px';
        this.shaft.style.top = (this.cueParkY || 0).toFixed(1) + 'px';

        this.shaftAngle = (Math.atan2(-uy, -ux) * 180) / Math.PI;

        this.sdContact = -(len / 2 + (this.cueR || 40)) + this.shaftNudge;

        /* THE APPROACH STARTS AT THE EDGE, not a rod-length behind it.

           Pulling back by the whole rod length parked the tip far above
           the section, so most of the approach was spent with nothing on
           screen at all and the cue only appeared at the last moment.

           Backing off just far enough to put the tip a whisker off the
           top edge means the rod is visible for the ENTIRE approach --
           growing down into frame as you scroll, which is the part meant
           to be under your control. The divisor is the axis's vertical
           component, guarded because a near-horizontal shot would send it
           to infinity. */
        var descent = Math.max(0.2, Math.abs(uy));
        var approach = (this.cueParkY - (this.cueR || 40) * uy + 40) / descent;
        this.sdStart = this.sdContact - Math.max(120, approach);
        // How far past contact the tip drives before pulling back. A
        // ball's width or so -- enough to read as a hit, not a lunge.
        this.sdPush = this.cueSize * 0.9;
      }

      /* ----------------------------------------------------------------
         CARDS
      ---------------------------------------------------------------- */

      updateCards(u) {
        var deal = clamp01((u - this.tBreak) / (this.tDealt - this.tBreak));
        var exit = clamp01((u - this.tLeave) / (1 - this.tLeave));

        for (var i = 0; i < this.shells.length; i++) {
          var shell = this.shells[i];
          var inner = this.inners[i];
          var item = this.items[i];
          var g = this.geo[i];
          var c = this.plan[i];

          var t = clamp01((deal - i * this.dealLead) / (this.dealSpan * c.spanMult));

          var ex = c.easeX(t);
          var ey = c.easeY(t);
          var rest = 1 - easeOutCubic(t);
          var swing = Math.sin(Math.PI * t);

          /* Perpendicular bow: take the rack-to-slot vector, rotate it 90
             degrees, and push the card along that normal by an amount
             peaking mid-flight. That makes a real arc rather than a
             straight line, and each card's leans a different way. */
          var len = Math.hypot(g.dx, g.dy);
          var nx = len > 1 ? g.dx / len : 0;
          var ny = len > 1 ? g.dy / len : 0;
          var bow = this.arc * c.bow * swing;

          var x = g.dx * (1 - ex) + ny * bow;
          var y = g.dy * (1 - ey) - nx * bow;

          /* Depth peaks MID-FLIGHT and is zero at both ends.

             It used to sit at -depth while racked, and that was what
             wrecked the triangle. With perspective on the <li>, a point
             at depth z is projected by P/(P-z) about that li's OWN
             centre -- so every ball's displacement to the rack got
             shrunk by ~10% toward a different origin, landing each one
             short by a different amount. Rows came out with mismatched
             centres and unequal gaps, and the balls rendered 10% smaller
             than the spacing was cut for, so they never touched.

             Zero depth at rest means no projection at rest, so the rack
             is exact. The depth cue lives entirely in the flight now,
             where nothing has to line up. */
          var z = this.depth * 0.5 * c.lift * swing;

          /* And for whatever depth remains mid-flight, undo the
             projection so the arc still passes through the points it was
             plotted for: pre-multiplying by (P-z)/P cancels the P/(P-z)
             the browser is about to apply. */
          var proj = (this.perspective - z) / this.perspective;

          var tumbleMix = rest * 0.6 + swing * 0.4;
          var rx = this.tumble * c.rotX * tumbleMix;
          var ry = this.tumble * c.rotY * tumbleMix;
          // Rolling: unwinds to an exact multiple of 360, so the card
          // lands square with no corrective tween.
          var rz = g.revs * 360 * rest * Math.sign(g.dx || 1) + this.tilt * c.tilt * rest;

          var ball = rest;
          var opacity = 1;
          var air = clamp01(rest * 0.72 + swing * 0.5);
          var zoom = 1;

          if (exit > 0) {
            /* Staggered starts, but every ball finishes at exactly the
               end of the pass.

               Sharing one span meant a ball with a short duration
               multiplier was finished at barely a third of the roll-out,
               so the object balls were all gone while a good half of the
               section was still on screen -- leaving just the cue ball
               drifting round an empty section.

               Giving each ball whatever remains of the exit from its own
               start keeps balls leaving right up to the moment the
               section does, and the stagger still reads as a sequence. */
            /* Nothing happens to this card until the cue ball reaches it.

               hitAt is where along the roll-out its contact falls, taken
               straight from the chain. Before that k is zero, so it is
               still a card: `ball` stays at 0 and the colour overlay stays
               hidden. It only starts turning back into a ball, and moving,
               once it has actually been struck. */
            var start = g.hitAt;
            var k = clamp01((exit - start) / Math.max(0.1, 1 - start));
            /* Milder back-loading than before. The chain already staggers
               the departures across the whole roll-out, so each ball can
               move steadily away from its own hit rather than hanging
               about and then bolting. */
            var ke = Math.pow(k, 1.7);

            // The distance solved per ball in measureCards, so every one
            // of them genuinely clears the section's edge by the end.
            var far = g.clear * ke;

            x += g.ox * far;
            y += g.oy * far;
            z += this.outDepth * c.outZ * ke;
            /* ROLLING, not sliding.

               This used to be the "Exit tumble" setting flat -- 40deg
               across the whole roll-out, about a ninth of one turn on a
               96px ball covering 500px. A ball that covers five times its
               own circumference has to turn five times, or the eye reads
               it as a disc being dragged.

               Derived from the distance THIS ball travels divided by its
               own circumference, so the surface speed matches the ground
               speed no matter how far out it happens to be. */
            rz += (g.outRoll || 0) * ke;
            // Tumble takes its own per-ball variance, so it is not
            // locked to the depth the way it used to be.
            rx += this.outSpin * 0.35 * c.outSpin * ke;
            zoom *= 1 - 0.28 * ke;

            /* Back to a ball on the way out -- and it ROLLS out rather
               than dissolving.

               The fade used to start at 40% of the exit, so the balls were
               already half transparent while still well inside the
               section: it emptied out and went white long before anything
               had actually left. Holding full opacity until 82% means they
               are carried out past the edge and clipped there, which is
               what leaving looks like. The last sliver of fade only covers
               anything that has not quite cleared the boundary. */
            ball = Math.max(ball, smoothstep(clamp01(k * 1.2)));
            /* Only the last tenth. The distance is now solved so each ball
               is clipped at the edge on its own, and this is a safety net
               for anything not quite clear rather than the mechanism for
               getting rid of them. Fading earlier is what emptied the
               section while it was still filling the screen. */
            opacity = 1 - smoothstep(clamp01((k - 0.9) / 0.1));
            air = Math.max(air, clamp01(ke * 1.2));
          }

          /* Roundness resolves faster than size, so by the time a card is
             at full scale it has been rectangular for a while and the last
             of the arrival is pure growth. That also keeps the
             border-radius repaints -- the one non-composited property here
             -- happening while the element is small and cheap to raster. */
          var shape = clamp01(ball / 0.5);
          var qxE = 1 + (g.qx - 1) * shape;
          var qyE = 1 + (g.qy - 1) * shape;
          var sE = (1 + (g.scale - 1) * ball) * zoom;

          shell.style.transform =
            'translate3d(' +
            (x * proj).toFixed(1) +
            'px,' +
            (y * proj).toFixed(1) +
            'px,' +
            z.toFixed(1) +
            'px) rotateX(' +
            rx.toFixed(2) +
            'deg) rotateY(' +
            ry.toFixed(2) +
            'deg) rotate(' +
            rz.toFixed(2) +
            'deg) scale(' +
            (sE * qxE).toFixed(5) +
            ',' +
            (sE * qyE).toFixed(5) +
            ')';

          inner.style.transform =
            'scale(' + (1 / qxE).toFixed(5) + ',' + (1 / qyE).toFixed(5) + ')';

          /* Elliptical radius written as "rx / ry". At full ball these are
             exactly half the box on each axis -- 50%/50% -- which the
             squash then renders as a true circle. Quantised because
             radius is a repaint, unlike transform. */
          var rq = Math.round(shape * 48) / 48;
          if (this.lastBall[i] !== rq) {
            this.lastBall[i] = rq;
            shell.style.setProperty(
              '--pj-rx',
              (this.frameR + (g.w / 2 - this.frameR) * rq).toFixed(1) + 'px'
            );
            shell.style.setProperty(
              '--pj-ry',
              (this.frameR + (g.h / 2 - this.frameR) * rq).toFixed(1) + 'px'
            );
          }

          /* The coloured ball gets its OWN tracker, not the shape one.

             `shape` saturates at 1 for every ball value above 0.5, so
             hanging the ball's opacity off it meant no update at all
             across that whole range -- the ball could sit half
             transparent with the card's placeholder showing through it,
             which is what looked like a cue stick reflected in the ball.

             Reaching full opacity by 0.38 rather than 0.8 also means the
             ball is genuinely solid for nearly all of the time it is
             supposed to be a ball. Keyed on how ball-shaped the card is,
             so one line still covers the break and the exit alike. */
          var bq = Math.round(clamp01((ball - 0.1) / 0.28) * 48) / 48;
          if (this.lastBallOpacity[i] !== bq && this.balls[i]) {
            this.lastBallOpacity[i] = bq;
            this.balls[i].style.opacity = bq.toFixed(3);
          }

          if (this.lastOpacity[i] === undefined || Math.abs(this.lastOpacity[i] - opacity) > 0.004) {
            this.lastOpacity[i] = opacity;
            shell.style.opacity = opacity.toFixed(3);
            var isGone = opacity < 0.02;
            if (isGone !== this.gone[i]) {
              this.gone[i] = isGone;
              shell.classList.toggle('is-gone', isGone);
            }
          }

          // Real z-ordering: whichever card is nearest the viewer paints
          // on top, so the pack reshuffles during flight. Written to the
          // <li>, because its perspective makes it a stacking context and
          // a z-index on the shell would be trapped inside it.
          if (item) item.style.zIndex = String(Math.round(900 + z));

          if (this.liftShadow || this.flightBlur > 0) this.updateLift(i, air);
        }
      }

      /* Shadow geometry and blur are PAINT properties -- unlike transform
         and opacity they cannot go to the compositor, so writing them
         every frame is the one genuinely expensive thing here. Quantising
         to 1/48ths cuts the repaints to about a third with no visible
         stepping, since a shadow moving half a pixel is not something an
         eye resolves. */
      updateLift(i, air) {
        var q = Math.round(air * 48) / 48;
        if (this.lastAir[i] === q) return;
        this.lastAir[i] = q;

        var shell = this.shells[i];
        if (this.liftShadow) shell.style.setProperty('--pj-lift', String(q));

        if (this.flightBlur > 0) {
          // Hysteresis, so a card sitting on the threshold does not flip
          // the filter on and off every frame.
          if (!this.airborne[i] && q > 0.05) {
            this.airborne[i] = true;
            shell.classList.add('is-airborne');
          } else if (this.airborne[i] && q < 0.02) {
            this.airborne[i] = false;
            shell.classList.remove('is-airborne');
          }
        }
      }

      /* ----------------------------------------------------------------
         THE WHITE BALL
      ---------------------------------------------------------------- */

      updateCue(u) {
        var x;
        var y;
        var spin;
        var o = 1;

        if (u <= this.tContact) {
          // Waiting to be hit. A ball at rest does not spin.
          x = this.cueParkX;
          y = this.cueParkY;
          spin = 0;
        } else if (u <= this.tBreak) {
          /* The shot. Accelerating, because a break does -- a linear
             approach reads as a slow push rather than a strike. */
          var a = clamp01((u - this.tContact) / (this.tBreak - this.tContact));
          var e = Math.pow(a, this.cueAccel);
          x = this.cueParkX + (this.cueHitX - this.cueParkX) * e;
          y = this.cueParkY + (this.cueHitY - this.cueParkY) * e;
          spin = e * this.cueRevs * 360;
        } else {
          /* Rolling around off the cushions. Decelerating, and folded
             into the view box so it rebounds off the rails. */
          var b = clamp01((u - this.tBreak) / (1 - this.tBreak));
          var d = this.driftSpan * (1 - Math.pow(1 - b, 1.8));

          /* Cushions at the edges of what is ON SCREEN, which is not the
             wrapper's own box once the grid has slid. Read per frame, so
             the ball keeps rebounding off the visible rails while the
             slide is still under way. */
          var vd = this.visBox(this.panNow);
          x = fold(this.cueHitX + this.driftX * d, vd.l + this.cueR, vd.l + vd.w - this.cueR);
          y = fold(this.cueHitY + this.driftY * d, vd.t + this.cueR, vd.t + vd.h - this.cueR);
          spin = this.cueRevs * 360 + (d / (Math.PI * this.cueSize)) * 360;

          /* ON THE WAY OUT it is the white ball that leaves, not the
             shaft. It breaks off the cushion path and rolls down out of
             the bottom of the section, accelerating -- so the last thing
             moving as the section goes is the ball that started it all,
             rather than a rod sliding away.

             Lerped from wherever the drift had it, so there is no jump at
             the moment it takes over. */
          /* The cue ball leaves LAST, not with the cards.

             It used to break for the bottom the moment the roll-out
             began, so by the time the section was still half on screen
             everything had gone and it looked empty. Holding it on the
             cushions for the first half of the exit means there is always
             something moving right up to the point the section leaves. */
          var cueOut = this.tLeave + (1 - this.tLeave) * 0.55;
          /* WORKING THROUGH THE CARDS.

             Once the roll-out starts the cue ball stops drifting and walks
             the chain instead -- a leg per card, then off the screen. Each
             leg eases out, so it leaves a contact fast and arrives at the
             next one slowing down, which is what reads as a hit rather
             than a constant glide through them. */
          if (this.chain && this.chainAt && u >= this.tLeave) {
            var ce = clamp01((u - this.tLeave) / (1 - this.tLeave));
            var at = this.chainAt;
            var si = 0;
            while (si < at.length - 2 && ce >= at[si + 1]) si++;
            var segSpan = Math.max(1e-6, at[si + 1] - at[si]);
            // Eased per leg: away from a contact fast, into the next one
            // slowing down. That is what makes each one land as a hit.
            var sf = 1 - Math.pow(1 - clamp01((ce - at[si]) / segSpan), 1.6);
            var a0 = this.chain[si];
            var a1 = this.chain[si + 1];

            var nx = a0.x + (a1.x - a0.x) * sf;
            var ny = a0.y + (a1.y - a0.y) * sf;

            /* Rolling along the path, from the running total measured at
               each turn. It used to be derived from the gap between the
               drift position and the chain position, which is not a
               distance the ball ever travelled -- so the roll neither
               matched the speed nor reversed at a bounce. */
            var s0 = this.chainSpin[si];
            spin = this.spinAtLeave + s0 + (this.chainSpin[si + 1] - s0) * sf;

            x = nx;
            y = ny;
          } else if (u > cueOut) {
            var xk = clamp01((u - cueOut) / (1 - cueOut));
            var ke = xk * xk;
            var outY = this.viewH + this.cueSize;
            y = y + (outY - y) * ke;
            x = x + (this.viewW * 0.5 - x) * ke * 0.55;
            // Still rolling as it goes.
            spin += (((outY - this.cueHitY) * ke) / (Math.PI * this.cueSize)) * 360;
          }
        }

        // A DELTA from the CSS resting position, not an absolute offset --
        // so no transform at all still leaves the ball where it belongs.
        this.cue.style.transform =
          'translate3d(' +
          (x - this.cueParkX).toFixed(1) +
          'px,' +
          (y - this.cueParkY).toFixed(1) +
          'px,0) rotate(' +
          spin.toFixed(1) +
          'deg)';
        this.cue.style.opacity = clamp01(o).toFixed(3);
        if (this.spot) this.placeSpot(spin, o);
      }

      /* THE SPOT ON A ROLLING SPHERE.

         A point painted on a ball does not orbit the middle of the disc
         -- it travels a circle in three dimensions, and for part of every
         turn that circle is behind the ball, where you cannot see it.
         Modelling that is the whole difference between a mark sliding
         around a circle and a ball that is actually rolling.

         The point sits on a latitude circle, radius r at height h, and
         the ball turns about an axis tilted back from vertical. Rotating
         that circle by the tilt gives the screen position directly, and
         the depth falls out of the same maths -- so how long it spends
         hidden is a consequence of the geometry rather than a number
         picked to look right.

         The counter-rotation matters. The ball element already carries
         rotate(spin), which would spin this offset around with it and
         double the motion; rotating the spot by -spin first cancels that
         and leaves exactly the position solved here. */
      placeSpot(spinDeg, ballOpacity) {
        var th = (spinDeg * Math.PI) / 180;
        var R = this.cueSize / 2;

        /* Latitude of the spot: h above the equator, r out from the axis.
           Sized so the spot never reaches the rim -- the ball clips its own
           overflow, and a spot cut in half by that edge reads as a bite
           taken out of it rather than as curvature. At these values its
           furthest reach is 47.7px against a 48px radius. */
        var h = R * 0.36;
        var r = R * 0.74;
        var tilt = 0.52; // about 30deg back, so the path reads as an ellipse

        var sinT = Math.sin(tilt);
        var cosT = Math.cos(tilt);
        var st = Math.sin(th);

        var px = r * Math.cos(th);
        var py = h * cosT - r * st * sinT;
        var pz = h * sinT + r * st * cosT;

        /* Fading across the rim rather than switching off at it. A spot
           that vanishes the instant its depth turns negative pops; over
           the last part of the turn it slides out of sight the way a real
           one does. */
        var facing = clamp01((pz / R + 0.16) / 0.3);

        /* Foreshortening. A spot square-on to you is a circle; the same
           spot near the edge of the sphere is seen at an angle and reads
           narrower. Scaling with depth costs nothing and is most of what
           sells it as being ON the ball rather than over it. */
        var fore = 0.72 + 0.28 * Math.abs(pz / R);

        this.spot.style.transform =
          'rotate(' +
          (-spinDeg).toFixed(1) +
          'deg) translate(' +
          px.toFixed(1) +
          'px,' +
          py.toFixed(1) +
          'px) scale(' +
          fore.toFixed(3) +
          ')';
        this.spot.style.opacity = (facing * 0.92 * clamp01(ballOpacity)).toFixed(3);
      }

      /* ----------------------------------------------------------------
         THE SHAFT
      ---------------------------------------------------------------- */

      updateShaft(u) {
        var d;
        var o;

        if (u <= this.tContact) {
          var a = clamp01(u / this.tContact);
          d = this.sdStart + (this.sdContact - this.sdStart) * Math.pow(a, this.cueAccel);
          o = clamp01(a / 0.12);
        } else {
          /* Short follow-through, then it WITHDRAWS back the way it came
             rather than sliding on through the pack and off the bottom.
             A cue does not carry on through the table -- the stroke ends
             and the player pulls back, and that is also what leaves the
             screen clear for the balls to do the work.

             sin() over the first third gives the punch through and
             recovery; the second term walks it back behind where it
             started. */
          var b = clamp01((u - this.tContact) / (this.tDealt - this.tContact));
          var push = Math.sin(Math.PI * clamp01(b / 0.34));
          var back = Math.pow(clamp01((b - 0.28) / 0.72), 1.6);

          d =
            this.sdContact +
            this.sdPush * push -
            (this.sdContact - this.sdStart + 140) * back;
          o = clamp01((1 - b) / 0.32);
        }

        // Travelling along its own axis, which is the same axis the ball
        // leaves on.
        this.shaft.style.transform =
          'translate3d(' +
          (d * this.cueUx).toFixed(1) +
          'px,' +
          (d * this.cueUy).toFixed(1) +
          'px,0) rotate(' +
          this.shaftAngle.toFixed(2) +
          'deg)';
        this.shaft.style.opacity = (o * this.shaftOpacity).toFixed(3);
      }

      /* A cubed falloff over a narrow band around the break, so it is a
         strike rather than a glow -- and being a pure function of u it
         reverses cleanly on the way back up. */
      updateImpact(u) {
        var punch = Math.pow(clamp01(1 - Math.abs(u - this.tBreak) / 0.055), 3);
        var q = Math.round(punch * 64) / 64;
        if (this.lastPunch === q) return;
        this.lastPunch = q;
        this.impact.style.opacity = (q * this.flashMax).toFixed(4);
      }

      updateGlow(u) {
        var near = clamp01(1 - Math.abs(u - this.tBreak) / 0.3);
        var edges = Math.min(clamp01(u / 0.06), clamp01((1 - u) / 0.14));
        var q = Math.round(this.glowBase * (0.34 + 0.66 * near * near) * edges * 64) / 64;
        if (this.lastGlow === q) return;
        this.lastGlow = q;
        this.glow.style.opacity = q.toFixed(4);
      }

      /* ----------------------------------------------------------------
         HEADER

         Driven by the TIMELINE, and deliberately not latched.

         Everywhere else I have tied a header reveal to the element's own
         position, precisely to avoid leaving visible text sitting at zero
         opacity. Here that is the entire point: the section opens on
         nothing but the rack and the cue ball, and the copy only arrives
         once the cue ball has been struck. Scrolling back up takes it
         away again, which is what makes the strike feel like the thing
         that summoned it.

         The reveal spans from contact to most of the way through the cue
         ball's run at the pack, so the text has finished landing by the
         time the break happens.
      ---------------------------------------------------------------- */

      prepareText() {
        if (!this.header) return false;
        this.eyebrow = this.header.querySelector('.pristine-joint__eyebrow');
        this.headingEl = this.header.querySelector('.pristine-joint__heading');
        this.sub = this.header.querySelector('.pristine-joint__subheading');
        if (!(this.eyebrow || this.headingEl || this.sub)) return false;

        this.words = this.splitWords && this.headingEl ? splitWords(this.headingEl) : [];
        for (var i = 0; i < this.words.length; i++) {
          this.words[i].style.setProperty('--pj-i', String(i));
        }

        /* ARM AND WIRE IN THE SAME BREATH.

           The hidden state and the thing that undoes it are set up
           together, on purpose: there is no window in which the copy can
           be hidden by something that is not already guaranteed to reveal
           it. Arming is the last step, so if any of this throws, the CSS
           default has left the text readable. */
        var host = this;
        var reveal = function () {
          host.header.classList.add('pj-in');
        };

        if (window.IntersectionObserver) {
          this.textIO = new IntersectionObserver(
            function (entries) {
              for (var k = 0; k < entries.length; k++) {
                if (!entries[k].isIntersecting) continue;
                reveal();
                if (host.textIO) {
                  host.textIO.disconnect();
                  host.textIO = null;
                }
                return;
              }
            },
            /* A shade of the header on screen is enough. Waiting for a
               larger share is what used to leave it blank on a short
               screen, where a large share of a 286px header never
               qualifies until it is halfway up the page. */
            { threshold: 0.01, rootMargin: '0px 0px -8% 0px' }
          );
          this.textIO.observe(this.header);
        }

        this.header.classList.add('pj-armed');

        /* Already on screen at load -- an anchor link, a reload part-way
           down, the theme editor jumping to the section -- gets revealed on
           the next frame rather than waiting for a scroll that may never
           come. The frame's delay is what lets the transition actually run
           instead of starting in its finished state. */
        var r = this.header.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          requestAnimationFrame(function () {
            requestAnimationFrame(reveal);
          });
        }

        // Belt and braces: no observer support, no waiting.
        if (!window.IntersectionObserver) reveal();

        return true;
      }

      /* NOTHING HERE ANY MORE, and that is the fix.

         The copy used to be revealed by a per-frame calculation off the
         header's position. It is now a one-shot CSS transition triggered by
         an IntersectionObserver, which means the browser decides when the
         header is on screen rather than arithmetic that had to be right
         about the pin state, the progress mapping and the measure timing
         all at once. Three rounds of a missing heading all came from that
         arithmetic, never from the styling.

         Kept as a no-op so the update loop and the settle passes need no
         special case. */
      updateText() {}

      /* ----------------------------------------------------------------
         SHARED SCROLL READ
      ---------------------------------------------------------------- */

      readScroll() {
        var vh = window.innerHeight;

        /* PINNED: progress comes from the TRACK, not the content.

           Once the view is stuck the grid stops moving on screen, so
           measuring the grid would read a constant and everything would
           freeze for the whole pin. The track keeps scrolling underneath,
           so it is the only thing that still knows how far through we are.

           The lead-in counts part of the approach, so the shot can land on
           the way in rather than waiting for the pin to lock; the run-on
           counts the tail after it releases, so the cards are still
           scattering while the section travels. */
        if (this.pinned && this.track) {
          var t = this.track.getBoundingClientRect();
          var span = t.height - vh;
          var total = (vh * this.leadIn) / 100 + span + (vh * this.leadOut) / 100;
          var pinU = total > 0 ? clamp01(((vh * this.leadIn) / 100 - t.top) / total) : 0;
          return { sig: 1 - 2 * pinU, u: pinU };
        }

        /* UNPINNED FALLBACK.

           u = 1 HAS TO LAND WHERE THE SECTION LEAVES, and nowhere else.

           This is what kept emptying the section early, and it was not the
           opacity or the timeline -- it was here. Keyed on the RACK's
           position with a 55% window, u reached 1 while the rack was still
           7px below the top of the screen. The rack sits 200px into a grid
           that is another 800px tall, so the section was 83% on screen
           with the entire roll-out already finished and everything gone.
           No amount of retuning the exit could reach that, because the
           clock had simply run out early.

           Anchored to the section's OWN travel instead -- from its top
           edge appearing at the bottom of the screen through to its bottom
           edge clearing the top -- the roll-out cannot possibly finish
           while any of the section is still showing.

           The window and anchor pair now only ever DELAYS the start, so
           the strike can land as the section comes in. They cannot bring
           the end forward: the end is the departure, always, whatever
           they are set to. */
        var rect = this.getBoundingClientRect();
        var travel = Math.max(1, rect.height + vh);
        var passed = vh - rect.top;
        var begin = travel * (1 - this.windowPct / 100) * (this.anchor / 100);
        var freeU = clamp01((passed - begin) / Math.max(1, travel - begin));

        return { sig: 1 - 2 * freeU, u: freeU };
      }

      update() {
        var m = this.readScroll();

        if (this.lastSig !== undefined && Math.abs(m.sig - this.lastSig) < 0.0012) return;
        this.lastSig = m.sig;

        /* The slide first: the cue ball's cushions are the edges of the
           visible window, so where that window is has to be settled before
           anything is positioned inside it. */
        if (this.panMax) {
          this.panNow = this.panAt(m.u);
          this.writeFit();
        }

        if (this.cardsActive) this.updateCards(m.u);
        if (this.cueActive) this.updateCue(m.u);
        if (this.shaftActive) this.updateShaft(m.u);
        if (this.impact) this.updateImpact(m.u);
        if (this.glowActive) this.updateGlow(m.u);
        if (this.textActive) this.updateText(m.u);
      }

      onScroll() {
        if (this.frame) return;
        var self = this;
        this.frame = requestAnimationFrame(function () {
          self.frame = null;
          self.update();
        });
      }

      onResize() {
        var self = this;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
          self.measure();
          self.lastSig = undefined;
          self.lastBall = new Array(self.shells.length);
          self.update();
        }, 150);
      }
    }

    customElements.define('pristine-joint-break', PristineJointBreak);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pristine-shaft-roll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('pristine-shaft-roll')) return;

    function clamp01(n) {
      return n < 0 ? 0 : n > 1 ? 1 : n;
    }

    function num(v, fallback) {
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class PristineShaftRoll extends HTMLElement {
      connectedCallback() {
        if (this.setUp) return;
        this.setUp = true;

        this.track = this.querySelector('[data-sr-track]');
        this.view = this.querySelector('[data-sr-view]');
        this.canvas = this.querySelector('[data-sr-canvas]');
        this.wrapper = this.closest('.pristine-shaftroll');
        this.poster = this.querySelector('[data-sr-poster]');
        this.bar = this.querySelector('[data-sr-bar]');

        /* A frame URL that leads nowhere is silent -- the canvas simply
           never gets a picture. The poster is the one frame loaded as a
           real image, so it is the only one that can report back. */
        var setup = document.getElementById('ShaftRollSetup-' + this.dataset.sectionId);
        if (setup && this.poster) {
          this.poster.addEventListener('error', function () {
            setup.hidden = false;
          });
        }

        if (!this.track || !this.view || !this.canvas) return;

        var payload = this.querySelector('script[type="application/json"]');
        try {
          this.urls = payload ? JSON.parse(payload.textContent) || [] : [];
        } catch (e) {
          this.urls = [];
        }
        if (this.urls.length < 2) return;

        var d = this.dataset;
        this.pinWanted = d.pin === '1';
        this.pinMobile = d.pinMobile === '1';
        this.overHeader = d.over === '1';
        this.mode = d.mode === 'topbar' || d.mode === 'below' ? d.mode : 'pinned';

        /* Both bar modes are the same machine pointed at a different edge
           of the screen: fixed rather than pinned, a wrapping timeline
           rather than a clamped one, always on screen rather than observed
           into view. Naming that once is better than testing for two mode
           strings in nine places and eventually forgetting one. */
        this.isBar = this.mode === 'topbar' || this.mode === 'below';

        this.revealAfter = Math.max(0, num(d.reveal, 40));
        this.rollDistance = Math.max(10, num(d.rollDistance, 200));
        this.pushHeader = d.push === '1';
        this.headerSelector = d.headerSelector || '';
        this.barOffset = num(d.offset, 0);

        /* How much of the remaining rotation to cover each frame. Low is
           glidey, 1 is locked rigidly to the scroll. Inverted from the
           setting because "more smoothing" has to mean "move less of the
           way per frame", which is the smaller number. */
        this.smooth = 1 - (clamp01(num(d.smooth, 85) / 100) * 0.94);
        this.turns = null;
        this.lastTop = null;
        /* In the editor the strip stays out, whatever the scroll position.
           Hidden until the page moves is right for a shop and useless for
           the person configuring it -- the preview usually sits at the top,
           so the section would simply never be there to click on. */
        this.designMode = d.design === '1';
        this.ease = num(d.ease, 100) / 100;
        this.fit = d.fit === 'contain' ? 'contain' : 'cover';
        this.focalX = clamp01(num(d.focalX, 50) / 100);
        this.focalY = clamp01(num(d.focalY, 50) / 100);
        this.eager = d.eager === '1';
        this.margin = Math.max(0, num(d.margin, 1200));
        this.concurrency = Math.max(1, Math.round(num(d.concurrency, 8)));

        this.ctx = this.canvas.getContext('2d');
        this.cache = new Array(this.urls.length);
        this.lastDrawn = -1;
        this.ready = false;
        this.onScreen = true;

        /* REDUCED MOTION STOPS HERE.

           The poster is already painted with a real src, so the banner is
           complete without another byte. Fetching twenty-nine more frames
           nobody will see would be the worst of both worlds. */
        if (prefersReducedMotion()) {
          this.classList.add('is-ready');

          /* A bar is a position, not an animation. It still takes the
             announcement bar's place, or still sits under the header --
             it simply holds one frame and never rolls. The slide itself is
             disabled in CSS, and the bar under the header still has to be
             kept under a header that moves. */
          if (this.isBar) {
            this.onScroll = this.onScroll.bind(this);
            this.onResize = this.onResize.bind(this);
            if (this.mode === 'below') this.updateBelow();
            else this.updateStrip();
            window.addEventListener('scroll', this.onScroll, { passive: true });
            /* A header changes height at a breakpoint without anyone
               scrolling, and nothing else here would notice. */
            window.addEventListener('resize', this.onResize);
          }
          return;
        }

        this.isOver = false;
        this.showing = false;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.decidePin();
        this.measure();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.watch();

        /* Settle on the correct state before anyone touches the wheel.

           Everything else here is driven by scrolling, which is fine for a
           section you scroll to and wrong for one that is already at the
           top of the page: reload halfway down and the strip would stay
           hidden until the next scroll event, and in the editor -- where
           the preview sits at the top and may never be scrolled at all --
           it would never appear. */
        this.update();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.resizeTimer);
        if (this.io) this.io.disconnect();
        if (this.vis) this.vis.disconnect();
      }

      /* NOTHING LOADS UNTIL IT IS NEARLY NEEDED.

         A sequence is the heaviest thing on the page and a banner is not
         the most important, so the fetch waits until the section is within
         about a screenful. Above-the-fold content gets the bandwidth
         first. */
      watch() {
        var self = this;

        /* THE STRIP CANNOT WAIT TO BE SEEN.

           Deferring the fetch until the section scrolls into view depends
           on the section being somewhere to scroll to. The strip is fixed
           and parked above the top edge, so its box is never within a
           screen of anything -- an observer watching for it would wait
           forever, and the sequence would never load at all. It is also a
           banner: it is wanted at the first flick of the wheel, not a
           screenful later. So it loads straight away. */
        if (this.eager || this.isBar || !('IntersectionObserver' in window)) {
          this.preload();
        } else {
          this.io = new IntersectionObserver(
            function (entries) {
              if (!entries[0].isIntersecting) return;
              self.io.disconnect();
              self.io = null;
              self.preload();
            },
            { rootMargin: this.margin + 'px 0px' }
          );
          this.io.observe(this);
        }

        /* Scroll work stops entirely while the banner is off screen --
           except in strip mode, where "off screen" is its resting state and
           the observer would switch the whole thing off permanently. */
        if (!this.isBar && 'IntersectionObserver' in window) {
          this.vis = new IntersectionObserver(function (entries) {
            self.onScreen = entries[0].isIntersecting;
            if (self.onScreen) self.update();
          });
          this.vis.observe(this);
        }
      }

      /* EVERY FRAME FETCHED AND DECODED BEFORE ANY IS SHOWN.

         Assigning src is not enough: the bytes can be in cache while the
         pixels are not, and the decode then lands on the frame you try to
         display. decode() moves that work off the critical path and reports
         when it has genuinely finished.

         Concurrency is capped and the queue refills as each one resolves,
         so requests complete in a predictable order rather than thirty
         stalling together against the connection limit. */
      preload() {
        if (this.loading) return;
        this.loading = true;

        var self = this;
        var urls = this.urls;
        var next = 0;
        var finished = 0;

        function progress() {
          finished += 1;
          if (self.bar) {
            self.bar.style.width = Math.round((finished / urls.length) * 100) + '%';
          }
          if (finished >= urls.length) {
            self.ready = true;
            self.classList.add('is-ready');
            self.resize();
            self.lastDrawn = -1;
            self.update();
            return;
          }
          start();
        }

        function start() {
          if (next >= urls.length) return;
          var i = next++;
          var img = new Image();
          img.decoding = 'async';

          function ok() {
            img.__ok = true;
            self.cache[i] = img;
            if (i === 0) self.draw(0, true);
            progress();
          }

          function fail() {
            img.__ok = false;
            self.cache[i] = img;
            progress();
          }

          img.onerror = fail;

          if (typeof img.decode === 'function') {
            img.src = urls[i];
            img.decode().then(ok, function () {
              /* Safari can reject decode() on an already-cached image.
                 Falling back to load is still correct, only less eager. */
              if (img.complete && img.naturalWidth > 0) ok();
              else {
                img.onload = ok;
              }
            });
          } else {
            img.onload = ok;
            img.src = urls[i];
          }
        }

        for (var k = 0; k < Math.min(this.concurrency, urls.length); k++) start();
      }

      decidePin() {
        /* The strip is fixed, so there is nothing to pin. Pinning and
           fixing are alternatives, not layers: a fixed element has already
           left the flow, and a track reserving scroll for it would only add
           an empty stretch of page. */
        if (this.isBar) {
          this.pinned = false;
          this.track.classList.remove('pristine-shaftroll__track--pinned');
          return;
        }

        if (!this.pinWanted) {
          this.pinned = false;
          this.track.classList.remove('pristine-shaftroll__track--pinned');
          return;
        }
        var allowed = this.pinMobile || window.innerWidth >= 750;
        this.pinned = allowed;
        this.track.classList.toggle('pristine-shaftroll__track--pinned', allowed);
      }

      measure() {
        this.viewH = this.view.offsetHeight || 1;
        /* The pinned run is the track's height less the banner's own: how
           far the track still has to travel once the view has stopped
           moving. Derived rather than read back from the setting, so it
           holds whatever the banner's height turns out to be. */
        this.span = Math.max(1, this.track.offsetHeight - this.viewH);
        this.resize();
      }

      /* Backed at devicePixelRatio, capped at 2. Uncapped, a 3x phone
         quadruples the fill cost for a difference nobody can see. */
      resize() {
        if (!this.ctx) return;
        var r = this.view.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(r.width * dpr);
        this.canvas.height = Math.round(r.height * dpr);
        this.canvas.style.width = r.width + 'px';
        this.canvas.style.height = r.height + 'px';
        if (this.lastDrawn >= 0) this.draw(this.lastDrawn, true);
      }

      /* object-fit in canvas maths, so frames never distort and the focal
         point behaves the way the CSS equivalent would. */
      draw(i, force) {
        if (!this.ctx) return;
        var img = this.cache[i];
        if (!img || !img.__ok) return;
        if (i === this.lastDrawn && !force) return;

        var cw = this.canvas.width;
        var ch = this.canvas.height;
        var iw = img.naturalWidth;
        var ih = img.naturalHeight;
        if (!iw || !ih) return;

        var scale =
          this.fit === 'contain' ? Math.min(cw / iw, ch / ih) : Math.max(cw / iw, ch / ih);
        var dw = iw * scale;
        var dh = ih * scale;

        this.ctx.clearRect(0, 0, cw, ch);
        this.ctx.drawImage(img, (cw - dw) * this.focalX, (ch - dh) * this.focalY, dw, dh);
        this.lastDrawn = i;
      }

      /* Progress across the pinned run.

         Taken from the TRACK, because once the view is stuck it no longer
         moves and measuring it would read a constant. The track keeps
         travelling underneath, so it is the only thing that still knows how
         far through we are. */
      /* BAR MODE: the page itself is the timeline, counted in whole turns.

         There is no track travelling past to measure, so the shaft's
         rotation is simply how far the page has moved divided by the
         distance set for one full turn.

         This returns turns UNWRAPPED -- 2.4 rather than 0.4 -- and that
         matters more than it looks. The frames are one complete rotation,
         so the sequence has to repeat; but a value that jumps from 0.99
         back to 0.01 cannot be smoothed, because any easing would read
         that as a violent lurch backwards through the whole turn. Kept
         unwrapped, the number only ever climbs, smoothing works on it
         normally, and the wrap happens at the last possible moment when
         the frame index is chosen. */
      readTurns() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var per = (this.rollDistance / 100) * window.innerHeight;
        return y / Math.max(1, per);
      }

      readScroll() {
        var r = this.track.getBoundingClientRect();

        if (!this.pinned) {
          /* Unpinned, the banner's own travel across the window drives it,
             so the roll still follows the scroll instead of freezing on one
             frame. */
          var vh = window.innerHeight;
          return clamp01((vh - r.top) / (this.viewH + vh));
        }

        var offset = parseFloat(getComputedStyle(this.view).top) || 0;
        return clamp01(-(r.top - offset) / this.span);
      }

      /* THE STRIP APPEARS ONCE THE PAGE HAS MOVED.

         Held back until the announcement bar has had a chance to scroll
         away, so the two are never on screen together and the strip reads
         as taking its place rather than crowding it.

         The header is pushed down by a class on the body rather than by
         writing to the header itself. The theme owns that element and may
         well be animating its own top value; adding a class it can carry
         is a smaller intrusion than fighting it for the property. */
      updateStrip() {
        if (!this.wrapper) return;

        var show =
          this.designMode ||
          (window.pageYOffset || document.documentElement.scrollTop || 0) > this.revealAfter;
        if (show === this.showing) return;
        this.showing = show;

        this.wrapper.classList.toggle('is-showing', show);

        if (this.pushHeader) {
          /* The transition class goes on first and stays on, so the header
             eases both ways rather than snapping back on the way up. */
          document.body.classList.add('pristine-shaftroll-showing-transition');
          document.body.classList.toggle('pristine-shaftroll-showing', show);
        }
      }

      /* Stuck means: pinning is on, the track has reached the top, and it
         has not yet been used up. Read straight from the geometry rather
         than inferred from progress, because progress is clamped at both
         ends and would keep the banner raised long after it had gone. */
      updateOverlay() {
        if (!this.wrapper) return;

        var over = false;
        if (this.pinned && this.overHeader) {
          var r = this.track.getBoundingClientRect();
          var offset = parseFloat(getComputedStyle(this.view).top) || 0;
          over = r.top <= offset + 1 && r.bottom > this.viewH + offset;
        }

        if (over === this.isOver) return;
        this.isOver = over;
        this.wrapper.classList.toggle('is-over', over);
      }

      update() {
        if (this.mode === 'topbar') this.updateStrip();
        else if (this.mode === 'below') this.updateBelow();
        else this.updateOverlay();

        if (!this.ready) return;

        if (this.isBar) {
          this.rollBar();
          return;
        }

        var u = this.readScroll();

        /* Eased toward the middle when asked for. Evenly rotated stills
           play back at an even rate, which is correct and can read as
           mechanical; this lends a little weight at each end without
           changing which frames exist. */
        if (this.ease !== 1) {
          u =
            u < 0.5 ? Math.pow(u * 2, this.ease) / 2 : 1 - Math.pow((1 - u) * 2, this.ease) / 2;
        }

        var last = this.urls.length - 1;
        var idx = Math.round(u * last);
        if (idx < 0) idx = 0;
        if (idx > last) idx = last;

        this.draw(idx);
      }

      /* THE SHAFT ROLLS ITSELF, THE SCROLL ONLY TELLS IT HOW FAR.

         Locking the frame directly to the scroll position sounds right and
         looks wrong, because a mouse wheel does not move the page smoothly:
         it moves it in jumps of roughly a hundred pixels. Bound one to one,
         the shaft leaps three or four frames, sits still, then leaps again.
         It reads as a slider being dragged, not as something rolling.

         So the scroll sets a TARGET rotation and the shaft travels toward
         it under its own steam, a fraction of the remaining distance each
         frame. Scroll down and it rolls; keep scrolling and it keeps
         rolling; stop, and it turns the last little way and settles. The
         motion is continuous even though the input is not.

         It also has to keep asking for frames on its own. Everything else
         here is woken by a scroll event, but the whole point is that this
         is still moving after the scrolling has stopped, so while it has
         distance left to cover it schedules itself. */
      rollBar() {
        var target = this.readTurns();

        if (this.turns == null) this.turns = target;

        var d = target - this.turns;

        /* Close enough to done: land exactly, and stop asking for frames.
           Without a floor the gap only ever gets smaller and the loop runs
           for ever at a rotation nobody can see changing. */
        if (Math.abs(d) < 0.0005) {
          this.turns = target;
        } else {
          this.turns += d * this.smooth;
        }

        /* Wrap at the last moment. Modulo the count, not the count less
           one: the last frame is followed by the first, so there is no
           endpoint to land on exactly. */
        var n = this.urls.length;
        var frac = this.turns - Math.floor(this.turns);
        var idx = Math.floor(frac * n) % n;

        this.draw(idx);

        if (this.turns !== target) this.keepRolling();
      }

      keepRolling() {
        if (this.frame) return;
        var self = this;
        this.frame = requestAnimationFrame(function () {
          self.frame = null;
          self.update();
        });
      }

      /* WHERE THE HEADER ENDS, MEASURED RATHER THAN ASSUMED.

         Themes disagree about the header: it may be sticky or not, it may
         shrink once the page moves, and its height differs between
         breakpoints and between one merchant's logo and another's. Reading
         its bottom edge off the page each time sidesteps every one of those
         questions -- whatever the header is doing, the bar is directly
         under it. When the header scrolls away entirely the edge goes
         negative, which clamps to the top of the window, and the bar takes
         over the top of the screen. */
      updateBelow() {
        if (!this.wrapper) return;

        var top = 0;
        if (this.headerSelector) {
          var h = document.querySelector(this.headerSelector);
          if (h) top = Math.max(0, h.getBoundingClientRect().bottom);
        }
        top += this.barOffset;

        if (top === this.lastTop) return;
        this.lastTop = top;
        this.wrapper.style.setProperty('--sr-bar-top', top + 'px');
      }

      /* The listener only ever schedules. Measuring inside it is what makes
         a scroll-linked effect stutter, and a frame that has not changed
         costs nothing beyond the comparison. */
      onScroll() {
        /* The strip is fixed, so it is always on screen -- the off-screen
           short-circuit belongs to the pinned mode only. */
        if (this.frame || (!this.isBar && !this.onScreen)) return;
        var self = this;
        this.frame = requestAnimationFrame(function () {
          self.frame = null;
          self.update();
        });
      }

      onResize() {
        var self = this;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
          self.decidePin();
          self.measure();
          self.lastDrawn = -1;
          self.update();
        }, 150);
      }
    }

    customElements.define('pristine-shaft-roll', PristineShaftRoll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tallmade-craftsmanship"] && !Shopify.designMode) return;
  try {
    
/* ===================================================================
   CRAFTSMANSHIP -- SLIDER AND TILE MEDIA
   -------------------------------------------------------------------
   Lives in this section's own javascript block, which Shopify emits
   ONCE per section type however many Craftsmanship sections are on the
   page. Everything is found inside each [data-craf-root], so two of
   them on one page no longer fight over one set of element ids.

   WHY THE SLIDER INDEX DRIVES PLAYBACK, AND NOT IntersectionObserver
   A tile translated out of view is clipped by .craf-slider-viewport
   (overflow:hidden) on desktop and by .craf-section
   (overflow-x:hidden) on mobile. An observer's rootMargin expands its
   ROOT rect, not intermediate clipping ancestors, so a tile one step
   away can never be reported as "near" -- there is no way to pre-warm
   from an observer. The slider knows exactly which tiles are about to
   appear, so it says so.

   Static mode (three or fewer tiles, or fewer tiles than fit) has no
   transform and no clipping, so there an observer IS the right signal
   and is what gets used.

   THE WRAP HANDOFF
   Sliding into a clone and jumping back to the real tile swaps one
   <video> for another playing the same file at a different position.
   Before the jump, `currentTime` is copied across and the destination
   is already decoding, so the swap does not show.

   NOT BEFORE THE SECTION IS NEAR
   In slider mode nothing is attached until the SECTION (not a tile --
   the section is never clipped, so an observer works on it) is within
   NEAR_MARGIN of the viewport. Until then the wanted set is empty.
   The inline first-paint script uses the same margin and sets
   root._crafNear, so whichever of the two sees it first, both agree.
   =================================================================== */
(function () {
  'use strict';

  var MOBILE_MAX = 749;
  var TABLET_MAX = 989;
  var SLIDE_MS = 450;      /* matches the CSS transition duration */
  var TICK_MS = 500;
  var STALL_TICKS = 4;
  var NEAR_MARGIN = '150% 0px';   /* same as the inline first-paint script */

  function perView() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w <= MOBILE_MAX) return 1;
    if (w <= TABLET_MAX) return 2;
    return 4;
  }

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth || 0) <= MOBILE_MAX;
  }

  /* ---------- media primitives, shared by both modes ---------- */

  function mediaOf(tile) { return tile.querySelector('[data-craf-media]'); }

  function attach(v) {
    if (!v || v._crafOn) return;
    var src = v.getAttribute('data-craf-src');
    if (!src) return;
    v._crafOn = true;
    /* muted has to be set as a PROPERTY. The attribute alone is not
       enough -- a browser that restored a previous unmuted state will
       refuse to autoplay and give no error worth reading. */
    v.muted = true;
    v.defaultMuted = true;
    /* "auto", not "metadata": everything this attaches is about to be
       played, and metadata alone can leave the element showing nothing
       while it decides to fetch more. */
    v.setAttribute('preload', 'auto');
    v.src = src;
  }

  function release(v) {
    if (!v || !v._crafOn) return;
    v._crafOn = false;
    v._crafLast = -1;
    v._crafSame = 0;
    try {
      v.removeAttribute('src');
      /* load() is what actually hands the resource back. Clearing src
         alone leaves the element holding it. */
      v.load();
    } catch (e) {}
  }

  function play(v) {
    if (!v || !v._crafOn) return;
    v.muted = true;
    var p;
    try { p = v.play(); } catch (e) { return; }
    /* A rejected play() is the normal state under Low Power Mode or a
       strict autoplay policy. Swallow it; the gesture handler retries. */
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }

  function pauseQuietly(v) {
    if (!v) return;
    v._crafPausing = true;
    try { if (!v.paused) v.pause(); } catch (e) {}
    v._crafPausing = false;
  }

  /* Restart paths, because `loop` on its own is not dependable. */
  function wireMedia(v, isWanted) {
    if (!v || v._crafWired) return;
    v._crafWired = true;
    v._crafLast = -1;
    v._crafSame = 0;

    v.addEventListener('ended', function () {
      if (!isWanted(v)) return;
      try { v.currentTime = 0; } catch (e) {}
      play(v);
    });
    /* Any pause we did not ask for -- an OS interruption, a decoder
       taken away -- is one to undo. */
    v.addEventListener('pause', function () {
      if (v._crafPausing || !isWanted(v)) return;
      play(v);
    });
    v.addEventListener('stalled', function () { if (isWanted(v)) play(v); });
    v.addEventListener('loadedmetadata', function () { if (isWanted(v)) play(v); });
  }

  /* ---------- one section ---------- */

  function initRoot(root) {
    if (root._crafInit) return;
    root._crafInit = true;

    var track = root.querySelector('[data-craf-track]');
    if (!track) return;
    var viewport = root.querySelector('[data-craf-viewport]') || track.parentElement;
    var prev = root.querySelector('[data-craf-prev]');
    var next = root.querySelector('[data-craf-next]');

    var origTiles = [].slice.call(track.querySelectorAll('[data-craf-tile]'));
    var total = origTiles.length;
    if (!total) return;

    var tiles = origTiles.slice();   /* every tile in the track, DOM order */
    var builtFor = -1;               /* the perView the track is built for */
    var cur = 0;
    var sliding = false;
    var endTimer = null;
    var timer = null;
    var io = null;
    var wanted = [];                 /* videos that should be playing now */

    /* The section keeps the original gate: three or fewer tiles never
       slide, matching the Liquid that does not even render the arrows. */
    var canSlide = total > 3;

    /* True once the section has come within NEAR_MARGIN of the
       viewport. The inline first-paint script may already have seen
       that happen before this bundle ran. */
    var near = !!root._crafNear || !('IntersectionObserver' in window);

    function isWanted(v) { return wanted.indexOf(v) >= 0; }

    function allMedia() {
      var out = [];
      for (var i = 0; i < tiles.length; i++) {
        var v = mediaOf(tiles[i]);
        if (v) out.push(v);
      }
      return out;
    }

    /* ---------- watchdog ---------- */

    function tick() {
      var live = 0;
      for (var i = 0; i < wanted.length; i++) {
        var v = wanted[i];
        if (!v._crafOn) continue;
        live++;
        if (v.paused || v.ended) { play(v); continue; }
        if (v.seeking || v.readyState < 2) continue;
        if (v.currentTime === v._crafLast) {
          v._crafSame = (v._crafSame || 0) + 1;
          if (v._crafSame >= STALL_TICKS) { v._crafSame = 0; play(v); }
        } else {
          v._crafLast = v.currentTime;
          v._crafSame = 0;
        }
      }
      if (!live && timer) { clearInterval(timer); timer = null; }
    }

    function startTimer() { if (!timer) timer = setInterval(tick, TICK_MS); }

    /* ---------- apply a wanted set ---------- */

    /* Cap on how many tiles may hold a media resource at once. Above
       the wanted set there is deliberate slack: a tile that is merely
       paused keeps its last frame painted, so stepping back to it shows
       a picture instead of the tile's #111111 ground. Releasing is what
       protects the phone's decoders, so it still happens -- just to the
       tiles furthest from what you are looking at, rather than to
       everything the moment it leaves the window. */
    function poolCap() {
      var pv = builtFor > 0 ? builtFor : 1;
      return pv <= 1 ? 4 : 2 * pv;
    }

    /* How far a track position is from the visible window. */
    function distanceFromView(pos) {
      var pv = builtFor;
      if (pv < 1) return 0;
      var first = pv + cur, last = pv + cur + pv - 1;
      if (pos < first) return first - pos;
      if (pos > last) return pos - last;
      return 0;
    }

    function applyWanted(list, releaseAll) {
      /* Slider mode, section not near yet: nothing is wanted. Static
         mode is gated by its own visibility observer instead. */
      if (!near && builtFor > 0) list = [];
      wanted = list;
      var i, v;
      for (i = 0; i < list.length; i++) {
        v = list[i];
        wireMedia(v, isWanted);
        attach(v);
        play(v);
      }

      /* Nothing outside the wanted set decodes. */
      var idle = [];
      for (i = 0; i < tiles.length; i++) {
        v = mediaOf(tiles[i]);
        if (!v || list.indexOf(v) >= 0) continue;
        pauseQuietly(v);
        if (v._crafOn) idle.push({ v: v, d: distanceFromView(i) });
      }

      if (releaseAll || builtFor < 1) {
        for (i = 0; i < idle.length; i++) release(idle[i].v);
      } else {
        /* Furthest first, only as far as the cap requires. */
        idle.sort(function (a, b) { return b.d - a.d; });
        var over = list.length + idle.length - poolCap();
        for (i = 0; i < idle.length && i < over; i++) release(idle[i].v);
      }

      if (list.length) startTimer();
    }

    /* ---------- slider ---------- */

    function stepPx() {
      var t = tiles[0];
      if (!t) return 0;
      var cs = window.getComputedStyle(t);
      return t.offsetWidth + (parseFloat(cs.marginRight) || 0);
    }

    function buildClones(pv) {
      /* Rebuilding restarts every video in the track, so it happens
         only when perView actually changes -- see the resize handler. */
      var before = [], after = [], i, c;
      for (i = 0; i < pv; i++) {
        c = origTiles[total - pv + i];
        if (c) before.push(cloneTile(c));
      }
      for (i = 0; i < pv; i++) {
        c = origTiles[i];
        if (c) after.push(cloneTile(c));
      }
      track.innerHTML = '';
      for (i = 0; i < before.length; i++) track.appendChild(before[i]);
      for (i = 0; i < origTiles.length; i++) track.appendChild(origTiles[i]);
      for (i = 0; i < after.length; i++) track.appendChild(after[i]);
      tiles = [].slice.call(track.querySelectorAll('[data-craf-tile]'));
      builtFor = pv;
    }

    function cloneTile(t) {
      var c = t.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      /* A clone must never look like a real block to the theme editor. */
      c.removeAttribute('data-shopify-editor-block');
      c.setAttribute('data-craf-clone', '');
      /* And it must never carry a live source: cloneNode copies `src`,
         `autoplay`, `muted` and `loop`, which is how the track ended up
         asking a phone for a dozen decoders at once. */
      var v = mediaOf(c);
      if (v) {
        v.removeAttribute('src');
        v._crafOn = false;
        v._crafWired = false;
        v.setAttribute('preload', 'none');
      }
      return c;
    }

    function buildStatic() {
      track.innerHTML = '';
      for (var i = 0; i < origTiles.length; i++) track.appendChild(origTiles[i]);
      tiles = origTiles.slice();
      track.style.transform = '';
      builtFor = -1;
    }

    function setPos(animated) {
      var pv = builtFor;
      if (pv < 1) return;
      if (!animated) track.style.transition = 'none';
      if (isMobile()) {
        track.style.transform = 'translateX(-' + ((pv + cur) * stepPx()) + 'px)';
      } else {
        track.style.transform = 'translateX(-' + ((pv + cur) * (100 / pv)) + '%)';
      }
      if (!animated) {
        /* Force the reflow so the next frame animates from here. */
        void track.offsetHeight;
        track.style.transition = '';
      }
    }

    /* Visible tiles plus one either side, and -- one step before a wrap
       -- the tiles the silent jump will land on, so they are already
       decoding when it happens. */
    function sliderWanted() {
      var pv = builtFor;
      var picked = [];
      var seen = {};
      function take(p) {
        if (p < 0 || p >= tiles.length || seen[p]) return;
        seen[p] = true;
        var v = mediaOf(tiles[p]);
        if (v) picked.push(v);
      }
      var p;
      for (p = pv + cur - 1; p <= pv + cur + pv; p++) take(p);
      /* Only while a slide toward a wrap is actually in flight. At rest
         this would double the decoder count at both ends of the strip
         for no benefit -- advance() re-runs this the moment cur moves,
         which gives the destination the whole transition to buffer, and
         it is the same file as the clone already on screen so it comes
         from cache. */
      if (sliding) {
        if (cur >= total - 1) { for (p = pv; p < pv + pv; p++) take(p); }
        if (cur <= 0) { for (p = pv + total - pv; p < pv + total; p++) take(p); }
      }
      return picked;
    }

    /* Copy playback position from the tiles being left behind onto the
       ones being jumped to, so the wrap does not show. */
    function handoff(fromOffset, toOffset) {
      var pv = builtFor;
      for (var k = 0; k < pv; k++) {
        var a = tiles[fromOffset + k], b = tiles[toOffset + k];
        if (!a || !b) continue;
        var va = mediaOf(a), vb = mediaOf(b);
        if (!va || !vb) continue;
        wireMedia(vb, isWanted);
        attach(vb);
        try {
          if (va._crafOn && isFinite(va.currentTime)) { vb.currentTime = va.currentTime; }
        } catch (e) {}
        play(vb);
      }
    }

    function onEnd(e) {
      if (e && e.target !== track) return;
      finishSlide();
    }

    function finishSlide() {
      if (endTimer) { clearTimeout(endTimer); endTimer = null; }
      track.removeEventListener('transitionend', onEnd);
      sliding = false;

      if (cur >= total || cur < 0) {
        var pv = builtFor;
        var fromOffset = pv + cur;
        var wrapped = ((cur % total) + total) % total;
        var toOffset = pv + wrapped;
        handoff(fromOffset, toOffset);
        cur = wrapped;
        setPos(false);
      }
      applyWanted(sliderWanted());
    }

    function advance(dir) {
      if (!canSlide || builtFor < 1) return;
      /* One slide at a time. The old code added a transitionend
         listener per click, so two quick clicks left two handlers each
         applying its own one-step wrap correction. */
      if (sliding) return;
      if (total <= builtFor) return;

      sliding = true;
      cur += dir;
      applyWanted(sliderWanted());   /* warm the destination first */
      setPos(true);

      track.addEventListener('transitionend', onEnd);
      /* If transitionend never arrives -- an unchanged transform, or a
         reduced-motion setting that zeroes the duration -- the slider
         would stay parked on a clone for good. */
      endTimer = setTimeout(finishSlide, SLIDE_MS + 120);
    }

    function updateArrows() {
      var hide = !canSlide || total <= perView();
      if (prev) prev.style.display = hide ? 'none' : '';
      if (next) next.style.display = hide ? 'none' : '';
    }

    /* ---------- static mode uses an observer, which works there ---- */

    function teardownIO() {
      if (io) { io.disconnect(); io = null; }
    }

    function setupIO() {
      teardownIO();
      if (!('IntersectionObserver' in window)) {
        applyWanted(allMedia(), true);   /* never leave a tile blank */
        return;
      }
      var live = [];
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var v = mediaOf(entries[i].target);
          if (!v) continue;
          var at = live.indexOf(v);
          if (entries[i].isIntersecting) { if (at < 0) live.push(v); }
          else if (at >= 0) { live.splice(at, 1); }
        }
        applyWanted(live.slice(), true);
      }, { threshold: 0.01 });
      for (var i = 0; i < tiles.length; i++) io.observe(tiles[i]);
    }

    /* ---------- layout ---------- */

    function layout(force) {
      var pv = perView();
      var slide = canSlide && total > pv;

      if (!slide) {
        if (force || builtFor !== -1 || track.className.indexOf('craf-track--static') < 0) {
          buildStatic();
          if (track.className.indexOf('craf-track--static') < 0) {
            track.className += ' craf-track--static';
          }
          setupIO();
          applyWanted([], true);
          /* the observer will fill this in on its first callback */
        }
        updateArrows();
        return;
      }

      track.className = track.className.replace(/\s*craf-track--static/g, '');
      teardownIO();

      if (force || builtFor !== pv) {
        buildClones(pv);
        if (cur > total - 1) cur = total - 1;
        if (cur < 0) cur = 0;
        setPos(false);
      } else {
        /* perView unchanged -- do NOT rebuild. Rebuilding restarts
           every video in the track, and on mobile the address bar
           hiding during a scroll fires resize. */
        setPos(false);
      }
      applyWanted(sliderWanted());
      updateArrows();
    }

    /* ---------- input ---------- */

    if (prev) prev.addEventListener('click', function () { advance(-1); });
    if (next) next.addEventListener('click', function () { advance(1); });

    var touchX = 0, touchY = 0, touching = false;
    track.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      touching = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      var dx = touchX - e.changedTouches[0].clientX;
      var dy = touchY - e.changedTouches[0].clientY;
      /* Only treat it as a swipe if it was mostly horizontal, so a
         vertical page scroll does not advance the slider. */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        advance(dx > 0 ? 1 : -1);
      }
    }, { passive: true });

    var resizeTimer = null;
    var lastW = window.innerWidth;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = window.innerWidth;
        /* Mobile browsers fire resize when the address bar hides during
           a scroll. Width is what the layout depends on, so ignore the
           rest outright. */
        if (w === lastW) return;
        lastW = w;
        layout(false);
      }, 150);
    }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });

    layout(true);

    /* Wait for the section to come near, then run the slider's wanted
       set exactly as it would have run at load. */
    if (!near) {
      var nearIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          nearIO.disconnect();
          near = true;
          root._crafNear = true;
          if (builtFor > 0) applyWanted(sliderWanted());
          return;
        }
      }, { rootMargin: NEAR_MARGIN });
      nearIO.observe(root);
    }

    root._crafApi = {
      state: function () {
        var all = allMedia();
        var clones = [].slice.call(track.querySelectorAll('[data-craf-clone] [data-craf-media]'));
        return {
          tiles: tiles.length,
          blocks: total,
          perView: perView(),
          builtFor: builtFor,
          cur: cur,
          mode: builtFor > 0 ? 'slider' : 'static',
          near: near,
          attached: all.filter(function (v) { return v._crafOn; }).length,
          playing: all.filter(function (v) { return !v.paused; }).length,
          wanted: wanted.length,
          /* Attached but paused: keeps its last frame painted so
             stepping back to it shows a picture, not #111111. */
          retained: all.filter(function (v) { return v._crafOn && v.paused; }).length,
          poolCap: poolCap(),
          /* Every element actually holding a media resource. Should
             always equal `attached`: a source only ever arrives via
             attach(), never from cloneNode. */
          srcCount: all.filter(function (v) { return v.hasAttribute('src'); }).length,
          clonesWithSrc: clones.filter(function (v) { return v.hasAttribute('src'); }).length,
          /* A clone the slider does NOT want must hold nothing. This is
             the number that used to be "all of them". */
          freshCloneWithSrc: clones.filter(function (v) {
            return v.hasAttribute('src') && wanted.indexOf(v) < 0;
          }).length
        };
      },
      advance: advance,
      layout: layout
    };
  }

  function scan(scope) {
    var roots = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-craf-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    return roots.length;
  }

  /* A tab coming back to the foreground: iOS leaves every video paused. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var roots = document.querySelectorAll('[data-craf-root]');
    for (var i = 0; i < roots.length; i++) {
      var vs = roots[i].querySelectorAll('[data-craf-media]');
      for (var j = 0; j < vs.length; j++) { if (vs[j]._crafOn) play(vs[j]); }
    }
  });

  /* Low Power Mode and strict autoplay policies refuse play() until a
     real user gesture has happened. Retry inside the first one. */
  function unlock() {
    var vs = document.querySelectorAll('[data-craf-media]');
    for (var i = 0; i < vs.length; i++) { if (vs[i]._crafOn) play(vs[i]); }
  }
  ['touchstart', 'pointerdown', 'click', 'keydown'].forEach(function (t) {
    document.addEventListener(t, unlock, { once: true, capture: true, passive: true });
  });

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  window.TallmadeCraftsmanship = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
